export default {
  company: {
    zh_cn: '公司',
    zhhant: '公司',
    en: 'Company',
    he: 'חברה',
    de: 'Firma',
    es: 'Empresa',
    ru: 'Компания',
    vi: 'Công ty',
  },
  companyAddress: {
    zh_cn: '公司地址',
    zhhant: '公司地址',
    en: 'Company Address',
    he: 'כתובת החברה',
    de: 'Firmenadresse',
    es: 'Dirección de la empresa',
    ru: 'Адрес компании',
    vi: 'Địa chỉ công ty',
  },
  operator: {
    zh_cn: '运营商',
    zhhant: '运营商',
    en: 'Operator',
    he: 'מפעיל',
    de: 'Betreiber',
    es: 'Operador',
    ru: 'Оператор',
    vi: 'Nhà điều hành',
  },
  station: {
    zh_cn: '站点',
    zhhant: '站點',
    en: 'Station',
    he: 'מחסני',
    de: 'Station',
    es: 'Estación',
    ru: 'Оператор',
    vi: 'Trạm',
  },
  profitSharingPayees: {
    zh_cn: '分润收款方',
    zhhant: '分潤收款方',
    en: 'Profit Sharing Payee',
    he: 'מקבלת פרסום',
    de: 'Profitsharing-Empfänger',
    es: 'Destinatario de la comisión',
    ru: 'Получательroyalties',
    vi: 'Người nhậndoanh thu',
  },
  platenumber: {
    zh_cn: '车牌号',
    zhhant: '車牌號',
    en: 'Plate Number',
    he: 'מספר טאג',
    de: 'Kennzeichen',
    es: 'Matrícula',
    ru: 'Номер номерного знака',
    vi: 'Số biển số xe',
  },
  authOpartor: {
    zh_cn: '授权运营商',
    zhhant: '授權運營商',
    en: 'Authorized Operator',
    he: 'מפעיל מורשה',
    de: 'Autorisierter Betreiber',
    es: 'Operador autorizado',
    ru: 'Авторизованный оператор',
    vi: 'Nhà điều hành được ủy quyền',
  },
  selectCityCode: {
    zh_cn: '选择城市编码',
    zhhant: '選擇城市編碼',
    en: 'Select City Code',
    he: 'בחר קוד עיר',
    de: 'Stadtcode auswählen',
    es: 'Seleccionar código de ciudad',
    ru: 'Выберите код города',
    vi: 'Chọn mã thành phố',
  },

  stationAddress: {
    zh_cn: '站点地址信息',
    zhhant: '站點地址資訊',
    en: 'Station Address Info',
    he: 'מידע על כתובת תחנה',
    de: 'Station Adresse Info',
    es: 'Información de la dirección de estación',
    ru: 'Информация об адресе станции',
    vi: 'Thông tin địa chỉ trạm',
  },
  selectMapAddress: {
    zh_cn: '打开地图选择地址',
    zhhant: '打開地圖選擇地址',
    en: 'Open Map to Select Address',
    he: 'פתח מפה לבחירת כתובת',
    de: 'Karte öffnen, um Adresse auszuwählen',
    es: 'Abrir mapa para seleccionar dirección',
    ru: 'Открыть карту для выбора адреса',
    vi: 'Mở bản đồ để chọn địa chỉ',
  },
  stationEvseInfo: {
    zh_cn: '站点设备信息',
    zhhant: '站點設備資訊',
    en: 'Station EVSE Info',
    he: 'מידע על מכשיר תחנה',
    de: 'Station EVSE Info',
    es: 'Información de la estación EVSE',
    ru: 'Информация о станции EVSE',
    vi: 'Thông tin thiết bị trạm EVSE',
  },
  stationAC: {
    zh_cn: '交流充电站',
    zhhant: '交流充電站',
    en: 'AC charging station',
    he: 'אחוזי שעון',
    de: 'AC-Ladestation',
    es: 'Estación de carga AC',
    ru: 'АК-зарядная станция',
    vi: 'Trạm đèn LED AC',
  },
  stationDC: {
    zh_cn: '直流充电站',
    zhhant: '直流充電站',
    en: 'DC charging station',
    he: 'אחוזי שעון',
    de: 'DC-Ladestation',
    es: 'Estación de carga DC',
    ru: 'ДЦ-зарядная станция',
    vi: 'Trạm đèn LED DC',
  },
  stationDCAC: {
    zh_cn: '交/直流充电站',
    zhhant: '交/直流充電站',
    en: 'AC/DC charging station',
    he: 'אחוזי שעון',
    de: 'AC/DC-Ladestation',
    es: 'Estación de carga AC/DC',
    ru: 'АК/ДЦ-зарядная станция',
    vi: 'Trạm đèn LED AC/DC',
  },
  user: {
    zh_cn: '用户',
    zhhant: '用戶',
    en: 'Driver',
    he: 'נהג',
    de: 'Fahrer',
    es: 'Conductor',
    ru: 'Водитель',
    vi: 'Người lái xe',
  },
  group: {
    zh_cn: '群组',
    zhhant: '群組',
    en: 'Group',
    he: 'קבוצה',
    de: 'Gruppe',
    es: 'Grupo',
    ru: 'Группа',
    vi: 'Nhóm',
  },
  evse: {
    zh_cn: '设备',
    zhhant: '設備',
    en: 'Equipment',
    he: 'מכשיר',
    de: 'Gerät',
    es: 'Dispositivo',
    ru: 'Устройство',
    vi: 'Thiết bị',
  },
  brand: {
    zh_cn: '品牌终端',
    zhhant: '品牌終端',
    en: 'Brand',
    he: 'מותג',
    de: 'Marke',
    es: 'Marca',
    ru: 'Бренд',
    vi: 'Thương hiệu',
  },
  ownevse: {
    zh_cn: '用户设备',
    zhhant: '用戶設備',
    en: 'Own EVSE',
    he: 'מכשיר EVSE פרטי',
    de: 'Eigene EVSE',
    es: 'Dispositivo EVSE propio',
    ru: 'Собственное EVSE',
    vi: 'Thiết bị EVSE của người dùng',
  },
  reportInfo: {
    zh_cn: '账单信息',
    zhhant: '賬單信息',
    en: 'Report Info',
    he: 'דוח מידע',
    de: 'Berichtsinformationen',
    es: 'Información de informe',
    ru: 'Сведения о отчете',
    vi: 'Thông tin báo cáo',
  },
  lat: {
    zh_cn: '纬度',
    zhhant: '緯度',
    en: 'Longitude',
    he: 'אורך',
    de: 'Längengrad',
    es: 'Longitud',
    ru: 'Долгота',
    vi: 'Kinh độ',
  },
  lng: {
    zh_cn: '经度',
    zhhant: '經度',
    en: 'Latitude',
    he: 'רוחב',
    de: 'Breitengrad',
    es: 'Latitud',
    ru: 'Широта',
    vi: 'Vĩ độ',
  },
  selectLocation: {
    zh_cn: '在地图中选择位置',
    zhhant: '在地圖中選擇位置',
    en: 'Select a location on the map',
    he: 'בחר מיקום במפה',
    de: 'Standort auf der Karte auswählen',
    es: 'Seleccionar una ubicación en el mapa',
    ru: 'Выберите местоположение на карте',
    vi: 'Chọn một vị trí trên bản đồ',
  },
  selectOperator: {
    zh_cn: '选择运营商',
    zhhant: '選擇運營商',
    en: 'Select Operator',
    he: 'בחר מפעיל',
    de: 'Betreiber auswählen',
    es: 'Seleccionar operador',
    ru: 'Выберите оператора',
    vi: 'Chọn nhà điều hành',
  },
  selectStation: {
    zh_cn: '选择站点',
    zhhant: '選擇站點',
    en: 'Select Station',
    he: 'בחר תחנה',
    de: 'Station auswählen',
    es: 'Seleccionar estación',
    ru: 'Выберите станцию',
    vi: 'Chọn trạm',
  },
  selectUser: {
    zh_cn: '选择用户',
    zhhant: '選擇用戶',
    en: 'Select Driver',
    he: 'בחר נהג',
    de: 'Fahrer auswählen',
    es: 'Seleccionar conductor',
    ru: 'Выберите водителя',
    vi: 'Chọn người lái xe',
  },
  address: {
    zh_cn: '详细地址',
    zhhant: '詳細地址',
    en: 'Address',
    he: 'כתובת',
    de: 'Adresse',
    es: 'Dirección',
    ru: 'Адрес',
    vi: 'Địa chỉ',
  },
  contactmt: {
    zh_cn: '联系方式',
    zhhant: '聯絡方式',
    en: 'Contact way',
    he: 'צור קשר',
    de: 'Kontakt',
    es: 'Contacto',
    ru: 'Контакт',
  },
  contacts: {
    zh_cn: '联系人',
    zhhant: '聯絡人',
    en: 'Contacts',
    he: 'איש קשר',
    de: 'Kontakte',
    es: 'Contactos',
    ru: 'Контакты',
    vi: 'Liên hệ',
  },
  phone: {
    zh_cn: '电话',
    zhhant: '電話',
    en: 'Phone',
    he: 'טלפון',
    de: 'Telefon',
    es: 'Teléfono',
    ru: 'Телефон',
    vi: 'Số điện thoại',
  },
  selectAppChannel: {
    zh_cn: '选择应用渠道',
    zhhant: '選擇應用渠道',
    en: 'Select app channel',
    he: 'בחר אצלו',
    de: 'App-Kanal auswählen',
    es: 'Seleccione el canal de la aplicación',
    ru: 'Выберите канал приложения',
    vi: 'Chọn kênh ứng dụng',
  },
  selectPayment: {
    zh_cn: '选择支付渠道',
    zhhant: '選擇支付渠道',
    en: 'Select payment method',
    he: 'בחר אצלו',
    de: 'Zahlungsmethode auswählen',
    es: 'Seleccione el método de pago',
    ru: 'Выберите способ оплаты',
    vi: 'Chọn cách thanh toán',
  },
  selectNoti: {
    zh_cn: '选择通知方式',
    zhhant: '選擇通知方式',
    en: 'Select notification method',
    he: 'בחר אצלו',
    de: 'Benachrichtigungsmethode auswählen',
    es: 'Seleccione el método de notificación',
    ru: 'Выберите способ уведомления',
    vi: 'Chọn cách thông báo',
  },
  email: {
    zh_cn: '邮箱',
    zhhant: '郵件',
    en: 'Email',
    he: 'אימייל',
    de: 'E-Mail',
    es: 'Correo electrónico',
    ru: 'Электронная почта',
    vi: 'Email',
  },
  feishu: {
    zh_cn: '飞书',
    zhhant: '飛書',
    en: 'lark',
    he: '飞书',
    de: 'lark',
    es: 'lark',
    ru: 'lark',
    vi: 'lark',
  },
  sms: {
    zh_cn: '短信',
    zhhant: '簡訊',
    en: 'SMS',
    he: 'הודעת SMS',
    de: 'SMS',
    es: 'Mensaje de texto',
    ru: 'СМС',
    vi: 'Sms',
  },
  smsAccessKeyDesc: {
    zh_cn: 'SMS AccessKey相关信息需要去第三方SMS服务提供商管理后台创建。',
    zhhant: 'SMS AccessKey相關信息需要去第三方SMS服務提供商管理後台創建。',
    en: "SMS AccessKey information needs to be created in the third-party SMS service provider's management background.",
    he: 'מידע על SMS AccessKey חייב להיות יוצר בגרסת מנהל שירות הSMS של שירות ספק.',
    de: 'SMS AccessKey-Informationen müssen in der Verwaltungoberfläche des Drittanbieters für SMS-Dienste erstellt werden.',
    es: 'La información de la clave de acceso SMS necesita ser creada en el panel de administración del proveedor de servicios de SMS terceros.',
    ru: 'Информация о ключе доступа SMS требуется создать в панели управления сервис-провайдером SMS.',
    vi: 'Thông tin về SMS AccessKey cần được tạo trong bảng điều khiển của nhà cung cấp dịch vụ SMS.',
  },
  smsAccessKeyId: {
    zh_cn: '短信AccessKeyId',
    zhhant: '簡訊AccessKeyId',
    en: 'SMS AccessKeyId',
    he: 'מפתח גישה SMS',
    de: 'SMS AccessKeyId',
    es: 'Clave de acceso SMS',
    ru: 'Ключ доступа к СМС',
    vi: 'SMS AccessKeyId',
  },
  smsAccessKeySecret: {
    zh_cn: '短信AccessKeySecret',
    zhhant: '簡訊AccessKeySecret',
    en: 'SMS AccessKeySecret',
    he: 'סוד הגישה SMS',
    de: 'SMS AccessKeySecret',
    es: 'Clave secreta de acceso SMS',
    ru: 'Секретный ключ доступа к СМС',
    vi: 'SMS AccessKeySecret',
  },
  smsEndpointHost: {
    zh_cn: '短信服务地址',
    zhhant: '簡訊服務地址',
    en: 'SMS Endpoint Host',
    he: 'מארח SMS Endpoint',
    de: 'SMS Endpunkt-Host',
    es: 'Host de punto final SMS',
    vi: 'SMS Endpoint Host',
    ru: 'SMS Endpoint Host',
  },
  emailSendHost: {
    zh_cn: 'SMTP 地址',
    zhhant: 'SMTP 地址',
    en: 'SMTP Address',
    he: 'כתובת SMTP',
    de: 'SMTP Adresse',
    es: 'Dirección SMTP',
    vi: 'SMTP Address',
    ru: 'SMTP Address',
  },
  stationEXInfo: {
    zh_cn: '互联互通',
    zhhant: '互联互通',
    en: 'Interconnection',
    he: 'תחברות מערכת',
    de: 'Interkonektivität',
    es: 'Interconexión',
    vi: 'Tích hợp hệ thống',
    ru: 'Совместное использование',
  },
  streetCode: {
    zh_cn: '乡镇街道编码',
    zhhant: '乡镇街道编码',
    en: 'Street Code',
    he: 'קוד רחוב',
    de: 'Straßenkennzeichen',
    es: 'Código de la calle',
    vi: 'Mã đường phố',
    ru: 'Код улицы',
  },
  org: {
    zh_cn: '设备所属组织机构',
    zhhant: '設備所屬組織',
    en: 'Organization',
    he: 'ארגון',
    de: 'Organisation',
    es: 'Organización',
    ru: 'Организация',
    vi: 'Công ty',
  },
  meterAccount: {
    zh_cn: '电表号',
    zhhant: '電錶號',
    en: 'Meter Number',
    he: 'מספר מטרה',
    de: 'Meternummer',
    es: 'Número de medidor',
    ru: 'Номер счетчика',
    vi: 'Số điện tử',
  },
  elecAccount: {
    zh_cn: '电费户号',
    zhhant: '電費戶號',
    en: 'Electricity Account Number',
    he: 'מספר חשבון ציבורי',
    de: 'Elektroverbrauchsrechnungsnummer',
    es: 'Número de cuenta de electricidad',
    ru: 'Номер счетчика электричества',
    vi: 'Số điện tử',
  },
  buildTime: {
    zh_cn: '建设时间',
    zhhant: '建設時間',
    en: 'Build Time',
    he: 'זמן בניית',
    de: 'Baumassnahme',
    es: 'Tiempo de construcción',
    ru: 'Время строительства',
    vi: 'Thời gian xây dựng',
  },
  smtpDesc: {
    zh_cn: 'SMTP信息，可以再第三方邮件服务器管理后台登录，然后在收发设置中查看SMTP信息',
    zhhant: 'SMTP信息，可以再第三方郵件服務器管理後台登錄，然後在收發設置中查看SMTP信息',
    en: 'SMTP Information, you can log in to the third-party email server management background and view SMTP information in the send and receive settings',
    he: 'מידע על SMTP חייב להיות יוצר בגרסת מנהל שירות הדואר אלקטרוני של שירות ספק.',
    de: 'SMTP-Informationen müssen in der Verwaltungoberfläche des Drittanbieters für E-Mail-Dienste erstellt werden.',
    es: 'La información de SMTP necesita ser creada en el panel de administración del proveedor de servicios de correo electrónico terceros.',
    ru: 'Информация о SMTP требуется создать в панели управления сервис-провайдером почты.',
    vi: 'Thông tin SMTP cần được tạo trong bảng điều khiển của nhà cung cấp dịch vụ email.',
  },
  emailSendPort: {
    zh_cn: 'SMTP 端口',
    zhhant: 'SMTP 端口',
    en: 'SMTP Port',
    he: 'פורט SMTP',
    de: 'SMTP-Port',
    es: 'Puerto SMTP',
    vi: 'SMTP Port',
    ru: 'SMTP Port',
  },
  emailUserName: {
    zh_cn: 'SMTP 用户名',
    zhhant: 'SMTP 用户名',
    en: 'SMTP Username',
    he: 'שם משתמש SMTP',
    de: 'SMTP Benutzername',
    es: 'Nombre de usuario SMTP',
    vi: 'SMTP Username',
    ru: 'SMTP Username',
  },
  emailPassword: {
    zh_cn: 'SMTP 密码',
    zhhant: 'SMTP 密碼',
    en: 'SMTP Password',
    he: 'סיסמה SMTP',
    de: 'SMTP-Kennwort',
    es: 'Contraseña SMTP',
    vi: 'SMTP Password',
    ru: 'SMTP Password',
  },
  emailDefSenderMail: {
    zh_cn: '发件人邮箱',
    zhhant: '發件人郵箱',
    en: 'sender email',
    he: 'מייל שולח',
    de: 'Absender E-Mail',
    es: 'Correo electrónico del remitente',
    vi: 'Email người gửi mặc định',
    ru: 'Email отправителя',
  },
  country: {
    zh_cn: '国家',
    zhhant: '國家',
    en: 'Country',
    he: 'מדינה',
    de: 'Land',
    es: 'País',
    ru: 'Страна',
    vi: 'Quốc gia',
  },
  minChargingAmount: {
    zh_cn: '最小充电金额（必须大于1元)',
    zhhant: '最小加載金額（必須大於1元）',
    en: 'Minimum charging amount (must be greater than 1 yuan)',
    he: 'עלות מינימלית של העלאה (חובה להיות גדול מ-1 ש"ח)',
    de: 'Mindestbetrag der Aufladung (muss größer als 1 Euro sein)',
    es: 'Monto mínimo de carga (debe ser mayor que 1 euro)',
    ru: 'Минимальная сумма для зарядки (должна быть больше 1 евро)',
    vi: 'Số tiền tối thiểu cho nạp tiền (phải lớn hơn 1 đồng)',
  },
  stationType: {
    zh_cn: '站点类型',
    zhhant: '站點類型',
    en: 'Station Type',
    he: 'סוג תחנה',
    de: 'Stationstyp',
    es: 'Tipo de estación',
    ru: 'Тип станции',
    vi: 'Loại trạm',
  },
  stationTypePublic: {
    zh_cn: '公共站点',
    zhhant: '公共站點',
    en: 'Public Station',
    he: 'תחנה ציבורית',
    de: 'Öffentliche Station',
    es: 'Estación Pública',
    ru: 'Публичная станция',
    vi: 'Trạm công cộng',
  },
  stationTypePrivate: {
    zh_cn: '私人站点',
    zhhant: '私人站點',
    en: 'Private Station',
    he: 'תחנה פרטית',
    de: 'Private Station',
    es: 'Estación Privada',
    ru: 'Частная станция',
    vi: 'Trạm cá nhân',
  },
  stationTypeBusOnly: {
    zh_cn: '公交专用站点',
    zhhant: '公交專用站點',
    en: 'Bus Exclusive Station',
    he: 'תחנה בלעדית לאוטובוסים',
    de: 'Exklusive Busstation',
    es: 'Estación Exclusiva para Autobuses',
    ru: 'Станция только для автобусов',
    vi: 'Trạm chuyên dụng xe buýt',
  },
  stationTypeSanitationOnly: {
    zh_cn: '环卫专用站点',
    zhhant: '環衛專用站點',
    en: 'Sanitation Exclusive Station',
    he: 'תחנה בלעדית לניקיון',
    de: 'Exklusive Reinigungsstation',
    es: 'Estación Exclusiva para Saneamiento',
    ru: 'Станция только для санитарии',
    vi: 'Trạm chuyên dụng vệ sinh',
  },
  stationTypeLogisticsOnly: {
    zh_cn: '物流专用站点',
    zhhant: '物流專用站點',
    en: 'Logistics Exclusive Station',
    he: 'תחנה בלעדית לוגיסטיקה',
    de: 'Exklusive Logistikstation',
    es: 'Estación Exclusiva para Logística',
    ru: 'Станция только для логистики',
    vi: 'Trạm chuyên dụng logistics',
  },
  stationTypeTaxiOnly: {
    zh_cn: '出租车专用站点',
    zhhant: '出租車專用站點',
    en: 'Taxi Exclusive Station',
    he: 'תחנה בלעדית למוניות',
    de: 'Exklusive Taxistation',
    es: 'Estación Exclusiva para Taxis',
    ru: 'Станция только для такси',
    vi: 'Trạm chuyên dụng taxi',
  },
  stationTypeDumpTruckOnly: {
    zh_cn: '电动自卸车专用站点',
    zhhant: '電動自卸車專用站點',
    en: 'Dump Truck Exclusive Station',
    he: 'תחנה בלעדית למשאיות',
    de: 'Exklusive Kipperstation',
    es: 'Estación Exclusiva para Camiones Volquete',
    ru: 'Станция только для самосвалов',
    vi: 'Trạm chuyên dụng xe tự đổ',
  },
  stationTypeOther: {
    zh_cn: '其他类型站点',
    zhhant: '其他類型站點',
    en: 'Other Station Type',
    he: 'סוג תחנה אחר',
    de: 'Andere Stationstypen',
    es: 'Otro Tipo de Estación',
    ru: 'Другой тип станции',
    vi: 'Loại trạm khác',
  },
  stationConstruction: {
    zh_cn: '站点建设类型',
    zhhant: '站點建設類型',
    en: 'Station Construction Type',
    he: 'סוג בניית תחנה',
    de: 'Station Bauart',
    es: 'Tipo de construcción de estación',
    ru: 'Тип строительства станции',
    vi: 'Loại xây dựng trạm',
  },
  stationState: {
    zh_cn: '站点状态',
    zhhant: '站點狀態',
    en: 'Station State',
    he: 'סטטוס תחנה',
    de: 'Station Status',
    es: 'Estado de estación',
    ru: 'Состояние станции',
    vi: 'Trạng thái trạm',
  },
  stationStateInConstruction: {
    zh_cn: '建设中',
    zhhant: 'בניית',
    en: 'In Construction',
    he: 'בניית',
    de: 'In Bau',
    es: 'En construcción',
    ru: 'В процессе строительства',
    vi: 'Đang xây dựng',
  },
  stationStateClose: {
    zh_cn: '关闭下线',
    zhhant: 'סגור',
    en: 'Close',
    he: 'סגור',
    de: 'Schließen',
    es: 'Cerrar',
    ru: 'Закрыто',
    vi: 'Đóng',
  },
  stationStateMaintained: {
    zh_cn: '维护中',
    zhhant: 'בתחזוקה',
    en: 'Under Maintenance',
    he: 'בתחזוקה',
    de: 'In Wartung',
    es: 'En mantenimiento',
    ru: 'В процессе обслуживания',
    vi: 'Đang bảo trì',
  },
  stationStateOperation: {
    zh_cn: '正常使用',
    zhhant: 'בתהליך',
    en: 'In Operation',
    he: 'בתהליך',
    de: 'In Betrieb',
    es: 'En operación',
    ru: 'В процессе эксплуатации',
    vi: 'Đang hoạt động',
  },
  stationConstructionHousingEstate: {
    zh_cn: '住宅区',
    zhhant: '住宅區',
    en: 'Housing Estate',
    he: 'אזור מגורים',
    de: 'Wohngebiet',
    es: 'Urbanización',
    ru: 'Жилой комплекс',
    vi: 'Khu dân cư',
  },
  stationConstructionPublicInstitution: {
    zh_cn: '公共区域',
    zhhant: '公共區域',
    en: 'Public Institution',
    he: 'מוסד ציבורי',
    de: 'Öffentliche Einrichtung',
    es: 'Institución pública',
    ru: 'Государственное учреждение',
    vi: 'Khu vực công cộng',
  },
  stationConstructionEnterprises: {
    zh_cn: '企事业单位',
    zhhant: '企事業單位',
    en: 'Enterprises',
    he: 'מפעלים',
    de: 'Unternehmen',
    es: 'Empresas',
    ru: 'Предприятия',
    vi: 'Doanh nghiệp',
  },
  stationConstructionOfficeBuilding: {
    zh_cn: '写字楼',
    zhhant: '寫字樓',
    en: 'Office Building',
    he: 'בניין משרדים',
    de: 'Bürogebäude',
    es: 'Edificio de oficinas',
    ru: 'Офисное здание',
    vi: 'Tòa nhà văn phòng',
  },
  stationConstructionIndustrialZone: {
    zh_cn: '工业园区',
    zhhant: '工業園區',
    en: 'Industrial Zone',
    he: 'אזור תעשייה',
    de: 'Industriegebiet',
    es: 'Zona industrial',
    ru: 'Промышленная зона',
    vi: 'Khu công nghiệp',
  },
  stationConstructionTransportationHub: {
    zh_cn: '交通枢纽',
    zhhant: '交通樞紐',
    en: 'Transportation Hub',
    he: 'מרכז תחבורה',
    de: 'Verkehrsknotenpunkt',
    es: 'Centro de transporte',
    ru: 'Транспортный узел',
    vi: 'Trung tâm giao thông',
  },
  stationConstructionRSFacilities: {
    zh_cn: '大型文体设施',
    zhhant: '大型文體設施',
    en: 'Large Sports Facilities',
    he: 'מתקני ספורט גדולים',
    de: 'Große Sportanlagen',
    es: 'Instalaciones deportivas grandes',
    ru: 'Крупные спортивные объекты',
    vi: 'Cơ sở thể thao lớn',
  },
  stationConstructionUGSpace: {
    zh_cn: '城市绿地',
    zhhant: '城市綠地',
    en: 'Urban Green Space',
    he: 'שטח ירוק עירוני',
    de: 'Städtische Grünfläche',
    es: 'Espacio verde urbano',
    ru: 'Городская зеленая зона',
    vi: 'Khu đô thị xanh',
  },
  stationConstructionParkingArea: {
    zh_cn: '大型建筑配件停车场',
    zhhant: '大型建築配件停車場',
    en: 'Parking Area',
    he: 'אזור חניה',
    de: 'Parkplatz',
    es: 'Área de estacionamiento',
    ru: 'Парковочная зона',
    vi: 'Bãi đỗ xe lớn',
  },
  stationConstructionRoadsideParking: {
    zh_cn: '路边停车位',
    zhhant: '路邊停車位',
    en: 'Roadside Parking',
    he: 'חניה בצד הדרך',
    de: 'Straßenrandparkplatz',
    es: 'Estacionamiento en la calle',
    ru: 'Парковка на обочине',
    vi: 'Đỗ xe ven đường',
  },
  stationConstructionHSServiceArea: {
    zh_cn: '城际高速服务区',
    zhhant: '城際高速服務區',
    en: 'Highway Service Area',
    he: 'אזור שירות בכביש מהיר',
    de: 'Autobahnraststätte',
    es: 'Área de servicio de autopista',
    ru: 'Зона обслуживания на автомагистрали',
    vi: 'Khu dịch vụ cao tốc',
  },
  stationConstructionScenicArea: {
    zh_cn: '风景区',
    zhhant: '風景區',
    en: 'Scenic Area',
    he: 'אזור נוף',
    de: 'Landschaftsgebiet',
    es: 'Área escénica',
    ru: 'Живописная зона',
    vi: 'Khu danh lam thắng cảnh',
  },
  stationConstructionBusStation: {
    zh_cn: '公交场站',
    zhhant: '公交場站',
    en: 'Bus Station',
    he: 'תחנת אוטובוסים',
    de: 'Busbahnhof',
    es: 'Estación de autobuses',
    ru: 'Автобусная станция',
    vi: 'Bến xe buýt',
  },
  stationConstructionOilGasStation: {
    zh_cn: '加油加气站',
    zhhant: '加油加氣站',
    en: 'Oil & Gas Station',
    he: 'תחנת דלק וגז',
    de: 'Tankstelle',
    es: 'Estación de gasolina y gas',
    ru: 'Заправочная станция',
    vi: 'Trạm xăng dầu',
  },
  stationConstructionTaxi: {
    zh_cn: '出租车',
    zhhant: '出租車',
    en: 'Taxi',
    he: 'מונית',
    de: 'Taxi',
    es: 'Taxi',
    ru: 'Такси',
    vi: 'Taxi',
  },
  stationConstructionOther: {
    zh_cn: '其他',
    zhhant: '其他',
    en: 'Other',
    he: 'אחר',
    de: 'Andere',
    es: 'Otro',
    ru: 'Другое',
    vi: 'Khác',
  },
  currency: {
    zh_cn: '货币',
    zhhant: '貨幣',
    en: 'Currency',
    he: 'מטבע',
    de: 'Währung',
    es: 'Moneda',
    ru: 'Валюта',
    vi: 'Tiền tệ',
  },
  currencyNotChange: {
    zh_cn: '添加后，货币不能修改',
    zhhant: '添加后，貨幣不能修改',
    en: 'After adding, the currency cannot be modified',
    he: 'לאחר הוספה, לא ניתן לשנות את המטבע',
    de: 'Nach dem Hinzufügen kann die Währung nicht geändert werden',
    es: 'Después de agregar, la moneda no se puede modificar',
    ru: 'После добавления, валюта не может быть изменен',
    vi: 'Sau khi thêm, tiền tệ không thể sửa đổi',
  },
  importNotChange: {
    zh_cn: '以下参数字段非技术人员-禁止修改。否则可导致线上程序崩溃',
    zhhant: '以下參數字段非技術人員-禁止修改。否則可導致線上程序崩潰',
    en: 'The following parameter fields are prohibited from being modified by non-technical personnel. Otherwise, it may cause the online program to crash',
    he: 'השדות הבאים של פרמטרים אסורים לשינוי על ידי אנשי מקצוע לא טכניים. אחרת, זה עלול לגרום לקריסת התוכנית המקוונת',
    de: 'Die folgenden Parameterfelder dürfen von nicht-technischem Personal nicht geändert werden. Andernfalls kann das Online-Programm abstürzen',
    es: 'Los siguientes campos de parámetros están prohibidos para ser modificados por personal no técnico. De lo contrario, puede causar que el programa en línea se bloquee',
    ru: 'Следующие поля параметров запрещены для изменения нетехническим персоналом. В противном случае это может привести к сбою онлайн-программы',
    vi: 'Các trường tham số sau đây bị cấm sửa đổi bởi nhân viên không kỹ thuật. Nếu không',
  },
  defKey: {
    zh_cn: '默认密钥',
    zhhant: '默認密鑰',
    en: 'Default Key',
    he: 'מפתח ברירת מחדל',
    de: 'Standard-Schlüssel',
    es: 'Clave predeterminada',
    ru: 'Ключ по умолчанию',
    vi: 'Khóa mặc định',
  },
  aliAppKey: {
    zh_cn: '阿里云密钥',
    zhhant: '阿里雲密鑰',
    en: 'Aliyun Key',
    he: 'מפתח Aliyun',
    de: 'Aliyun Schlüssel',
    es: 'Clave de Aliyun',
    ru: 'Ключ Aliyun',
    vi: 'Khóa Aliyun',
  },
  wxAppKey: {
    zh_cn: '微信小程序密钥',
    zhhant: '微信小程序密钥',
    en: 'WeChat Mini Program Key',
    he: 'מפתח תוכנית מיני WeChat',
    de: 'WeChat Mini Program Schlüssel',
    es: 'Clave del programa mini WeChat',
    ru: 'Ключ мини-программы WeChat',
    vi: 'Khóa chương trình mini WeChat',
  },
  city: {
    zh_cn: '城市',
    zhhant: '城市',
    en: 'City',
    he: 'עיר',
    de: 'Stadt',
    es: 'Ciudad',
    ru: 'Город',
    vi: 'Thành phố',
  },
  cityCode: {
    zh_cn: '城市编码',
    zhhant: '城市編碼',
    en: 'City Code',
    he: 'קוד עיר',
    de: 'Stadtcode',
    es: 'Kod da şehir',
    vi: 'Mã thành phố',
    ru: 'Месяц код',
  },
  covers: {
    zh_cn: '照片',
    zhhant: '照片',
    en: 'Covers',
    he: 'מצגות',
    de: 'Bilder',
    es: 'Portadas',
    ru: 'Обложки',
    vi: 'Hình ảnh',
  },
  countryChina: {
    zh_cn: '中国',
    zhhant: '中國',
    en: 'China',
    he: 'סין',
    de: 'China',
    es: 'China',
    ru: 'Китай',
    vi: 'Trung Quốc',
  },
  countryUs: {
    zh_cn: '美国',
    zhhant: '美國',
    en: 'America',
    he: 'ארצות הברית',
    de: 'Vereinigte Staaten',
    es: 'Estados Unidos',
    ru: 'США',
    vi: 'Mỹ',
  },
  countryUk: {
    zh_cn: '英国',
    zhhant: '英國',
    en: 'England',
    he: 'בריטניה',
    de: 'Vereinigtes Königreich',
    es: 'Reino Unido',
    ru: 'Великобритания',
    vi: 'Vương quốc Anh',
  },
  countrySingapore: {
    zh_cn: '新加坡',
    zhhant: '新加坡',
    en: 'Singapore',
    he: 'סינגפור',
    de: 'Singapur',
    es: 'Singapur',
    ru: 'Сингапур',
    vi: 'Singapore',
  },
  countryNz: {
    zh_cn: '新西兰',
    zhhant: '紐西蘭',
    en: 'New Zealand',
    he: 'ניו זילנד',
    de: 'Neuseeland',
    es: 'Nueva Zelanda',
    ru: 'Новая Зеландия',
    vi: 'New Zealand',
  },
  countryGermany: {
    zh_cn: '德国',
    zhhant: '德國',
    en: 'Germany',
    he: 'גרמניה',
    de: 'Deutschland',
    es: 'Alemania',
    ru: 'Германия',
    vi: 'Đức',
  },
  countryAustralia: {
    zh_cn: '澳大利亚',
    zhhant: '澳大利亞',
    en: 'Australia',
    he: 'אוסטרליה',
    de: 'Australien',
    es: 'Australia',
    ru: 'Австралия',
    vi: 'Úc',
  },
  countryFrance: {
    zh_cn: '法国',
    zhhant: '法國',
    en: 'France',
    he: 'צרפת',
    de: 'Frankreich',
    es: 'Francia',
    ru: 'Франция',
    vi: 'Pháp',
  },
  countryIndia: {
    zh_cn: '印度',
    zhhant: '印度',
    en: 'India',
    he: 'הודו',
    de: 'Indien',
    es: 'India',
    ru: 'Индия',
    vi: 'Ấn Độ',
  },
  countryJapan: {
    zh_cn: '日本',
    zhhant: '日本',
    en: 'Japan',
    he: 'יפן',
    de: 'Japan',
    es: 'Japón',
    ru: 'Япония',
    vi: 'Nhật Bản',
  },
  priceID: {
    zh_cn: '定价策略ID',
    zhhant: '定價策略ID',
    en: 'Pricing ID',
    he: 'מזהה תמחור',
    de: 'Preis-ID',
    es: 'ID de precios',
    ru: 'ID ценовой стратегии',
    vi: 'ID định giá',
  },
  priceVer: {
    zh_cn: '定价策略版本',
    zhhant: '定價策略版本',
    en: 'Pricing Version',
    he: 'גרסת תמחור',
    de: 'Preisversion',
    es: 'Versión de precios',
    ru: 'Версия ценовой стратегии',
    vi: 'Phiên bản định giá',
  },
  priceing: {
    zh_cn: '定价策略',
    zhhant: '定價策略',
    en: 'Pricing',
    he: 'תמחור',
    de: 'Preisgestaltung',
    es: 'Estrategia de precios',
    ru: 'Ценовая стратегия',
    vi: 'Chiến lược định giá',
  },
  uses: {
    zh_cn: '使用授权',
    zhhant: '使用授權',
    en: 'Uses',
    he: 'שימושים',
    de: 'Nutzungen',
    es: 'Usos',
    ru: 'Использования',
    vi: 'Sử dụng',
  },
  lastRelease: {
    zh_cn: '最后发布',
    zhhant: '最後發布',
    en: 'Last Release',
    he: 'שחרור אחרון',
    de: 'Letzte Veröffentlichung',
    es: 'Última publicación',
    ru: 'Последнее обновление',
    vi: 'Phiên bản cuối cùng',
  },
  vehicleType: {
    zh_cn: '车辆',
    zhhant: '車輛',
    en: 'Vehicle',
    he: 'רכב',
    de: 'Fahrzeug',
    es: 'Vehículo',
    ru: 'Транспортное средство',
    vi: 'Xe',
  },
  car: {
    zh_cn: '汽车',
    zhhant: '汽車',
    en: 'Car',
    he: 'רכב',
    de: 'Auto',
    es: 'Coche',
    ru: 'Автомобиль',
    vi: 'Ô tô',
  },
  bike: {
    zh_cn: '单车',
    zhhant: '單車',
    en: 'Bike',
    he: 'אופניים',
    de: 'Fahrrad',
    es: 'Bicicleta',
    ru: 'Велосипед',
    vi: 'Xe đạp',
  },
  addStation: {
    zh_cn: '添加充电站点',
    zhhant: '新增充電站點',
    en: 'Create Station',
    he: 'הוסף מקום',
    de: 'Station hinzufügen',
    es: 'Agregar estación',
    ru: 'Добавить станцию',
    vi: 'Thêm điểm dừng',
  },
  editStation: {
    zh_cn: '编辑站点信息',
    zhhant: '編輯站點資訊',
    en: 'Edit Station',
    he: 'ערוך מקום',
    de: 'Station bearbeiten',
    es: 'Editar estación',
    ru: 'Редактировать станцию',
    vi: 'Chỉnh sửa điểm dừng',
  },
  addPrice: {
    zh_cn: '添加定价策略',
    zhhant: '添加定價策略',
    en: 'Add Pricing',
    he: 'הוסף תמחור',
    de: 'Preise hinzufügen',
    es: 'Agregar estrategia de precios',
    ru: 'Добавить ценовую стратегию',
    vi: 'Thêm định giá',
  },
  editPrice: {
    zh_cn: '编辑定价策略',
    zhhant: '編輯定價策略',
    en: 'Edit Pricing',
    he: 'ערוך תמחור',
    de: 'Preis bearbeiten',
    es: 'Editar estrategia de precios',
    ru: 'Редактировать ценовую стратегию',
    vi: 'Chỉnh sửa định giá',
  },
  priceingName: {
    zh_cn: '定价策略名称',
    zhhant: '定價策略名稱',
    en: 'Pricing Name',
    he: 'שם תמחור',
    de: 'Preisname',
    es: 'Nombre de la estrategia de precios',
    ru: 'Название ценовой стратегии',
    vi: 'Tên định giá',
  },
  priceingTariffElec: {
    zh_cn: '按电量计费',
    zhhant: '按電量計費',
    en: 'Charge by electricity',
    he: 'חיוב לפי חשמל',
    de: 'Stromverbrauch berechnen',
    es: 'Cobro por electricidad',
    ru: 'Оплата по электроэнергии',
    vi: 'Tính phí theo điện',
  },
  priceingTariffPowerStart: {
    zh_cn: '起始功率(W)',
    zhhant: '起始功率(W)',
    en: 'Starting power',
    he: 'משקל התחלה',
    de: 'Anfangsleistung',
    es: 'Potencia de inicio',
    ru: 'Начальная мощность',
    vi: 'Khối lượng bắt đầu',
  },
  priceingTariffPowerEnd: {
    zh_cn: '结束功率(W)',
    zhhant: '结束功率(W)',
    en: 'Ending power',
    he: 'משקל סיום',
    de: 'Endleistung',
    es: 'Potencia final',
    ru: 'Конечная мощность',
    vi: 'Khối lượng kết thúc',
  },

  priceingTariffPrice: {
    zh_cn: '电费(元/度)',
    zhhant: '电费(元/度)',
    en: 'Elec Price',
    he: 'תעריף חשמל',
    de: 'Stromtarif',
    es: 'Tarifa eléctrica',
    ru: 'Тариф на электроэнергию',
    vi: 'Tỷ lệ điện',
  },
  priceingTariffServicePrice: {
    zh_cn: '服务费(元/小时)',
    zhhant: '服务费(元/小时)',
    en: 'Service Price',
    he: 'תעריף שירות',
    de: 'Servicegebühr',
    es: 'Tarifa de servicio',
    ru: 'Сервисный сбор',
    vi: 'Phí dịch vụ',
  },
  priceingTariffUnitPrice: {
    zh_cn: '最小计费单位(元)',
    zhhant: '最小计费单位(元)',
    en: 'Min Unit Price(Yuan)',
    he: 'מחיר יחידה מינימלי (יואן)',
    de: 'Mindestpreis pro Einheit (Yuan)',
    es: 'Precio mínimo por unidad (yuan)',
    ru: 'Минимальная единица стоимости (юань)',
    vi: 'Giá tối thiểu cho đơn vị (Nhân dân tệ)',
  },
  priceingTariffUnitPriceDesc: {
    zh_cn:
      '本设置只应用于按功率时长的计费策略，当费用不足最小单位费用的整数倍时，将会安装最小单位费用的整数倍收取。如，最小单位费用的是0.5元，当费用为1.1元时，将会收取1.5元；当费用为1.5元时，将会收取1.5元。',
  },
  priceingTariffFreeTime: {
    zh_cn: '免费充电时间(分钟)',
    zhhant: '免费充电时间(分钟)',
    en: 'Free Charge Time(min)',
    he: 'זמן חיוב חשמל חופשי (דקות)',
    de: 'Freie Ladezeit (Minuten)',
    es: 'Tiempo de carga libre (minutos)',
    ru: 'Бесплатное время зарядки (минуты)',
    vi: 'Thời gian nạp miễn phí (phút)',
  },
  priceingTariffFreeTimeDesc: {
    zh_cn:
      '本设置只应用于按功率时长的计费策略，前几分钟不参与计费。如，免费充电时长的是5分钟，当充电时长是4分钟时，将不会收取费用；当充电时长是6分钟时，将会根据计费模版收取6分钟的费用。',
    zhhant:
      '本设置只应用于按功率时长的计费策略，前几分钟不参与计费。如，免费充电时长的是5分钟，当充电时长是4分钟时，将不会收取费用；当充电时长是6分钟时，将会根据计费模版收取6分钟的费用',
    en: 'This setting is only applicable to power-based charging strategies. The first few minutes are not included in the billing. For example, if the free charging time is 5 minutes and the charging duration is 4 minutes, no fees will be charged; if the charging duration is 6 minutes, the fees will be charged based on the billing template for 6 minutes.',
    he: 'ההגדרה הזו חלה על אסטרטגיות חיוב לפי משקל בלבד. הדקות הראשונות אינן כלולות בחשבון. למשל, אם משך זמן החיוב החופשי הוא 5 דקות ואורך ההטענה הוא 4 דקות, לא יתגבה שום תשלום; ואם אורך ההטענה הוא 6 דקות, יתגבה תשלום בהתאם לעיצוב הח שבון. ',
    de: 'Diese Einstellung gilt nur für Leistungsgesteuerte Ladestrategien. Die ersten paar Minuten sind nicht in die Abrechnung einbezogen. Wenn zum Beispiel die kostenlose Ladezeit 5 Minuten ist und die Ladezeit 4 Minuten, werden keine Kosten berechnet; wenn die Ladezeit 6 Minuten ist, werden die Kosten basierend auf dem Abrechnungstemplate für 6 Minuten berechnet.',
    es: 'Esta configuración solo se aplica a estrategias de carga basadas en potencia. Los primeros minutos no están incluidos en la facturación. Por ejemplo, si el tiempo libre de carga es de 5 minutos y la duración de la carga es de 4 minutos no se cobrarán; si la duración de la carga es de 6 minutos, se cobrarán los costos basados en el plantilla de facturación para 6 minutos.',
  },
  priceingPower: {
    zh_cn: '按功率计费',
    zhhant: '按功率計費',
    en: 'Charge by power',
    he: 'חיוב לפי יחידות',
    de: 'Leistung berechnen',
    es: 'Cobro por potencia',
    ru: 'Оплата по мощности',
    vi: 'Tính phí theo công suất',
  },
  discountUseBeginTime: {
    zh_cn: '券使用开始时间',
    zhhant: '券使用開始時間',
    en: 'Discount Use Begin Time',
    he: 'תאריך תחילת שימוש בקופון',
    de: 'Beginn der Nutzung der Gutschein',
    es: 'Inicio de uso de descuento',
    ru: 'Начало использования скидок',
    vi: 'Bắt đầu sử dụng giảm giá',
  },
  discountUseEndTime: {
    zh_cn: '券使用结束时间',
    zhhant: '券使用結束時間',
    en: 'Discount Use End Time',
    he: 'תאריך סיום שימוש בקופון',
    de: 'Ende der Nutzung der Gutschein',
    es: 'Fin de uso de descuento',
    ru: 'Окончание использования скидок',
    vi: 'Kết thúc sử dụng giảm giá',
  },
  elecFee: {
    zh_cn: '电费',
    zhhant: '電費',
    en: 'Elec Rate',
    he: 'תעריף חשמל',
    de: 'Stromtarif',
    es: 'Tarifa eléctrica',
    ru: 'Тариф на электроэнергию',
    vi: 'Tỷ lệ điện',
  },
  priceingTariffElecFee: {
    zh_cn: '电费(元/度)',
    zhhant: '電費(元/度)',
    en: 'Elec Rate($/kWh)',
    he: 'תעריף חשמל (₪/קילוואט)',
    de: 'Stromtarif (€/kWh)',
    es: 'Tarifa eléctrica ($/kWh)',
    ru: 'Тариф на электроэнергию (₽/кВт*ч)',
    vi: 'Tỷ lệ điện ($/kWh)',
  },
  priceingTariffServiceFee: {
    zh_cn: '服务费(元/度)',
    zhhant: '服務費(元/度)',
    en: 'Service Rate($/kWh)',
    he: 'שירות (₪/קילוואט)',
    de: 'Service-Rate (€/kWh)',
    es: 'Tarifa de servicio ($/kWh)',
    ru: 'Стоимость услуг (₽/кВт*ч)',
    vi: 'Tỷ lệ dịch vụ ($/kWh)',
  },
  priceingTariffTimeSelect: {
    zh_cn: '时间分配 (每30分钟一个时段), 当前选中:',
    zhhant: '時間分配 (每30分钟一個時段), 當前選中:',
    en: 'Time Allocation (Every 30 minutes a period), Currently selected:',
    he: 'תצוגת זמן (כל 30 דקות תקופה), שבוע נבחר:',
    de: 'Zeitverteilung (Jede 30 Minuten ein Zeitraum), aktuell ausgewählt:',
    es: 'Asignación de tiempo (cada 30 minutos un periodo), seleccionado actualmente:',
    ru: 'Распределение времени (каждые 30 минут период), выбрано:',
    vi: 'Phân bổ thời gian (mỗi 30 phút một khoảng), đã chọn:',
  },
  priceingTariffTimeSelectTip: {
    zh_cn: '鼠标选择对应的时间段即可，支持框选。',
    zhhant: '鼠標選擇對應的時間段即可，支持框選。',
    en: 'Select the corresponding time period with your mouse, supports box selection.',
    he: 'בחר את הזמן המתאים לחשבון שלך, ניתן לבחור יותר מקבוצה אחת.',
    de: 'Wähle den passenden Zeitraum mit deinem Mauszeiger, unterstützt Boxauswahl.',
    es: 'Selecciona el periodo de tiempo correspondiente con tu ratón, admite selección múltiple.',
    ru: 'Выберите соответствующий временной период с помощью мыши, поддерживает выбор в блоке.',
    vi: 'Chọn đối tượng sử dụng tương ứng với con trỏ chuột, hỗ trợ chọn nhiều.',
  },
  priceingTariffTag: {
    zh_cn: '标签',
    zhhant: '標籤',
    en: 'Tag',
    he: 'תג',
    de: 'Tag',
    es: 'Etiqueta',
    ru: 'Тег',
    vi: 'Nhãn',
  },
  priceingTariffSharp: {
    zh_cn: '尖时段',
    zhhant: '尖时段',
    en: 'Sharp',
    he: 'שיא',
    de: 'Spitz',
    es: 'Pico',
    ru: 'Пик',
    vi: 'Cao điểm',
  },
  priceingTariffPeak: {
    zh_cn: '峰时段',
    zhhant: '峰时段',
    en: 'Peak',
    he: 'שיא',
    de: 'Spitze',
    es: 'Pico',
    ru: 'Пиковый',
    vi: 'Pha đỉnh',
  },
  priceingTariffFlat: {
    zh_cn: '平时段',
    zhhant: '平时段',
    en: 'Flat',
    he: 'שטוח',
    de: 'Flach',
    es: 'Plana',
    ru: 'Ровный',
    vi: 'Phẳng',
  },
  priceingTariffValley: {
    zh_cn: '谷时段',
    zhhant: '谷时段',
    en: 'Valley',
    he: 'עמק',
    de: 'Tal',
    es: 'Valle',
    ru: 'Долина',
    vi: 'Thung lũng',
  },
  priceingTariffDeepValley: {
    zh_cn: '深谷时段',
    zhhant: '深谷时段',
    en: 'Deep Valley',
    he: 'עמק עמוק',
    de: 'Tief Tal',
    es: 'Valle profundo',
    ru: 'Глубокая долина',
    vi: 'Thung lũng sâu',
  },
  selectUseOBJ: {
    zh_cn: '选择使用对象',
    zhhant: '選擇使用對象',
    en: 'Select a use object',
    he: 'בחר אובייקט שימוש',
    de: 'Verwendungsobjekt auswählen',
    es: 'Seleccionar objeto de uso',
    ru: 'Выберите объект использования',
    vi: 'Chọn đối tượng sử dụng',
  },
  selectEvse: {
    zh_cn: '选择设备',
    zhhant: '選擇設備',
    en: 'Select Equipment',
    he: 'בחר ציוד',
    de: 'Gerät auswählen',
    es: 'Seleccionar equipo',
    ru: 'Выберите оборудование',
    vi: 'Chọn thiết bị',
  },
  editUser: {
    zh_cn: '编辑用户信息',
    zhhant: '編輯用戶信息',
    en: 'Edit User',
    he: 'ערוך משתמש',
    de: 'Benutzer bearbeiten',
    es: 'Editar usuario',
    ru: 'Редактировать пользователя',
    vi: 'Chỉnh sửa người dùng',
  },
  cardNo: {
    zh_cn: '卡号',
    zhhant: '卡號',
    en: 'Card NO',
    he: 'מספר כרטיס',
    de: 'Kartennummer',
    es: 'Número de tarjeta',
    ru: 'Номер карты',
    vi: 'Số thẻ',
  },
  cardType: {
    zh_cn: '卡类型',
    zhhant: '卡類型',
    en: 'Card Type',
    he: 'סוג כרטיס',
    de: 'Kartentyp',
    es: 'Tipo de tarjeta',
    ru: 'Тип карты',
    vi: 'Loại thẻ',
  },
  localPlug: {
    zh_cn: '即插即充',
    zhhant: '即插即充',
    en: 'Local plug',
    he: 'תקע מקומי',
    de: 'Lokaler Stecker',
    es: 'Enchufe local',
    ru: 'Локальная розетка',
    vi: 'Cắm vào là sạc',
  },
  localAdmin: {
    zh_cn: '本地管理员',
    zhhant: '本地管理員',
    en: 'Local admin',
    he: 'מנהל מקומי',
    de: 'Lokaler Administrator',
    es: 'Administrador local',
    ru: 'Локальный администратор',
    vi: 'Quản trị viên địa phương',
  },
  localIdentityCard: {
    zh_cn: '本地鉴权卡 ',
    zhhant: '本地鑑權卡',
    en: 'Local Identity Card',
    he: 'כרטיס זהות מקומי',
    de: 'Lokale Identitätskarte',
    es: 'Tarjeta de identidad local',
    ru: 'Местная карта идентификации',
    vi: 'Thẻ nhận diện địa phương',
  },
  onlineIdentityCard: {
    zh_cn: '在线鉴权卡',
    zhhant: '在線鑑權卡',
    en: 'Online Identity Card',
    he: 'כרטיס זהות מקוון',
    de: 'Online-Identitätskarte',
    es: 'Tarjeta de identidad en línea',
    ru: 'Онлайн карта идентификации',
    vi: 'Thẻ nhận diện trực tuyến',
  },
  localWalletCard: {
    zh_cn: '本地钱包卡',
    zhhant: '本地錢包卡',
    en: 'Local Wallet Card',
    he: 'כרטיס ארנק מקומי',
    de: 'Lokale Wallet-Karte',
    es: 'Tarjeta de billetera local',
    ru: 'Местная кошелек-карта',
    vi: 'Thẻ ví địa phương',
  },
  localVin: {
    zh_cn: '离线车辆VIN',
    zhhant: '離線車輛VIN',
    en: 'Local VIN',
    he: 'VIN מקומי',
    de: 'Lokale VIN',
    es: 'VIN local',
    ru: 'Локальный VIN',
    vi: 'VIN địa phương',
  },
  onlineVin: {
    zh_cn: '在线车辆VIN',
    zhhant: '在線車輛VIN',
    en: 'Online VIN',
    he: 'VIN מקוון',
    de: 'Online-VIN',
    es: 'VIN en línea',
    ru: 'Онлайн VIN',
    vi: 'VIN trực tuyến',
  },
  bluetooth: {
    zh_cn: '本地通过蓝牙启动',
    zhhant: '本地通過藍牙啟動',
    en: 'Bluetooth',
    he: 'בלוטות',
    de: 'Bluetooth',
    es: 'Bluetooth',
    ru: 'Bluetooth',
    vi: 'Bluetooth',
  },
  mac: {
    zh_cn: '本地通过输入校验码启动',
    zhhant: '本地通過輸入校驗碼啟動',
    en: 'Mac',
    he: 'Mac',
    de: 'Mac',
    es: 'Mac',
    ru: 'Mac',
    vi: 'Mac',
  },
  remoteAdmin: {
    zh_cn: '远程管理员启动',
    zhhant: '遠程管理員啟動',
    en: 'Remote admin',
    he: 'מנהל מרוחק',
    de: 'Remote-Administrator',
    es: 'Administrador remoto',
    ru: 'Удаленный администратор',
    vi: 'Quản trị viên từ xa',
  },
  remoteUser: {
    zh_cn: '远程用户启动',
    zhhant: '遠程用戶啟動',
    en: 'Remote user',
    he: 'משתמש מרוחק',
    de: 'Remote-Benutzer',
    es: 'Usuario remoto',
    ru: 'Удаленный пользователь',
    vi: 'Người dùng từ xa',
  },
  deleteCardConfirm: {
    zh_cn: '确定删除RFID卡',
    zhhant: '確定刪除RFID卡',
    en: 'Confirm to delete the RFID card',
    he: 'אשר למחוק את כרטיס ה-RFID',
    de: 'Bestätigen Sie das Löschen der RFID-Karte',
    es: 'Confirmar la eliminación de la tarjeta RFID',
    ru: 'Подтвердите удаление RFID-карты',
    vi: 'Xác nhận xóa thẻ RFID',
  },
  fbcontent: {
    zh_cn: '反馈内容',
    zhhant: '反饋內容',
    en: 'Feedback Content',
    he: 'תוכן משוב',
    de: 'Feedback-Inhalt',
    es: 'Contenido de comentarios',
    ru: 'Содержание отзыва',
    vi: 'Nội dung phản hồi',
  },
  totalNum: {
    zh_cn: '总结算数量',
    zhhant: '總結算數量',
    en: 'Total number',
    he: 'סה"כ מספר',
    de: 'Gesamtanzahl',
    es: 'Número total',
    ru: 'Общее количество',
    vi: 'Tổng số',
  },
  settleElec: {
    zh_cn: '结算电量',
    zhhant: '結算電量',
    en: 'Settle Electricity',
    he: 'סך אשראי',
    de: 'Einsatzleistung',
    es: 'Consolidar electricidad',
    ru: 'Объединить электроэнергию',
    vi: 'Đãi tiêu thụ điện',
  },
  settleAmount: {
    zh_cn: '充电总金额',
    zhhant: '充電總金額',
    en: 'Charging Amount',
    he: 'סך כולל',
    de: 'Ladebetrag',
    es: 'Cantidad de carga',
    ru: 'Общая сумма зарядки',
    vi: 'Tổng số tiền nạp',
  },
  settleElecAmount: {
    zh_cn: '电费',
    zhhant: '電費',
    en: 'Electricity Fees',
    he: 'סך אשראי',
    de: 'Stromkosten',
    es: 'Cantidad de electricidad',
    ru: 'Сумма электроэнергии',
    vi: 'Giá điện tiêu thụ tổng số tiền',
  },
  settleSrvAmount: {
    zh_cn: '服务费',
    zhhant: '服務費',
    en: 'Service Fees',
    he: 'סך שירות',
    de: 'Servicegebühr',
    es: 'Cantidad de servicio',
    ru: 'Сумма услуг',
    vi: 'Giá dịch vụ tổng số tiền',
  },
  settlDiscountAmount: {
    zh_cn: '优惠金额',
    zhhant: '優惠金額',
    en: 'Discount Fees',
    he: 'סך הנחה',
    de: 'Rabattgebühr',
    es: 'Cantidad de descuento',
    ru: 'Сумма скидки',
    vi: 'Giá giảm giá tổng số tiền',
  },
  final: {
    zh_cn: '最终金额',
    zhhant: '最終金額',
    en: 'Final',
    he: 'סך סופי',
    de: 'Endgültig',
    es: 'Final',
    ru: 'Окончательная сумма',
    vi: 'Cuối cùng',
  },
  settleChargingTime: {
    zh_cn: '充电时间',
    zhhant: '充電時間',
    en: 'Charging Time',
    he: 'זמן אשראי',
    de: 'Ladezeit',
    es: 'Tiempo de carga',
    ru: 'Время зарядки',
    vi: 'Thời gian nạp',
  },
  regenConfirm: {
    zh_cn: '确认重新生成账单?',
    zhhant: '確認重新生成賬單?',
    en: 'Confirm to regenerate the bill?',
    he: 'לאשר יצירה מחדש של החשבון?',
    de: 'Bestätigen, die Rechnung neu zu erstellen?',
    es: '¿Confirmar la regeneración de la factura?',
    ru: 'Подтвердить пересоздание счета?',
    vi: 'Xác nhận tái tạo lại hóa đơn?',
  },
  regen: {
    zh_cn: '重新生成',
    zhhant: '重新生成',
    en: 'Regenerate',
    he: 'ליצור מחדש',
    de: 'Neu generieren',
    es: 'Regenerar',
    ru: 'Перегенерировать',
    vi: 'Tái tạo lại',
  },
  reportPending: {
    zh_cn: '待生成账单',
    zhhant: '待生成帳單',
    en: 'Pending',
    he: 'ממתין לייצור',
    de: 'Warten auf Rechnung',
    es: 'Pendiente',
    ru: 'Ожидает счета',
    vi: 'Đang chờ hóa đơn',
  },
  reportGened: {
    zh_cn: '已生成账单',
    zhhant: '已生成帳單',
    en: 'Generated',
    he: 'ייצר',
    de: 'Erzeugt',
    es: 'Generado',
    ru: 'Сгенерировано',
    vi: 'Đã tạo hóa đơn',
  },
  grain: {
    zh_cn: '时间维度',
    zhhant: '時間粒度',
    en: 'Tiem Grain',
    he: 'זמן אשראי',
    de: 'Zeitliche Granularität',
    es: 'Granularidad de tiempo',
    ru: 'Временная разбивка',
    vi: 'Phân tách theo thời gian',
  },
  selectGrain: {
    zh_cn: '选择时间维度',
    zhhant: '選擇時間粒度',
    en: 'Select Time Grain',
    he: 'לבחור זמן אשראי',
    de: 'Wählen Sie die zeitliche Granularität',
    es: 'Seleccione la granularidad de tiempo',
    ru: 'Выберите временную разбивку',
    vi: 'Chọn phân tách theo thời gian',
  },
  operatorOnly: {
    zh_cn: '只搜索运营商维度的账单, 忽略商户站点及设备维度的账单',
    zhhant: '只搜索运营商維度的帳單, 忽略商户站點及設備維度的帳單',
    en: 'Search only for billing in the carrier dimension, ignoring billing in the merchant site and device dimension.',
    he: 'חפש רק חשבונות בממד הספק, תוך התעלמות מחשבונות בממד האתר וההתקן של הסוחר.',
    de: 'Suchen Sie nur nach Abrechnungen im Carrier-Dimension und ignorieren Sie Abrechnungen im Händler-Site- und Geräte-Dimension.',
    es: 'Buscar solo facturación en la dimensión del operador, ignorando la facturación en la dimensión del sitio del comerciante y del dispositivo.',
    ru: 'Искать только счета в измерении оператора, игнорируя счета в измерении торгового сайта и устройства.',
    vi: 'Chỉ tìm hóa đơn trong phạm vi nhà mạng, bỏ qua hóa đơn trong phạm vi trang thương mại và thiết bị.',
  },
  maxLoad: {
    zh_cn: '最大负载信息',
    zhhant: '最大負載資訊',
    en: 'Max Load Info',
    he: 'מידע על טעינה מקסימלית',
    de: 'Maximaler Ladeinformationen',
    es: 'Información de carga máxima',
    ru: 'Максимальная информация нагрузки',
    vi: 'Thông tin tải trọng tối đa',
  },
  latestVersionName: {
    zh_cn: '最新版本名称',
    zhhant: '最新版本名稱',
    en: 'Latest Version Name',
    he: 'שם גרסה אחרונה',
    de: 'Letzter Version Name',
    es: 'Nombre de la última versión',
    ru: 'Название последней версии',
    vi: 'Tên phiên bản mới nhất',
  },
  latestVersionNameDesc: {
    zh_cn: '最新版本名称描述。 主要用户显示, 例如: v1.0.0',
    zhhant: '最新版本名稱描述。 主要用戶顯示, 例如: v1.0.0',
    en: 'Latest version name description. Mainly used for display, such as: v1.0.0',
    he: 'תיאור שם גרסה אחרונה. משתמשים בו כדי להציג, לדוגמה: v1.0.0',
    de: 'Beschreibung des Namen der neuesten Version. Wird hauptsächlich für die Anzeige verwendet, z. B.: v1.0.0',
    es: 'Descripción del nombre de la última versión. Se utiliza principalmente para mostrar, por ejemplo: v1.0.0',
    ru: 'Описание названия последней версии. Основное использование для отображения, например: v1.0.0',
    vi: 'Mô tả tên phiên bản mới nhất. Dùng để hiển thị, ví dụ: v1.0.0',
  },
  latestVersionCode: {
    zh_cn: '最新版本码',
    zhhant: '最新版本碼',
    en: 'Latest Version Code',
    he: 'קוד גרסה אחרונה',
    de: 'Letzter Versionscode',
    es: 'Código de la última versión',
    ru: 'Код последней версии',
    vi: 'Mã phiên bản mới nhất',
  },
  latestVersionCodeDesc: {
    zh_cn: '最新版本码描述。用于对比判断是否需要升级APP，格式为: 100',
    zhhant: '最新版本碼描述。用於比較判斷是否需要升級APP，格式為: 100',
    en: 'Latest version code description. Used to compare and determine whether it is necessary to upgrade the APP, format: 100',
    he: 'תיאור קוד גרסה אחרונה. משתמש בו כדי לבדוק ולגרם עדכון APP, לדוגמה: 100',
    de: 'Beschreibung des Codes der neuesten Version. Wird für die Vergleichung und Bestimmung verwendet, ob ein Upgrade notwendig ist, z. B.: 100',
    es: 'Descripción del código de la última versión. Se utiliza para comparar y determinar si es necesario actualizar la APP, por ejemplo: 100',
    ru: 'Описание кода последней версии. Используется для сравнения и определения необходимости обновления приложения, формат: 100',
    vi: 'Mô tả mã phiên bản mới nhất. Dùng để so sánh và quyết định cần cập nhật ứng dụng hay không, ví dụ: 100',
  },
  forceUpgrade: {
    zh_cn: '是否强制升级APP',
    zhhant: '是否強制升級APP',
    en: 'Whether to force upgrade the APP',
    he: 'האם לבקש עדכון APP',
    de: 'Ob die App erzwungen werden muss, um auf dem neuesten Stand zu sein',
    es: '¿Si se requiere actualizar la APP',
    ru: 'Необходимо ли принудительное обновление приложения',
    vi: 'Cần cập nhật ứng dụng hay không',
  },
  appleClientId: {
    zh_cn: 'Apple Client ID',
    zhhant: 'Apple Client ID',
    en: 'Apple Client ID',
    he: 'Apple Client ID',
    de: 'Apple Client ID',
    es: 'ID de cliente de Apple',
    ru: 'ID клиента Apple',
    vi: 'ID khách hàng Apple',
  },
  appleClientIdDesc: {
    zh_cn: 'Apple ClientID 需要登录Apple Developer后台获取',
    zhhant: 'Apple ClientID 需要登入Apple Developer後台獲取',
    en: 'Apple ClientID needs to be obtained from the Apple Developer background',
    he: 'Apple ClientID צריך לקבל מרקע Apple Developer',
    de: 'Apple ClientID muss aus dem Apple Developer-Hintergrund abgerufen werden',
    es: 'El ID de cliente de Apple es necesario obtener desde el fondo de desarrollador de Apple',
    ru: 'ID клиента Apple необходимо получать из фона разработчика Apple',
    vi: 'ID khách hàng Apple cần phải được lấy từ nền tảng nhà phát triển của Apple',
  },
  googleClientId: {
    zh_cn: 'Google Client ID',
    zhhant: 'Google Client ID',
    en: 'Google Client ID',
    he: 'Google Client ID',
    de: 'Google Client ID',
    es: 'ID de cliente de Google',
    ru: 'ID клиента Google',
    vi: 'ID khách hàng Google',
  },
  googleClientIdDesc: {
    zh_cn: 'Google ClientID 需要登录Google Play后台创建应用',
    zhhant: 'Google ClientID 需要登入Google Play後台創建應用',
    en: 'Google ClientID needs to be created in the Google Play background application',
    he: 'Google ClientID צריך ליצור ברקע Google Play',
    de: 'Google ClientID muss in der Google Play-Hintergrung-Anwendung erstellt werden',
    es: 'El ID de cliente de Google es necesario crear en la aplicación de fondo de Google Play',
    ru: 'ID клиента Google необходимо создать в приложении фона Google Play',
    vi: 'ID khách hàng Google cần phải được tạo trong ứng dụng nền tảng Google Play',
  },
  googleClientIdByIos: {
    zh_cn: 'IOS登录Google ClientId',
    zhhant: 'IOS登入Google ClientId',
    en: 'IOS login Google ClientId',
    he: 'IOS login Google ClientId',
    de: 'IOS login Google ClientId',
    es: 'IOS login Google ClientId',
    ru: 'IOS login Google ClientId',
    vi: 'IOS login Google ClientId',
  },
  mctid: {
    zh_cn: '商户号',
    zhhant: '商戶號',
    en: 'Merchant ID',
    he: 'מספר פרטי מרכז',
    de: 'Geschäft ID',
    es: 'ID de comerciante',
    ru: 'ID магазина',
    vi: 'ID cửa hàng',
  },
  token: {
    zh_cn: 'Token',
    zhhant: 'Token',
    en: 'Token',
    he: 'Token',
    de: 'Token',
    es: 'Token',
    ru: 'Token',
    vi: 'Token',
  },
  appid: {
    zh_cn: 'APPID',
    zhhant: 'APPID',
    he: 'APPID',
    de: 'APPID',
    es: 'APPID',
    ru: 'APPID',
    vi: 'APPID',
  },
  appSecret: {
    zh_cn: 'APP Secret',
    zhhant: 'APP Secret',
    en: 'APP Secret',
    he: 'APP Secret',
    de: 'APP Secret',
    es: 'APP Secret',
    ru: 'APP Secret',
    vi: 'APP Secret',
  },
  singKey: {
    zh_cn: '签名密钥',
    zhhant: '簽名密鑰',
    en: 'Signature key',
    he: 'מפתח חתימה',
    de: 'Signatur Schlüssel',
    es: 'Clave de firma',
    ru: 'Ключ подписи',
    vi: 'Khóa chữ ký',
  },
  encryptKey: {
    zh_cn: '加密密钥',
    zhhant: '加密密鑰',
    en: 'Encryption key',
    he: 'מפתח קריפטוגרפי',
    de: 'Verschlüsselungsschlüssel',
    es: 'Clave de cifrado',
    ru: 'Шифровочный ключ',
    vi: 'Khóa mã hóa',
  },
  mctPrivateKey: {
    zh_cn: '商户私钥',
    zhhant: '商戶私鑰',
    en: 'Merchant private key',
    he: 'מספר פרטי מרכז',
    de: 'Geschäft privater Schlüssel',
    es: 'Clave privada del comerciante',
    ru: 'Приватный ключ магазина',
    vi: 'Khóa riêng tư cửa hàng',
  },
  aliPublicKey: {
    zh_cn: '支付宝公钥',
    zhhant: '支付宝公鑰',
    en: 'Alipay public key',
    he: 'מפתח ציבורי אליפא',
    de: 'Alipay öffentlicher Schlüssel',
    es: 'Clave pública de Alipay',
    ru: 'Публичный ключ Alipay',
    vi: 'Khóa công khai của Alipay',
  },
  aliEncryptKey: {
    zh_cn: '支付宝加密密钥',
    zhhant: '支付宝加密密鑰',
    en: 'Alipay encryption key',
    he: 'מפתח קריפטוגרפי אליפא',
    de: 'Alipay Verschlüsselungsschlüssel',
    es: 'Clave de cifrado Alipay',
    ru: 'Шифровочный ключ Alipay',
    vi: 'Khóa mã hóa của Alipay',
  },
  mayiAccessKeyId: {
    zh_cn: '蚂蚁链AccessKeyId',
    zhhant: '螞蟻鏈AccessKeyId',
    en: 'AntChain AccessKeyId',
    he: 'AntChain AccessKeyId',
    de: 'AntChain AccessKeyId',
    es: 'AntChain AccessKeyId',
    ru: 'AntChain AccessKeyId',
    vi: 'AntChain AccessKeyId',
  },
  mayiAccessKeySecret: {
    zh_cn: '蚂蚁链AccessKeySecret',
    zhhant: '螞蟻鏈AccessKeySecret',
    en: 'AntChain AccessKeySecret',
    he: 'AntChain AccessKeySecret',
    de: 'AntChain AccessKeySecret',
    es: 'AntChain AccessKeySecret',
    ru: 'AntChain AccessKeySecret',
    vi: 'AntChain AccessKeySecret',
  },
  scene: {
    zh_cn: '场景',
    zhhant: '場景',
    en: 'Scene',
    he: 'סצנה',
    de: 'Szene',
    es: 'Escena',
    ru: 'Сцена',
    vi: 'Cảnh',
  },
  merchantNo: {
    zh_cn: '商户号',
    zhhant: '商戶號',
    en: 'Merchant number',
    he: 'מספר מרכז',
    de: 'Geschäft Nummer',
    es: 'Número de comerciante',
    ru: 'Номер магазина',
    vi: 'Số cửa hàng',
  },
  parentMerchantNo: {
    zh_cn: '父商户号',
    zhhant: '父商戶號',
    en: 'Parent merchant number',
    he: 'מספר מרכז אב',
    de: 'Elterngeschäft Nummer',
    es: 'Número de comerciante padre',
    ru: 'Родительский номер магазина',
    vi: 'Số cửa hàng cha',
  },
  merchantCode: {
    zh_cn: '商户号',
    zhhant: '商戶號',
    en: 'Merchant number',
    he: 'מספר מרכז',
    de: 'Geschäft Nummer',
    es: 'Número de comerciante',
    ru: 'Номер магазина',
    vi: 'Số cửa hàng',
  },
  payPrivateKey: {
    zh_cn: '商户支付私钥',
    zhhant: '商戶支付私鑰',
    en: 'Merchant private key',
    he: 'מפתח פרטי מרכז',
    de: 'Geschäft privater Schlüssel',
    es: 'Clave privada del comerciante',
    ru: 'Приватный ключ магазина',
    vi: 'Khóa riêng tư cửa hàng',
  },
  payPublicKey: {
    zh_cn: '商户支付公钥',
    zhhant: '商户支付公鑰',
    en: 'Payment public key',
    he: 'מפתח ציבורי תשלום',
    de: 'Zahlung öffentlicher Schlüssel',
    es: 'Clave pública de pago',
    ru: 'Публичный ключ платежа',
    vi: 'Khóa công khai của thanh toán',
  },
  orderTypeHome: {
    zh_cn: '家用',
    zhhant: '家用',
    en: 'Home',
    he: 'בית',
    de: 'Zuhause',
    es: 'Casa',
    ru: 'Домашний',
    vi: 'Trang chủ',
  },
  orderTypeOperator: {
    zh_cn: '运营',
    zhhant: '運營',
    en: 'Operator',
    he: 'אופן',
    de: 'Betreiber',
    es: 'Operador',
    ru: 'Оператор',
    vi: 'Điều hành viên',
  },
  paypal: {
    zh_cn: 'PayPal',
    zhhant: 'PayPal',
    en: 'PayPal',
    he: 'PayPal',
    de: 'PayPal',
    es: 'PayPal',
    ru: 'PayPal',
    vi: 'PayPal',
  },
  alipay: {
    zh_cn: '支付宝',
    zhhant: '支付宝',
    en: 'AliPay',
    he: 'AliPay',
    de: 'AliPay',
    es: 'AliPay',
    ru: 'AliPay',
    vi: 'AliPay',
  },
  wechat: {
    zh_cn: '微信',
    zhhant: '微信',
    en: 'WeChat',
    he: 'WeChat',
    de: 'WeChat',
    es: 'WeChat',
    ru: 'WeChat',
    vi: 'WeChat',
  },
  yeepay: {
    zh_cn: '易宝',
    zhhant: '易宝',
    en: 'Yeepay',
    he: 'Yeepay',
    de: 'Yeepay',
    es: 'Yeepay',
    ru: 'Yeepay',
    vi: 'Yeepay',
  },
  PC_PAYMENT_HUB: {
    zh_cn: 'PC支付中心',
    zhhant: 'PC支付中心',
    en: 'PC Payment Hub',
    he: 'PC Payment Hub',
    de: 'PC-Zahlungshub',
    es: 'PC Payment Hub',
    ru: 'PC Payment Hub',
    vi: 'PC Payment Hub',
  },
  PC_STRIPE: {
    zh_cn: 'PC Stripe',
    zhhant: 'PC Stripe',
    en: 'PC Stripe',
    he: 'PC Stripe',
    de: 'PC Stripe',
    es: 'PC Stripe',
    ru: 'PC Stripe',
    vi: 'PC Stripe',
  },
  walletTransaction: {
    zh_cn: '钱包交易',
    zhhant: '錢包交易',
    en: 'Wallet transaction',
    he: 'העברת ארנק',
    de: 'Geldtransaktion',
    es: 'Transacción de billetera',
    ru: 'Перевод в кошелке',
    vi: 'Giao dịch ví',
  },
  manualRecharge: {
    zh_cn: '人工充值',
    zhhant: '人工充值',
    en: 'Manual recharge',
    he: 'רכיב מחדש',
    de: 'Manuelle Rückzahlung',
    es: 'Reembolso manual',
    ru: 'Manual recharge',
    vi: 'Manual recharge',
  },
  rechargeAmount: {
    zh_cn: '充值金额',
    zhhant: '充值金額',
    en: 'Recharge amount',
    he: 'כמות רכיב',
    de: 'Rückzahlungsbetrag',
    es: 'Cantidad de reembolso',
    ru: 'Сумма пополнения',
    vi: 'Số tiền rút',
  },
  giftAmount: {
    zh_cn: '赠送金额',
    zhhant: '贈送金額',
    en: 'Gift amount',
    he: 'כמות הופעה',
    de: 'Geschenkbetrag',
    es: 'Cantidad de regalo',
    ru: 'Награда',
    vi: 'Số tiền quà',
  },
  withholdAmount: {
    zh_cn: '扣款金额',
    zhhant: '扣款金額',
    en: 'Withhold amount',
    he: 'כמות תשלום',
    de: 'Abzuzahlender Betrag',
    es: 'Cantidad de retención',
    ru: 'Сумма удержания',
    vi: 'Số tiền thuế',
  },
  forceWithhold: {
    zh_cn: '强制扣款',
    zhhant: '強制扣款',
    en: 'Force withhold',
    he: 'תשלום חובה',
    de: 'Erzwingende Abzuzahlung',
    es: 'Retención obligatoria',
    ru: 'Принудительное удержание',
    vi: 'Thuế bắt buộc',
  },
  manualRechargeDesc: {
    zh_cn: '人工充值属于赠送类型,充值金额将直接存入钱包,但是赠送金额不能用于退款。',
    zhhant: '人工充值屬於贈送類型,充值金額將直接存入錢包,但是贈送金額不能用於退款。',
    en: 'Manual recharge belongs to the gift type, and the recharge amount will be directly stored in the wallet. However, the gift amount cannot be used for refund.',
    he: 'רכיב מחדש שייך לסוג הופעת, כמות רכיב יש לאחסן בארנק, אך כמות הופעה לא יכולה להימשך עבור שובה.',
    de: 'Manuelle Rückzahlung gehört zum Geschenktyp und der Rückzahlungsbetrag wird direkt in das Geldbeutel gespeichert werden. Allerdings kann der Geschenkbetrag nicht für Rückerstattungen verwendet werden.',
    es: 'El reembolso manual pertenece al tipo de regalo y la cantidad de reembolso se guardará directamente en el billetera. Sin embargo, no se puede usar para devoluciones.',
    ru: 'Manual recharge принадлежит типу подарка и сумма пополнения будет непосредственно сохранена в кошельке. Однако, награда не может быть использована для возмещения.',
    vi: 'Manual recharge thuộc về loại quà, số tiền rút sẽ được lưu trực tiếp trong ví. Tuy nhiên, số tiền quà không thể được sử',
  },
  manualRefundDesc: {
    zh_cn: '人工退款时本金将原路返还, 赠送金额全部清零',
    zhhant: '人工退款時本金將原路返回, 贈送金額全部清零',
    en: 'When manual refund, the principal will be returned in full, and the gift amount will be cleared.',
    he: 'בעת תשלום מחדש, הפרטיה יחזור בדיוק כפי שלה, ואת הכמות הופעה יפסק.',
    de: 'Bei manueller Rückzahlung wird der Hauptbetrag vollständig zurückgegeben, und die Geschenkbetrag wird vollständig geleert.',
    es: 'Cuando se realiza un reembolso manual, el principal se devolverá en su totalidad, y la cantidad de regalo se eliminará.',
    ru: 'При ручном возврате денег деньги вернутся в полном объеме, и количество подарка будет очищено.',
    vi: 'Khi thực hiện hoàn tiền thủ công, số tiền chính sẽ được hoàn trả đầy đủ, và số tiền quà sẽ bị xóa.',
  },
  manualWithholdDesc: {
    zh_cn: '人工扣款时本金和赠送金额必选其一，允许强制扣款(不校验)',
    zhhant: '人工扣款時本金和贈送金額必選其一，允許強制扣款(不校驗)',
    en: 'When manual withhold, the principal and gift amount must be selected, and force withhold is allowed (no validation).',
    he: 'בעת תשלום מחדש, הפרטיה ואת הכמות הופעה חייבים לבחור אחד, ואת התשלום תחליף יכולה (לא תבדוק).',
    de: 'Bei manueller Abzuzahlung muss der Hauptbetrag und die Geschenkbetrag ausgewählt werden, und die Abzuzahlung kann auch (nicht validiert) erfolgen.',
    es: 'Cuando se realiza un abono manual, el principal y la cantidad de regalo deben seleccionarse, y el abono también puede (no validado) realizarse.',
    ru: 'При ручном удержании деньги и награда должны быть выбраны, и принудительное удержание может быть выполнено (без проверки).',
    vi: 'Khi thực hiện thuế thủ công, số tiền chính và số tiền quà phải được chọn, và thuế cũng có thể (không được kiểm tra).',
  },
  addDiscountsActivity: {
    zh_cn: '添加优惠活动',
    zhhant: '添加優惠活動',
    en: 'Add discounts activity',
    he: 'הוסף פעילות скиדות',
    de: 'Aktivität mit Rabatt hinzufügen',
    es: 'Agregar actividad de descuentos',
    ru: 'Добавить активность скидок',
    vi: 'Thêm hoạt động giảm giá',
  },
  editDiscountsActivity: {
    zh_cn: '编辑优惠活动',
    zhhant: '編輯優惠活動',
    en: 'Edit discounts activity',
    he: 'ערוך פעילות скиדות',
    de: 'Rabattaktivität bearbeiten',
    es: 'Actividad de descuentos editada',
    ru: 'Редактировать активность скидок',
    vi: 'Chỉnh sửa hoạt động giảm giá',
  },
  activityName: {
    zh_cn: '活动名称',
    zhhant: '活動名稱',
    en: 'Activity name',
    he: 'שם פעילות',
    de: 'Aktivitätsname',
    es: 'Nombre de la actividad',
    ru: 'Название активности',
    vi: 'Tên hoạt động',
  },
  publishTime: {
    zh_cn: '发布时间',
    zhhant: '發佈時間',
    en: 'Publish time',
    he: 'זמן Публикаציה',
    de: 'Veröffentlichungszeit',
    es: 'Tiempo de publicación',
    ru: 'Дата публикации',
    vi: 'Thời gian xuất bản',
  },
  editClockPrice: {
    zh_cn: '编辑定时策略',
    zhhant: '編輯定時策略',
    en: 'Edit clock price',
    he: 'עריכת שעון מחיר',
    de: 'Edit Clock Price',
    es: 'Editar precio de reloj',
    ru: 'Редактировать цену на час',
    vi: 'Chỉnh sửa giá theo giờ',
  },
  addClockPrice: {
    zh_cn: '添加定时策略',
    zhhant: '添加定时策略',
    en: 'Add clock price',
    he: 'הוסף שעון מחיר',
    de: 'Add Clock Price',
    es: 'Añadir precio de reloj',
    ru: 'Добавить цену на час',
    vi: 'Thêm giá theo giờ',
  },
  activityType: {
    zh_cn: '活动类型',
    zhhant: '活動類型',
    en: 'Activity type',
    he: 'סוג פעילות',
    de: 'Aktivitätstyp',
    es: 'Tipo de actividad',
    ru: 'Тип активности',
    vi: 'Loại hoạt động',
  },
  activityRechargerGift: {
    zh_cn: '充值赠送',
    zhhant: '充電贈送',
    en: 'Give gifts when recharge wallet',
    he: 'הופעת כאשר רכיב',
    de: 'Geschenke bei Rückzahlung',
    es: 'Regalos al reembolsar billetera',
    ru: 'Подарок при пополнении кошелька',
    vi: 'Quà khi rút tiền ví',
  },
  activityFullDiscount: {
    zh_cn: '满减优惠',
    zhhant: '滿減優惠',
    en: 'Full discount',
    he: 'החל מרבית',
    de: 'Vollrabatt',
    es: 'Descuento completo',
    ru: 'Полный скидка',
    vi: 'Giảm giá đầy đủ',
  },
  activityRebateDiscount: {
    zh_cn: '折扣优惠',
    zhhant: '折扣優惠',
    en: 'Discount',
    he: 'скиדות',
    de: 'Rabatt',
    es: 'Descuento',
    ru: 'Скидка',
    vi: 'Giảm giá',
  },
  addActivityDesc: {
    zh_cn: '请配置活动相关数据。注意: 配置完成后，只有结束时间和状态可以编辑，其他数据无法修改。',
    zhhant: '請配置活動相關數據。注意: 配置完成後，只有結束時間和狀態可以編輯，其他數據無法修改。',
    en: 'Please configure the relevant data of the activity. Note: After configuration, only the end time and status can be edited, other data cannot be modified.',
    he: 'נא להגדיר את נתונים פעילות. אזהרה: לאחר הגדרת הנתונים, רק שעה סיום וסטטוס יכולים לערוך, אחרת לא ניתן לשנות.',
    de: 'Bitte konfigurieren Sie die Daten der Aktivität. Hinweis: Nach der Konfiguration können nur das Enddatum und der Status bearbeitet werden, andere Daten können nicht geändert werden.',
    es: 'Por favor, configure los datos de la actividad. Nota: Una vez configurada, solo se puede editar el tiempo de finalización y estado, otros datos no se pueden modificar.',
    ru: 'Пожалуйста, настройте данные активности. Примечание: После настройки можно только изменить время окончания и статус, другие данные нельзя изменять.',
    vi: 'Vui lòng cấu hình dữ liệu hoạt động. Lưu ý: Sau khi cấu hình, chỉ có thể chỉnh sửa thời gian kết thúc và trạng thái, các dữ liệu khác không thể sửa đổi.',
  },
  editActivityDesc: {
    zh_cn: '只能修改活动结束时间和状态，其他数据无法修改。',
    zhhant: '只能修改活動結束時間和狀態，其他數據無法修改。',
    en: 'Only the end time and status of the activity can be modified, other data cannot be modified.',
    he: 'רק שעה סיום וסטטוס יכולים לערוך, אחרת לא ניתן לשנות.',
    de: 'Nur das Enddatum und der Status können bearbeitet werden, andere Daten können nicht geändert werden.',
    es: 'Solo se puede editar el tiempo de finalización y estado, otros datos no se pueden modificar.',
    ru: 'Можно только изменить время окончания и статус, другие данные нельзя изменять.',
    vi: 'Chỉ có thể chỉnh sửa thời gian kết thúc và trạng thái, các dữ liệu khác không thể sửa đổi.',
  },
  selectDiscountAmountType: {
    zh_cn: '选择优惠金额类型',
    zhhant: '選擇優惠金額類型',
    en: 'Select discount amount type',
    he: 'בחר סכום מרבית',
    de: 'Wählen Sie Rabattbetrag',
    es: 'Seleccione el tipo de descuento',
    ru: 'Выберите тип скидки',
    vi: 'Chọn loại giảm giá',
  },
  thresholdAmount: {
    zh_cn: '门槛金额',
    zhhant: '門檻金額',
    en: 'Threshold amount',
    he: 'סכום מרבית',
    de: 'Schwellenwertbetrag',
    es: 'Monto de umbral',
    ru: 'Пороговое количество',
    vi: 'Số tiền lệnh',
  },
  discountsAmount: {
    zh_cn: '优惠金额',
    zhhant: '優惠金額',
    en: 'Discounts amount',
    he: 'סכום מרבית',
    de: 'Rabattbetrag',
    es: 'Monto de descuento',
    ru: 'Скидка на сумму',
    vi: 'Số tiền giảm giá',
  },
  proportionOfDiscount: {
    zh_cn: '优惠比例',
    zhhant: '優惠比例',
    en: 'Discount proportion',
    he: 'שיעור הנחה',
    de: 'Rabattquote',
    es: 'Tasa de descuento',
    ru: 'Ставка скидки',
    vi: 'Tỷ lệ giảm giá',
  },
  discountRate: {
    zh_cn: '优惠比例',
    en: 'Discount Rate',
    zhhant: '優惠比例',
    he: 'שיעור הנחה',
    de: 'Rabattquote',
    es: 'Tasa de descuento',
    ru: 'Ставка скидки',
    vi: 'Tỷ lệ giảm giá',
  },
  terminalChannelApp: {
    zh_cn: 'APP',
    zhhant: 'APP',
    en: 'APP',
    he: 'אפ',
    de: 'APP',
    es: 'APP',
    ru: 'APP',
    vi: 'APP',
  },
  terminalChannelHlht: {
    zh_cn: '互联互通',
    zhhant: '互联互通',
    en: 'Interoperability',
    he: 'אינטר-אופרטביליטי',
    de: 'Interoperabilität',
    es: 'Interoperabilidad',
    ru: 'Межвзаимодействие',
    vi: 'Tương thích lẫn nhau',
  },
  terminalChannelHomeApp: {
    zh_cn: '家用APP',
    zhhant: '家用APP',
    en: 'Home APP',
    he: 'אפ הבית',
    de: 'Heim-APP',
    es: 'Aplicación de casa',
    ru: 'Домашняя APP',
    vi: 'App nhà',
  },
  terminalChannelWechatMiniApp: {
    zh_cn: '微信小程序',
    zhhant: '微信小程序',
    en: 'Wechat Mini App',
    he: 'אפליקציה מינוי קיווית',
    de: 'WeChat-Kleine App',
    es: 'Aplicación de WeChat Mini',
    ru: 'Мини-приложение Wechat',
    vi: 'App Wechat Mini',
  },
  terminalChannelWechatService: {
    zh_cn: '微信服务号',
    zhhant: '微信服务号',
    en: 'Wechat Service',
    he: 'שירות קיווי',
    de: 'WeChat-Service',
    es: 'Servicio de WeChat',
    ru: 'Служба Wechat',
    vi: 'Dịch vụ Wechat',
  },
  terminalChannelAliMiniApp: {
    zh_cn: '支付宝小程序',
    zhhant: '支付宝小程序',
    en: 'Ali Mini App',
    he: 'אפליקציה מינוי אליפי',
    de: 'Ali-Kleine App',
    es: 'Aplicación de Ali Mini',
    ru: 'Мини-приложение Ali',
    vi: 'App Ali Mini',
  },
  homeSupportShowTypes: {
    zh_cn: '首页支持显示方式',
    zhhant: '首頁支持顯示方式',
    en: 'Home support display mode',
    he: 'מודל תצוגה נתן בבית',
    de: 'Startseite unterstützt Anzeigemodus',
    es: 'Modo de visualización de la página principal',
    ru: 'Режим отображения на главной странице',
    vi: 'Chế độ hiển thị trang chủ',
  },
  homeDefaultShowTypes: {
    zh_cn: '首页默认显示方式',
    zhhant: '首頁默認顯示方式',
    en: 'Home default display mode',
    he: 'מודל תצוגה בבית ברירת מחדל',
    de: 'Startseite Standard-Anzeigemodus',
    es: 'Modo de visualización predeterminado de la página principal',
    ru: 'Режим отображения по умолчанию на главной странице',
    vi: 'Chế độ hiển thị mặc định trang chủ',
  },
  homeSwitchShowTypes: {
    zh_cn: '首页切换显示方式',
    zhhant: '首頁切換顯示方式',
    en: 'Home switch display mode',
    he: 'מודל תצוגה בבית切換',
    de: 'Startseite Switch-Anzeigemodus',
    es: 'Modo de visualización de cambio en la página principal',
    ru: 'Режим отображения переключения на главной странице',
    vi: 'Chế độ hiển thị chuyển đổi trang chủ',
  },
  appname: {
    zh_cn: 'APP名称',
    en: 'App name',
    zhhant: 'APP名稱',
    he: 'שם אפ',
    de: 'App-Name',
    es: 'Nombre de la aplicación',
    ru: 'Имя приложения',
    vi: 'Tên ứng dụng',
  },
  unauthOperator: {
    zh_cn: '确认取消授权商户: ',
    zhhant: '確認取消授權商戶: ',
    en: 'Confirm to cancel merchant authorization: ',
    he: 'אשר לבטל אישור סוחר: ',
    de: 'Bestätigen Sie, dass Sie die Händlerautorisation widerrufen möchten: ',
    es: 'Confirme la cancelación de la autorización del comerciante: ',
    ru: 'Подтвердите отмену авторизации торговца: ',
    vi: 'Xác nhận hủy ủy quyền cho thương gia: ',
  },
  agencyOperation: {
    zh_cn: '托管运营',
    zhhant: '託管運營',
    en: 'Agency operation',
    he: 'פעולת סוכנות',
    de: 'Vertriebsoperation',
    es: 'Operación de la agencia',
    ru: 'Агентская операция',
    vi: 'Hoạt động đại lý',
  },
  disableOperatorOperationWarn: {
    zh_cn: '确认关闭托管运营？ 关闭后，原APP将会自动下架站点，请谨慎操作。',
    zhhant: '確認關閉託管運營？ 關閉後，原APP將會自動下架站點，請謹慎操作。',
    en: 'Confirm to close the agency operation? After closing, the original APP will automatically delist the site. Please operate carefully.',
    he: 'אשר לסגור את פעולת הסוכנות? לאחר סיום, האפליקציה המקורית ירשם באופן אוטומטי את האתר. אנא פעל בזהירות.',
    de: 'Bestätigen Sie die Schließung der Vertriebsoperation? Nach dem Schließen wird die ursprüngliche APP automatisch ausgelistet. Bitte vorsichtig arbeiten.',
    es: 'Confirme cerrar la operación de la  distribución? Después de cerrar, la aplicación original se registrará automáticamente en el sitio. Por favor, trabaje con cuidado.',
    ru: 'Подтвердите закрытие операции распространения? После закрытия будет автоматически зарегистрирована оригинальная приложение. Пожалуйста, работайте с осторожностью.',
    vi: 'Xác nhận đóng hoạt động đại lý? Sau khi đóng, ứng dụng gốc sẽ tự động hủy kê khai. Vui lòng vận hành cẩn thận.',
  },
  profitSharingPayee: {
    zh_cn: '清分收款人',
    zhhant: '清分收款人',
    en: 'Profit sharing payee',
    he: 'Payee שיתוף רווחים',
    de: 'Profit-Sharing Payee',
    es: 'Beneficiario de la división de beneficios',
    ru: 'Получатель доли выручки',
    vi: 'Người Nhận Tiền chia sẻ lợi nhuận',
  },
  profitSharingPayeeDataPermTip: {
    zh_cn: '仅分润管理员选择，其他管理员忽略此项',
    zhhant: '僅分潤管理員選擇，其他管理員忽略此項',
    en: 'Only profit sharing administrators select, other administrators ignore this item',
    he: 'רק מנהלי שיתוף רווחים בחר, מנהלים אחרים התעלמו מהפריט הזה',
    de: 'Nur Profit-Sharing-Administratoren wählen, andere Administratoren ignorieren dieses Element',
    es: 'Solo los administradores de la división de beneficios seleccionan, otros administradores ignoran este elemento',
    ru: 'Только администраторы по дoли выручки выбирают, другие администраторы игнорируют этот элемент',
    vi: 'Chỉ quản trị viên chia sẻ lợi nhuận chọn, các quản trị viên khác bỏ qua mục này',
  },
  payee: {
    zh_cn: '收款人',
    zhhant: '收款人',
    en: 'Payee',
    he: 'Payee',
    de: 'Payee',
    es: 'Payee',
    ru: 'Payee',
    vi: 'Người Nhận Tiền',
  },
  payeeid: {
    zh_cn: '收款人ID',
    zhhant: '收款人ID',
    en: 'Payee ID',
    he: 'Payee ID',
    de: 'Payee ID',
    es: 'Payee ID',
    ru: 'Payee ID',
    vi: 'ID Người Nhận Tiền',
  },
  addPayee: {
    zh_cn: '添加收款人',
    zhhant: '添加收款人',
    en: 'Add Payee',
    he: 'Add Payee',
    de: 'Add Payee',
    es: 'Add Payee',
    ru: 'Add Payee',
    vi: 'Thêm Người Nhận Tiền',
  },
  editPayee: {
    zh_cn: '编辑收款人',
    zhhant: '編輯收款人',
    en: 'Edit Payee',
    he: 'Edit Payee',
    de: 'Edit Payee',
    es: 'Edit Payee',
    ru: 'Edit Payee',
    vi: 'Chỉnh Sửa Người Nhận Tiền',
  },
  payeeType: {
    zh_cn: '收款人类型',
    zhhant: '收款人類型',
    en: 'Payee Type',
    he: 'Payee Type',
    de: 'Payee Type',
    es: 'Payee Type',
    ru: 'Payee Type',
    vi: 'Loại Người Nhận Tiền',
  },
  payeeName: {
    zh_cn: '收款人姓名',
    zhhant: '收款人姓名',
    en: 'Payee Name',
    he: 'Payee Name',
    de: 'Payee Name',
    es: 'Payee Name',
    ru: 'Payee Name',
    vi: 'Tên Người Nhận Tiền',
  },
  bankCardName: {
    zh_cn: '银行卡户名',
    zhhant: '銀行卡戶名',
    en: 'Bank Card Name',
    he: 'Bank Card Name',
    de: 'Bank Card Name',
    es: 'Bank Card Name',
    ru: 'Bank Card Name',
    vi: 'Tên Tài Khoản Ngân Hàng',
  },
  bankCard: {
    zh_cn: '银行卡号',
    zhhant: '銀行卡號',
    en: 'Bank Card',
    he: 'Bank Card',
    de: 'Bank Card',
    es: 'Bank Card',
    ru: 'Bank Card',
    vi: 'Số Thẻ Ngân Hàng',
  },
  bankCardType: {
    zh_cn: '银行卡类型',
    zhhant: '銀行卡類型',
    en: 'Bank Card Type',
    he: 'Bank Card Type',
    de: 'Bank Card Type',
    es: 'Bank Card Type',
    ru: 'Bank Card Type',
    vi: 'Loại Thẻ Ngân Hàng',
  },
  bankCode: {
    zh_cn: '银行代码',
    zhhant: '銀行代碼',
    en: 'Bank Code',
    he: 'Bank Code',
    de: 'Bank Code',
    es: 'Bank Code',
    ru: 'Bank Code',
    vi: 'Mã Thẻ Ngân Hàng',
  },
  bankCodeEG: {
    zh_cn: '例如: 工商银行代码: ICBC',
    zhhant: '例如: 工商銀行代碼: ICBC',
    en: 'For example: ICBC',
    he: 'For example: ICBC',
    de: 'For example: ICBC',
    es: 'For example: ICBC',
    ru: 'For example: ICBC',
    vi: 'Ví dụ: ICBC',
  },
  uniteBankId: {
    zh_cn: '银行支行代码',
    zhhant: '銀行支行代碼',
    en: 'Bank Sub-Branch Code',
    he: 'Bank Sub-Branch Code',
    de: 'Bank Sub-Branch Code',
    es: 'Bank Sub-Branch Code',
    ru: 'Bank Sub-Branch Code',
    vi: 'Mã Chi Nhánh Ngân Hàng',
  },
  bankCardMobile: {
    zh_cn: '银行卡预留手机号',
    zhhant: '銀行卡預留手機號',
    en: 'Bank Card Mobile',
    he: 'Bank Card Mobile',
    de: 'Bank Card Mobile',
    es: 'Bank Card Mobile',
    ru: 'Bank Card Mobile',
    vi: 'Số Điện Thoại Ngân Hàng',
  },
  isAudit: {
    zh_cn: '是否审核',
    zhhant: '是否審核',
    en: 'Is Audit',
    he: 'Is Audit',
    de: 'Is Audit',
    es: 'Is Audit',
    ru: 'Is Audit',
    vi: 'Đã Xác Minh',
  },
  isAdminProfit: {
    zh_cn: '支付渠道关联账号',
    zhhant: '支付渠道關聯賬號',
    en: 'Payment Channel Associated Account',
    he: 'Payment Channel Associated Account',
    de: 'Payment Channel Associated Account',
    es: 'Payment Channel Associated Account',
    ru: 'Payment Channel Associated Account',
    vi: 'Tài Khoản Liên Kết Kênh Thanh Toán',
  },
  enterprise: {
    zh_cn: '企业',
    zhhant: '企業',
    en: 'Enterprise',
    he: 'Enterprise',
    de: 'Enterprise',
    es: 'Enterprise',
    ru: 'Enterprise',
    vi: 'Công Ty',
  },
  private: {
    zh_cn: '个人',
    zhhant: '個人',
    en: 'Private',
    he: 'Private',
    de: 'Private',
    es: 'Private',
    ru: 'Private',
    vi: 'Cá Nhân',
  },
  privateEnterprise: {
    zh_cn: '个体户',
    zhhant: '個體戶',
    en: 'Private Enterprise',
    he: 'Private Enterprise',
    de: 'Private Enterprise',
    es: 'Private Enterprise',
    ru: 'Private Enterprise',
    vi: 'Cá Nhân',
  },
  debitCard: {
    zh_cn: '借记卡',
    zhhant: '借記卡',
    en: 'Debit Card',
    he: 'Debit Card',
    de: 'Debit Card',
    es: 'Debit Card',
    ru: 'Debit Card',
    vi: 'Thẻ Ghi Nợ',
  },
  creditCard: {
    zh_cn: '贷记卡',
    zhhant: '貸記卡',
    en: 'Credit Card',
    he: 'Credit Card',
    de: 'Credit Card',
    es: 'Credit Card',
    ru: 'Credit Card',
    vi: 'Thẻ Tín Dụng',
  },
  quasiCreditCard: {
    zh_cn: '准贷卡',
    zhhant: '准貸卡',
    en: 'Quasi Credit Card',
    he: 'Quasi Credit Card',
    de: 'Quasi Credit Card',
    es: 'Quasi Credit Card',
    ru: 'Quasi Credit Card',
    vi: 'Thẻ Tín Dụng',
  },
  passbook: {
    zh_cn: '存折',
    zhhant: '存折',
    en: 'Passbook',
    he: 'Passbook',
    de: 'Passbook',
    es: 'Passbook',
    ru: 'Passbook',
    vi: 'Sổ Tiền',
  },
  unitSettleCard: {
    zh_cn: '单位结算卡',
    zhhant: '單位結算卡',
    en: 'Unit Settle Card',
    he: 'Unit Settle Card',
    de: 'Unit Settle Card',
    es: 'Unit Settle Card',
    ru: 'Unit Settle Card',
    vi: 'Thẻ Kết Toán',
  },
  publicCard: {
    zh_cn: '对公卡',
    zhhant: '對公卡',
    en: 'Public Card',
    he: 'Public Card',
    de: 'Public Card',
    es: 'Public Card',
    ru: 'Public Card',
    vi: 'Thẻ Công Ty',
  },
  addStrategy: {
    zh_cn: '添加策略',
    zhhant: '添加策略',
    en: 'Add Strategy',
    he: 'Add Strategy',
    de: 'Add Strategy',
    es: 'Add Strategy',
    ru: 'Add Strategy',
    vi: 'Thêm Chiến Lược',
  },
  editStrategy: {
    zh_cn: '编辑策略',
    zhhant: '編輯策略',
    en: 'Edit Strategy',
    he: 'Edit Strategy',
    de: 'Edit Strategy',
    es: 'Edit Strategy',
    ru: 'Edit Strategy',
    vi: 'Chỉnh Sửa Chiến Lược',
  },
  electricAmount: {
    zh_cn: '电费',
    zhhant: '電費',
    en: 'Electric Amount',
    he: 'Electric Amount',
    de: 'Electric Amount',
    es: 'Electric Amount',
    ru: 'Electric Amount',
    vi: 'Tiền Điện',
  },
  serviceAmount: {
    zh_cn: '服务费',
    zhhant: '服務費',
    en: 'Service Amount',
    he: 'Service Amount',
    de: 'Service Amount',
    es: 'Service Amount',
    ru: 'Service Amount',
    vi: 'Phí Dịch Vụ',
  },
  totalAmount: {
    zh_cn: '总费用',
    zhhant: '總費用',
    en: 'Total Amount',
    he: 'Total Amount',
    de: 'Total Amount',
    es: 'Total Amount',
    ru: 'Total Amount',
    vi: 'Tổng Phí',
  },
  selectPayee: {
    zh_cn: '选择收款方',
    zhhant: '選擇收款方',
    en: 'Select Payee',
    he: 'Select Payee',
    de: 'Select Payee',
    es: 'Select Payee',
    ru: 'Select Payee',
    vi: 'Chọn Người Thanh Toán',
  },
  strategyOwer: {
    zh_cn: '策略拥有者',
    zhhant: '策略擁有者',
    en: 'Strategy Owner',
    he: 'Strategy Owner',
    de: 'Strategy Owner',
    es: 'Strategy Owner',
    ru: 'Strategy Owner',
    vi: 'Chủ Sở Hữu Chiến Lược',
  },
  profitSharingSource: {
    zh_cn: '分成来源',
    zhhant: '分成來源',
    en: 'Profit Sharing Source',
    he: 'Profit Sharing Source',
    de: 'Profit Sharing Source',
    es: 'Profit Sharing Source',
    ru: 'Profit Sharing Source',
    vi: 'Nguồn Phân Thành',
  },
  profitSharingConfig: {
    zh_cn: '分成配置',
    zhhant: '分成配置',
    en: 'Profit Sharing Config',
    he: 'Profit Sharing Config',
    de: 'Profit Sharing Config',
    es: 'Profit Sharing Config',
    ru: 'Profit Sharing Config',
    vi: 'Cấu Hình Phân Thành',
  },
  profitSharingPercentage: {
    zh_cn: '分成比例',
    zhhant: '分成比例',
    en: 'Profit Sharing Percentage',
    he: 'Profit Sharing Percentage',
    de: 'Profit Sharing Percentage',
    es: 'Profit Sharing Percentage',
    ru: 'Profit Sharing Percentage',
    vi: 'Tỷ Lệ Phân Thành',
  },
  profitSharingPercentageDesc: {
    zh_cn: '总分成比例和应为100%',
    zhhant: '總分成比例和應為100%',
    en: 'The total profit sharing percentage should be 100%.',
    he: 'The total profit sharing percentage should be 100%.',
    de: 'The total profit sharing percentage should be 100%.',
    es: 'The total profit sharing percentage should be 100%.',
    ru: 'The total profit sharing percentage should be 100%.',
    vi: 'Tổng tỷ lệ phân thưởng là 100%.',
  },
  strategyOwerDesc: {
    zh_cn:
      '用于收款分成金额之外的金额。 例如: 分成来源=服务费，策略拥有者=房东，则房东收到的金额为电费。',
    zhhant:
      '用於收款分成金額之外的金額。 例如: 分成來源=服務費，策略擁有者=房東，則房東收到的金額為電費。',
    en: 'Used for the amount of money other than the revenue sharing. For example, if profit sharing source is service fee and strategy owner is landlord, then the landlord will receive electric fee.',
    he: 'Used for the amount of money other than the revenue sharing. For example, if profit sharing source is service fee and strategy owner is landlord, then the landlord will receive electric fee.',
    de: 'Used for the amount of money other than the revenue sharing. For example, if profit sharing source is service fee and strategy owner is landlord, then the landlord will receive electric fee.',
    es: 'Used for the amount of money other than the revenue sharing. For example, if profit sharing source is service fee and strategy owner is landlord, then the landlord will receive electric fee.',
    ru: 'Used for the amount of money other than the revenue sharing. For example, if profit sharing source is service fee and strategy owner is landlord, then the landlord will receive electric fee.',
    vi: 'Dùng cho số tiền khác với số tiền chia sẻ lợi nhuận. Ví dụ: Nếu nguồn phân thưởng là phí dịch vụ và chủ sở hữu chiến lược là chủ nhà, thì chủ nhà sẽ nhận được tiền điện.',
  },
  strategyAuthMgr: {
    zh_cn: '策略授权管理',
    zhhant: '策略授權管理',
    en: 'Strategy Auth Manager',
    he: 'Strategy Auth Manager',
    de: 'Strategy Auth Manager',
    es: 'Strategy Auth Manager',
    ru: 'Strategy Auth Manager',
    vi: 'Quản Lý Ủy Quyền Chiến Lược',
  },
  authado: {
    zh_cn: '授权对象',
    zhhant: '授權對象',
    en: 'Authado',
    he: 'Authado',
    de: 'Authado',
    es: 'Authado',
    ru: 'Authado',
    vi: 'Người Thanh Toán',
  },
  unauthAdoConfirm: {
    zh_cn: '解除授权后, 站点将无法分成, 你确定要解除授权吗?',
    zhhant: '解除授權後, 站點將無法分成, 你確定要解除授權嗎?',
    en: 'After removing the authorization, the site will not be able to share profits. Are you sure you want to remove the authorization?',
    he: 'After removing the authorization, the site will not be able to share profits. Are you sure you want to remove the authorization?',
    de: 'After removing the authorization, the site will not be able to share profits. Are you sure you want to remove the authorization?',
    es: 'After removing the authorization, the site will not be able to share profits. Are you sure you want to remove the authorization?',
    ru: 'After removing the authorization, the site will not be able to share profits. Are you sure you want to remove the authorization?',
    vi: 'Sau khi xóa quyền ủy quyền, trang web sẽ không thể chia sẻ lợi nhuận. Bạn có chắc chắn muốn xóa quyền ủy quyền?',
  },
  allowFixedAmount: {
    zh_cn: '定额充电',
    zhhant: '定額充電',
    en: 'Fixed Amount',
    he: 'Fixed Amount',
    de: 'Fixed Amount',
    es: 'Fixed Amount',
    ru: 'Fixed Amount',
    vi: 'Số Tiền Cố Định',
  },
  fixedAmounts: {
    zh_cn: '定额充电金额列表',
    zhhant: '定額充電金額列表',
    en: 'Fixed Amount List',
    he: 'Fixed Amount List',
    de: 'Fixed Amount List',
    es: 'Fixed Amount List',
    ru: 'Fixed Amount List',
    vi: 'Danh Sách Số Tiền Cố Định',
  },
  fixedAmountsFormatError: {
    zh_cn: '定额充电金额格式错误. 例如: 1,2,3,4,5',
    zhhant: '定額充電金額格式錯誤. 例如: 1,2,3,4,5',
    en: 'Fixed Amount format error. For example: 1,2,3,4,5',
    he: 'Fixed Amount format error. For example: 1,2,3,4,5',
    de: 'Fixed Amount format error. For example: 1,2,3,4,5',
    es: 'Fixed Amount format error. For example: 1,2,3,4,5',
    ru: 'Fixed Amount format error. For example: 1,2,3,4,5',
  },
  fixedAmountsEmpty: {
    zh_cn: '定额充电金额列表为空',
    zhhant: '定額充電金額列表為空',
    en: 'Fixed Amount List is empty',
    he: 'Fixed Amount List is empty',
    de: 'Fixed Amount List is empty',
    es: 'Fixed Amount List is empty',
    ru: 'Fixed Amount List is empty',
    vi: 'Danh Sách Số Tiền Cố Định Trống',
  },
  paymentModeTypes: {
    zh_cn: '支付方式',
    zhhant: '支付方式',
    en: 'Payment Mode',
    he: 'Payment Mode',
    de: 'Payment Mode',
    es: 'Payment Mode',
    ru: 'Payment Mode',
    vi: 'Phương Thức Thanh Toán',
  },
  paymentMode: {
    zh_cn: '支付类型',
    zhhant: '支付類型',
    en: 'Payment Mode Type',
    he: 'Payment Mode Type',
    de: 'Payment Mode Type',
    es: 'Payment Mode Type',
    ru: 'Payment Mode Type',
    vi: 'Phương Thức Thanh Toán',
  },
  groundParking: {
    zh_cn: '地面停车场',
    zhhant: '地面停车场',
    en: 'Ground Parking',
    he: 'Ground Parking',
    de: 'Ground Parking',
    es: 'Ground Parking',
    ru: 'Ground Parking',
    vi: 'Bãi Đậu Xe Mặt Đất',
  },
  underGroundParking: {
    zh_cn: '地下停车场',
    zhhant: '地下停车场',
    en: 'Underground Parking',
    he: 'Underground Parking',
    de: 'Underground Parking',
    es: 'Underground Parking',
    ru: 'Underground Parking',
    vi: 'Bãi Đậu Xe Dưới Lòng Đất',
  },
  freeParking: {
    zh_cn: '免费停车',
    zhhant: '免費停車',
    en: 'Free Parking',
    he: 'Free Parking',
    de: 'Free Parking',
    es: 'Free Parking',
    ru: 'Free Parking',
    vi: 'Đậu Xe Miễn Phí',
  },
  freeParkingTimeLimit: {
    zh_cn: '限时免费停车',
    zhhant: '限時免費停車',
    en: 'Free Parking Time Limit',
    he: 'Free Parking Time Limit',
    de: 'Free Parking Time Limit',
    es: 'Free Parking Time Limit',
    ru: 'Free Parking Time Limit',
    vi: 'Giới Hạn Thời Gian Đậu Xe Miễn Phí',
  },
  paymentModeTypeDesc: {
    zh_cn: '空值时, 默认为使用钱包后付费启动充电',
    zhhant: '空值時, 默認為使用錢包後付費啟動充電',
    en: 'If empty, the default is to use wallet post-payment charging',
    he: 'If empty, the default is to use wallet post-payment charging',
    de: 'If empty, the default is to use wallet post-payment charging',
    es: 'If empty, the default is to use wallet post-payment charging',
    ru: 'If empty, the default is to use wallet post-payment charging',
    vi: 'Nếu để trống, mặc định là sử dụng thanh toán sau khi sạc với ví',
  },
  walletPayment: {
    zh_cn: '钱包支付',
    zhhant: '錢包支付',
    en: 'Wallet Payment',
    he: 'Wallet Payment',
    de: 'Wallet Payment',
    es: 'Wallet Payment',
    ru: 'Wallet Payment',
    vi: 'Thanh Toán Với Ví',
  },
  onlinePayment: {
    zh_cn: '即充即退',
    zhhant: '即充即退',
    en: 'Online Payment',
    he: 'Online Payment',
    de: 'Online Payment',
    es: 'Online Payment',
    ru: 'Online Payment',
    vi: 'Thanh Toán Trực Tuyến',
  },
  parkCode: {
    zh_cn: '停车场编码',
    zhhant: '停車場編碼',
    en: 'Park Code',
    he: 'Park Code',
    de: 'Park Code',
    es: 'Park Code',
    ru: 'Park Code',
    vi: 'Mã Bãi Đậu Xe',
  },
  abilityCode: {
    zh_cn: '能力编码',
    zhhant: '能力編碼',
    en: 'Ability Code',
    he: 'Ability Code',
    de: 'Ability Code',
    es: 'Ability Code',
    ru: 'Ability Code',
    vi: 'Mã Năng Lượng',
  },
  couponAmount: {
    zh_cn: '优惠金额(元)',
    zhhant: '優惠金額(元)',
    en: 'Coupon Amount',
    he: 'Coupon Amount',
    de: 'Coupon Amount',
    es: 'Coupon Amount',
    ru: 'Coupon Amount',
    vi: 'Số Tiền Khuyến Mãi',
  },
  couponTime: {
    zh_cn: '优惠时长(小时)',
    zhhant: '優惠時長(小時)',
    en: 'Coupon Time',
    he: 'Coupon Time',
    de: 'Coupon Time',
    es: 'Coupon Time',
    ru: 'Coupon Time',
    vi: 'Thời Gian Khuyến Mãi',
  },
  barrierGateCouponType: {
    zh_cn: '优惠类型',
    zhhant: '優惠類型',
    en: 'Coupon Type',
    he: 'Coupon Type',
    de: 'Coupon Type',
    es: 'Coupon Type',
    ru: 'Coupon Type',
    vi: 'Loại Khuyến Mãi',
  },
  barrierGateCouponTypeAmount: {
    zh_cn: '按金额减免',
    zhhant: '按金额减免',
    en: 'Amount Reduction',
    he: 'Amount Reduction',
    de: 'Amount Reduction',
    es: 'Amount Reduction',
    ru: 'Amount Reduction',
    vi: 'Giảm Giá Bằng Số Tiền',
  },
  barrierGateCouponTypeTime: {
    zh_cn: '按时间减免',
    zhhant: '按时间减免',
    en: 'Time Reduction',
    he: 'Time Reduction',
    de: 'Time Reduction',
    es: 'Time Reduction',
    ru: 'Time Reduction',
    vi: 'Giảm Giá Bằng Thời Gian',
  },
  barrierGateCouponTypeFree: {
    zh_cn: '免费停车',
    zhhant: '免費停車',
    en: 'Free Parking',
    he: 'Free Parking',
    de: 'Free Parking',
    es: 'Free Parking',
    ru: 'Free Parking',
    vi: 'Đậu Xe Miễn Phí',
  },
  tradeFeePercentage: {
    zh_cn: '交易费率(%)',
    zhhant: '交易費率(%)',
    en: 'Trade Fee Percentage',
    he: 'Trade Fee Percentage',
    de: 'Trade Fee Percentage',
    es: 'Trade Fee Percentage',
    ru: 'Trade Fee Percentage',
    vi: 'Phí Giao Dịch',
  },
  tradeFeePercentageDesc: {
    zh_cn: '交易费率, 默认0.6%. 如需修改, 请求联系管理员。',
    zhhant: '交易费率, 默認0.6%. 如需修改, 请求聯繫管理員。',
    en: 'Trade Fee Percentage, default 0.6%. If you need to modify, please request the administrator.',
    he: 'Trade Fee Percentage, default 0.6%. If you need to modify, please request the administrator.',
    de: 'Trade Fee Percentage, default 0.6%. If you need to modify, please request the administrator.',
    es: 'Trade Fee Percentage, default 0.6%. If you need to modify, please request the administrator.',
    ru: 'Trade Fee Percentage, default 0.6%. If you need to modify, please request the administrator.',
    vi: 'Phí Giao Dịch, mặc định là 0.6%. Nếu cần sửa đổi, vui lòng yêu cầu quản trị viên.',
  },
  withdrawFee: {
    zh_cn: '提现手续费(元)',
    zhhant: '提現手續費(元)',
    en: 'Withdraw Fee',
    he: 'Withdraw Fee',
    de: 'Withdraw Fee',
    es: 'Withdraw Fee',
    ru: 'Withdraw Fee',
    vi: 'Phí Rút Tiền',
  },
  withdrawFeeDesc: {
    zh_cn: '提现手续费最小为1元',
    zhhant: '提現手續費最小為1元',
    en: 'Withdraw Fee minimum is 1 yuan',
    he: 'Withdraw Fee minimum is 1 yuan',
    de: 'Withdraw Fee minimum is 1 yuan',
    es: 'Withdraw Fee minimum is 1 yuan',
    ru: 'Withdraw Fee minimum is 1 yuan',
    vi: 'Phí Rút Tiền tối thiểu là 1',
  },
  minWithdrawAmount: {
    zh_cn: '最小提现金额(元)',
    zhhant: '最小提現金額(元)',
    en: 'Min Withdraw Amount',
    he: 'Min Withdraw Amount',
    de: 'Min Withdraw Amount',
    es: 'Min Withdraw Amount',
    ru: 'Min Withdraw Amount',
    vi: 'Số Tiền Rút Tối Thiểu',
  },
  minWithdrawAmountDesc: {
    zh_cn: '最小提现金额最小是2元且需大于提现手续费。',
    zhhant: '最小提現金額最小是2元且需大於提現手續費。',
    en: 'Min Withdraw Amount minimum is 2 yuan and must be greater than the withdraw fee.',
    he: 'Min Withdraw Amount minimum is 2 yuan and must be greater than the withdraw fee.',
    de: 'Min Withdraw Amount minimum is 2 yuan and must be greater than the withdraw fee.',
    es: 'Min Withdraw Amount minimum is 2 yuan and must be greater than the withdraw fee.',
    ru: 'Min Withdraw Amount minimum is 2 yuan and must be greater than the withdraw fee.',
    vi: 'Số Tiền Rút Tối Thiểu tối thiểu là 2 và phải lớn hơn phí rút tiền.',
  },
  selectOperatorPleace: {
    zh_cn: '请选择运营商',
    zhhant: '請選擇運營商',
    en: 'Please select an operator',
    he: 'Please select an operator',
    de: 'Please select an operator',
    es: 'Please select an operator',
    ru: 'Please select an operator',
    vi: 'Vui Lòng Chọn Một Nhà Cung Cấp Dịch Vụ',
  },
  selectOperatorOrStation: {
    zh_cn: '请选择运营商或站点',
    zhhant: '請選擇運營商或站點',
    en: 'Please select an operator or station',
    he: 'Please select an operator or station',
    de: 'Please select an operator or station',
    es: 'Please select an operator or station',
    ru: 'Please select an operator or station',
    vi: 'Vui lòng chọn nhà cung cấpdịch vụ hoặc trạm',
  },
  genFail: {
    zh_cn: '生成失败, 请重试',
    zhhant: '生成失敗, 請重試',
    en: 'Generation failed, please try again',
    he: 'Generation failed, please try again',
    de: 'Generation failed, please try again',
    es: 'Generation failed, please try again',
    ru: 'Generation failed, please try again',
    vi: 'Không Thể Tạo, Vui Lòng Thử Lại',
  },
  createEvseByScan: {
    zh_cn: '扫码创建充电桩',
    zhhant: '掃碼創建充電樁',
    en: 'Scan QR code to create EVSE',
    he: 'Scan QR code to create EVSE',
    de: 'Scan QR code to create EVSE',
    es: 'Scan QR code to create EVSE',
    ru: 'Scan QR code to create EVSE',
    vi: 'Quét Mã QR để Tạo Cột Sạc',
  },
  smsProvider: {
    zh_cn: '短信服务商',
    zhhant: '簡訊服務商',
    en: 'SMS Provider',
    he: 'SMS Provider',
    de: 'SMS Provider',
    es: 'SMS Provider',
    ru: 'SMS Provider',
    vi: 'Nhà Cung Cấp Dịch Vụ SMS',
  },
  aliProviderISO: {
    zh_cn: '阿里国际服务商',
    zhhant: '阿里國際服務商',
    en: 'Ali International Provider',
    he: 'Ali International Provider',
    de: 'Ali International Provider',
    es: 'Ali International Provider',
    ru: 'Ali International Provider',
    vi: 'Nhà Cung Cấp Dịch Vụ Quốc Tế Ali',
  },
  wxProvider: {
    zh_cn: '腾讯服务商',
    zhhant: '騰訊服務商',
    en: 'Tencent Provider',
    he: 'Tencent Provider',
    de: 'Tencent Provider',
    es: 'Tencent Provider',
    ru: 'Tencent Provider',
    vi: 'Nhà Cung Cấp Dịch Vụ Tencent',
  },
  signName: {
    zh_cn: '签名名称',
    zhhant: '簽名名稱',
    en: 'Sign Name',
    he: 'Sign Name',
    de: 'Sign Name',
    es: 'Sign Name',
    ru: 'Sign Name',
    vi: 'Tên Ký',
  },
  commTmplId: {
    zh_cn: '通用模板ID',
    zhhant: '通用模板ID',
    en: 'Common Template ID',
    he: 'Common Template ID',
    de: 'Common Template ID',
    es: 'Common Template ID',
    ru: 'Common Template ID',
    vi: 'ID Mẫu Thông Dụng',
  },
  hlht: {
    zh_cn: '互联互通(标准)',
    zhhant: '互聯互通(標準)',
    en: 'Interoperability (Standard)',
    he: 'Interoperability (Standard)',
    de: 'Interoperability (Standard)',
    es: 'Interoperability (Standard)',
    ru: 'Interoperability (Standard)',
    vi: 'Liên Kết Hỗ Trợ (Tiêu Chuẩn)',
  },
  ltyOpen: {
    zh_cn: '路通云停',
    zhhant: '路通雲停',
    en: 'Lutong Cloud Parking',
    he: 'Lutong Cloud Parking',
    de: 'Lutong Cloud Parking',
    es: 'Lutong Cloud Parking',
    ru: 'Lutong Cloud Parking',
    vi: 'Đỗ Xe Lưu Động Cloud',
  },
  hlhtsz: {
    zh_cn: '互联互通(深圳)',
    zhhant: '互聯互通(深圳)',
    en: 'Interoperability (Shenzhen)',
    he: 'Interoperability (Shenzhen)',
    de: 'Interoperability (Shenzhen)',
    es: 'Interoperability (Shenzhen)',
    ru: 'Interoperability (Shenzhen)',
    vi: 'Liên Kết Hỗ Trợ (Thành Phố Thâm Quyến)',
  },
  hlhtjx: {
    zh_cn: '互联互通(江西)',
    zhhant: '互聯互通(江西)',
    en: 'Interoperability (Jiangxi)',
    he: 'Interoperability (Jiangxi)',
    de: 'Interoperability (Jiangxi)',
    es: 'Interoperability (Jiangxi)',
    ru: 'Interoperability (Jiangxi)',
    vi: 'Liên Kết Hỗ Trợ (Tỉnh Giang Tây)',
  },
  amap: {
    zh_cn: '高德地图',
    zhhant: '高德地圖',
    en: 'Amap',
    he: 'Amap',
    de: 'Amap',
    es: 'Amap',
    ru: 'Amap',
    vi: 'Bản Đồ Gaode',
  },
  hlhtsh: {
    zh_cn: '互联互通(国网上海)',
    zhhant: '互聯互通(國網上海)',
    en: 'Interoperability (State Grid Shanghai)',
    he: 'Interoperability (State Grid Shanghai)',
    de: 'Interoperability (State Grid Shanghai)',
    es: 'Interoperability (State Grid Shanghai)',
    ru: 'Interoperability (State Grid Shanghai)',
    vi: 'Liên Kết Hỗ Trợ (Lưới Quốc Gia Thành Phố Thượng Hải)',
  },
  ali: {
    zh_cn: '支付宝(蚂蚁链)',
    zhhant: '支付寶(螞蟻鏈)',
    en: 'Alipay (Ant Chain)',
    he: 'Alipay (Ant Chain)',
    de: 'Alipay (Ant Chain)',
    es: 'Alipay (Ant Chain)',
    ru: 'Alipay (Ant Chain)',
    vi: 'Alipay (Chuỗi Mèo)',
  },
  jsopen: {
    zh_cn: '捷顺开放平台',
    zhhant: '捷順開放平台',
    en: 'Jieshun Open Platform',
    he: 'Jieshun Open Platform',
    de: 'Jieshun Open Platform',
    es: 'Jieshun Open Platform',
    ru: 'Jieshun Open Platform',
    vi: 'Nền Tảng Mở Jieshun',
  },
  bgc: {
    zh_cn: '互联互通(八桂充)',
    zhhant: '互聯互通(八桂充)',
    en: 'Interoperability (Baguichong)',
    he: 'Interoperability (Baguichong)',
    de: 'Interoperability (Baguichong)',
    es: 'Interoperability (Baguichong)',
    ru: 'Interoperability (Baguichong)',
    vi: 'Liên Kết Hỗ Trợ (Baguichong)',
  },
  nmg: {
    zh_cn: '互联互通(内蒙古)',
    zhhant: '互聯互通(內蒙古)',
    en: 'Interoperability (Inner Mongolia)',
    he: 'Interoperability (Inner Mongolia)',
    de: 'Interoperability (Inner Mongolia)',
    es: 'Interoperability (Inner Mongolia)',
    ru: 'Interoperability (Inner Mongolia)',
    vi: 'Liên Kết Hỗ Trợ (Nội Mông Cổ)',
  },
  xdt: {
    zh_cn: '互联互通(新电途)',
    zhhant: '互聯互通(新電途)',
    en: 'Interoperability (New Electricity)',
    he: 'Interoperability (New Electricity)',
    de: 'Interoperability (New Electricity)',
    es: 'Interoperability (New Electricity)',
    ru: 'Interoperability (New Electricity)',
    vi: 'Liên Kết Hỗ Trợ (Điện Mới)',
  },

  alihome: {
    zh_cn: '家充(支付宝)',
    zhhant: '家充(支付宝)',
    en: 'Home Charge (Alipay)',
    he: 'Home Charge (Alipay)',
    de: 'Home Charge (Alipay)',
    es: 'Home Charge (Alipay)',
    ru: 'Home Charge (Alipay)',
    vi: 'Home Charge (Alipay)',
  },
  alihlht: {
    zh_cn: '互联互通(支付宝)',
    zhhant: '互聯互通(支付宝)',
    en: 'Interoperability (Alipay)',
    he: 'Interoperability (Alipay)',
    de: 'Interoperability (Alipay)',
    es: 'Interoperability (Alipay)',
    ru: 'Interoperability (Alipay)',
    vi: 'Liên Kết Hỗ Trợ (Alipay)',
  },
  addHlhtConfig: {
    zh_cn: '创建互联互通配置',
    zhhant: '創建互聯互通配置',
    en: 'Create Interoperability Configuration',
    he: 'Create Interoperability Configuration',
    de: 'Create Interoperability Configuration',
    es: 'Create Interoperability Configuration',
    ru: 'Create Interoperability Configuration',
    vi: 'Tạo Cấu Hình Liên Kết Hỗ Trợ',
  },
  editHlhtConfig: {
    zh_cn: '编辑互联互通配置',
    zhhant: '編輯互聯互通配置',
    en: 'Edit Interoperability Configuration',
    he: 'Edit Interoperability Configuration',
    de: 'Edit Interoperability Configuration',
    es: 'Edit Interoperability Configuration',
    ru: 'Edit Interoperability Configuration',
    vi: 'Chỉnh Sửa Cấu Hình Liên Kết Hỗ Trợ',
  },
  ourConfig: {
    zh_cn: '我方配置',
    zhhant: '我方配置',
    en: 'Our Configuration',
    he: 'Our Configuration',
    de: 'Our Configuration',
    es: 'Our Configuration',
    ru: 'Our Configuration',
    vi: 'Cấu Hình Của Chúng Tôi',
  },
  tpConfig: {
    zh_cn: '对方配置',
    zhhant: '對方配置',
    en: 'Their Configuration',
    he: 'Their Configuration',
    de: 'Their Configuration',
    es: 'Their Configuration',
    ru: 'Their Configuration',
    vi: 'Cấu Hình Của Bên Ngang',
  },
  hlhtOperatorID: {
    zh_cn: '运营商标识',
    zhhant: '運營商標識',
    en: 'Operator ID',
    he: 'Operator ID',
    de: 'Operator ID',
    es: 'Operator ID',
    ru: 'Operator ID',
    vi: 'ID Nhà Mạng',
  },
  hlhtOperatorSecret: {
    zh_cn: '运营商密钥',
    zhhant: '運營商密鑰',
    en: 'Operator Secret',
    he: 'Operator Secret',
    de: 'Operator Secret',
    es: 'Operator Secret',
    ru: 'Operator Secret',
    vi: 'Bí Mật Nhà Mạng',
  },
  hlhtDataSecret: {
    zh_cn: '数据密钥',
    zhhant: '數據密鑰',
    en: 'Data Secret',
    he: 'Data Secret',
    de: 'Data Secret',
    es: 'Data Secret',
    ru: 'Data Secret',
    vi: 'Bí Mật Dữ Liệu',
  },
  hlhtDataSecretIV: {
    zh_cn: '数据密钥IV',
    zhhant: '數據密鑰IV',
    en: 'Data Secret IV',
    he: 'Data Secret IV',
    de: 'Data Secret IV',
    es: 'Data Secret IV',
    ru: 'Data Secret IV',
    vi: 'Bí Mật Dữ Liệu IV',
  },
  hlhtSigSecret: {
    zh_cn: '签名密钥',
    zhhant: '簽名密鑰',
    en: 'Signature Secret',
    he: 'Signature Secret',
    de: 'Signature Secret',
    es: 'Signature Secret',
    ru: 'Signature Secret',
    vi: 'Bí Mật Chữ Ký',
  },
  hlhtURL: {
    zh_cn: '访问地址',
    zhhant: '訪問地址',
    en: 'Access URL',
    he: 'Access URL',
    de: 'Access URL',
    es: 'Access URL',
    ru: 'Access URL',
    vi: 'Địa Chỉ Truy Cập',
  },
  hlhtAuthList: {
    zh_cn: '授权列表',
    zhhant: '授權列表',
    en: 'Authorization List',
    he: 'Authorization List',
    de: 'Authorization List',
    es: 'Authorization List',
    ru: 'Authorization List',
    vi: 'Danh Sách Ủy Quyền',
  },

  confirmDeleteConfig: {
    zh_cn: '确认删除配置?',
    zhhant: '確認刪除配置?',
    en: 'Confirm Delete Configuration?',
    he: 'Confirm Delete Configuration?',
    de: 'Confirm Delete Configuration?',
    es: 'Confirm Delete Configuration?',
    ru: 'Confirm Delete Configuration?',
    vi: 'Xác Nhận Xóa Cấu Hình?',
  },
  confirmRefreshToken: {
    zh_cn: '确认刷新Token?',
    zhhant: '確認刷新Token?',
    en: 'Confirm Refresh Token?',
    he: 'Confirm Refresh Token?',
    de: 'Confirm Refresh Token?',
    es: 'Confirm Refresh Token?',
    ru: 'Confirm Refresh Token?',
    vi: 'Xác Nhận Làm Mới Token?',
  },
  refreshToken: {
    zh_cn: '刷新Token',
    zhhant: '刷新Token',
    en: 'Refresh Token',
    he: 'Refresh Token',
    de: 'Refresh Token',
    es: 'Refresh Token',
    ru: 'Refresh Token',
    vi: 'Làm Mới Token',
  },
  hlhtSyncTip: {
    zh_cn: '同步商户下所有站点，便于第三方查询商户站点信息, 首次添加商户时使用，后续无需重复同步。',
    zhhant:
      '同步商戶下所有站點，便於第三方查詢商戶站點信息, 首次添加商戶時使用，後續無需重復同步。',
    en: 'Synchronize all merchant sites under the merchant to facilitate third-party query of merchant site information. Use it for adding a new merchant initially, and no need to synchronize repeatedly thereafter.',
    he: 'Synchronize all merchant sites under the merchant to facilitate third-party query of merchant site information. Use it for adding a new merchant initially, and no need to synchronize repeatedly thereafter.',
    de: 'Synchronize all merchant sites under the merchant to facilitate third-party query of merchant site information. Use it for adding a new merchant initially, and no need to synchronize repeatedly thereafter.',
    es: 'Synchronize all merchant sites under the merchant to facilitate third-party query of merchant site information. Use it for adding a new merchant initially, and no need to synchronize repeatedly thereafter.',
    ru: 'Synchronize all merchant sites under the merchant to facilitate third-party query of merchant site information. Use it for adding a new merchant initially, and no need to synchronize repeatedly thereafter.',
    vi: 'Đồng Bộ Tất Cả Các Trang Web Thương Mại Dưới Thương Mại Để Tiện Cho Bên Thứ Ba Tra Cứu Thông Tin Trang Web Thương Mại. Sử Dụng Nó Để Thêm Mới Thương Mại Ban Đầu, Và Không Cần Đồng Bộ Lặp Lại Sau.',
  },
  hlhtCacheTip: {
    zh_cn:
      '缓存配置下的所有站点信息，加速第三方查询商户站点信息。平台也会自动缓存站点信息, 可选操作。',
    zhhant:
      '緩存配置下的所有站點信息，加速第三方查詢商戶站點信息。平臺也會自動緩存站點信息, 可選操作。',
    en: 'Cache all site information under the configuration to accelerate third-party query of merchant site information. The platform will also automatically cache site information, optional operation.',
    he: 'Cache all site information under the configuration to accelerate third-party query of merchant site information. The platform will also automatically cache site information, optional operation.',
    de: 'Cache all site information under the configuration to accelerate third-party query of merchant site information. The platform will also automatically cache site information, optional operation.',
    es: 'Cache all site information under the configuration to accelerate third-party query of merchant site information. The platform will also automatically cache site information, optional operation.',
    ru: 'Cache all site information under the configuration to accelerate third-party query of merchant site information. The platform will also automatically cache site information, optional operation.',
    vi: 'Đệm Tất Cả Thông Tin Trang Web Dưới Cấu Hình Để Tăng Tốc Tra Cứu Trang Web Thương Mại Bởi Bên Thứ Ba. Nền Tảng Cũng Sẽ Tự Động Lưu Vào Cache Thông Tin Trang Web, Hoạt Động Tùy Chọn.',
  },
  hlhtURLTip: {
    zh_cn: 'URL不填时,系统内部将会自动生成',
    zhhant: 'URL不填時,系統內部將會自動生成',
    en: 'When URL is not filled, the system will automatically generate it internally',
    he: 'When URL is not filled, the system will automatically generate it internally',
    de: 'When URL is not filled, the system will automatically generate it internally',
    es: 'When URL is not filled, the system will automatically generate it internally',
    ru: 'When URL is not filled, the system will automatically generate it internally',
    vi: 'Khi Không Điền URL, Hệ Thống Sẽ Tự Động Tạo Nó',
  },
  hlhtSettlementId: {
    zh_cn: '结算账号ID',
    zhhant: '結算賬號ID',
    en: 'Settlement Account ID',
    he: 'Settlement Account ID',
    de: 'Settlement Account ID',
    es: 'Settlement Account ID',
    ru: 'Settlement Account ID',
    vi: 'ID Tài Khoản Kết Toán',
  },
  hlhtOperatingCompanyId: {
    zh_cn: '企业税号',
    zhhant: '企業稅號',
    en: 'Enterprise Tax Number',
    he: 'Enterprise Tax Number',
    de: 'Enterprise Tax Number',
    es: 'Enterprise Tax Number',
    ru: 'Enterprise Tax Number',
    vi: 'Số Thuế Của Doanh Nghiệp',
  },
  hlhtOperatingCompanyName: {
    zh_cn: '企业名称',
    zhhant: '企業名稱',
    en: 'Enterprise Name',
    he: 'Enterprise Name',
    de: 'Enterprise Name',
    es: 'Enterprise Name',
    ru: 'Enterprise Name',
    vi: 'Tên Doanh Nghiệp',
  },
  hlhtPushAllTip: {
    zh_cn: '推送所有站点信息到第三方',
    zhhant: '推送到所有站點信息到第三方',
    en: 'Push all site information to third parties',
    he: 'Push all site information to third parties',
    de: 'Push all site information to third parties',
    es: 'Push all site information to third parties',
    ru: 'Push all site information to third parties',
    vi: 'Đẩy Tất Cả Thông Tin Trang Web Đến Bên Thứ Ba',
    ja: '全てのサイト情報を第三者へプッシュ',
  },
  confirmPush: {
    zh_cn: '确认推送？',
    zhhant: '確認推送？',
    en: 'Confirm push?',
    he: 'Confirm push?',
    de: 'Confirm push?',
    es: 'Confirm push?',
    ru: 'Confirm push?',
    vi: 'Xác Nhận Đẩy?',
  },
  domainDesc: {
    zh_cn: '配置访问域名, 主要用于客户端方法校验, 以及设备二维码生成。',
    zhhant: '配置訪問域名, 主要用於客戶端方法校驗, 以及設備二維碼生成。',
    en: 'Configure the access domain name, mainly used for client method verification and device QR code generation.',
    he: 'Configure the access domain name, mainly used for client method verification and device QR code generation.',
    de: 'Configure the access domain name, mainly used for client method verification and device QR code generation.',
    es: 'Configure the access domain name, mainly used for client method verification and device QR code generation.',
    ru: 'Configure the access domain name, mainly used for client method verification and device QR code generation.',
    vi: 'Cấu Hình Tên Miền Truy Cập, Chủ Yếu Dùng Cho Xác Minh Phương Thức Khách Hàng Và Tạo Mã QR Thiết Bị.',
  },
  operatorName: {
    zh_cn: '运营商名称',
    zhhant: '运营商名称',
    en: 'Operator Name',
    he: 'Operator Name',
    de: 'Operator Name',
    es: 'Operator Name',
    ru: 'Operator Name',
    vi: 'Tên Nhà Mạng',
  },
  evseOperatorName: {
    zh_cn: '设备运营商名称',
    zhhant: '設備运营商名稱',
    en: 'EVSE Operator Name',
    he: 'EVSE Operator Name',
    de: 'EVSE Operator Name',
    es: 'EVSE Operator Name',
    ru: 'EVSE Operator Name',
    vi: 'Tên Nhà Mạng Điện Tử',
  },
  type: {
    zh_cn: '组类型',
    zhhant: '組類型',
    en: 'Type',
    he: 'Type',
    de: 'Type',
    es: 'Type',
    ru: 'Type',
    vi: 'Loại',
  },
  name: {
    zh_cn: '名字',
    zhhant: '名字',
    en: 'Name',
    he: 'Name',
    de: 'Name',
    es: 'Name',
    ru: 'Name',
    vi: 'Tên',
  },
  balance: {
    zh_cn: '余额',
    zhhant: '餘額',
    en: 'Balance',
    he: 'Balance',
    de: 'Balance',
    es: 'Balance',
    ru: 'Balance',
    vi: 'Số Dư',
  },
  priceTip: {
    zh_cn: '深谷时间段使用前，需要确定设备是否支持!!!',
    zhhant: '深谷時間段使用前，需要確定設備是否支持!!!',
    en: 'Before using the deep valley period, you need to determine whether the device supports it!!!',
    he: 'לפני שימוש בתקופת הגבעול, אתה צריך לקבוע אם המכשיר תומך!!!',
    de: 'Bevor Sie die Tiefenvalley-Periode verwenden, müssen Sie bestimmen, ob das Gerät es unterstützt!!!',
    es: 'Antes de usar el período de valle profundo, ¡¡¡debes determinar si el dispositivo es compatible!!!',
    ru: 'Перед использованием глубокого долинарного периода, вам нужно определить, поддерживает ли устройство это!!!',
    vi: 'Trước khi sử dụng giai đoạn thung lũng sâu, bạn cần xác định thiết bị có hỗ trợ không!!!',
  },
  elecPriceDiscount: {
    zh_cn: '电价折扣',
    zhhant: '电价折扣',
    en: 'Elec Price Discount',
    he: 'Elec Price Discount',
    de: 'Elec Price Discount',
    es: 'Elec Price Discount',
    ru: 'Elec Price Discount',
    vi: 'Giá Điện Tử',
  },
  servicePriceDiscount: {
    zh_cn: '服务费折扣',
    zhhant: '服务费折扣',
    en: 'Service Price Discount',
    he: 'Service Price Discount',
    de: 'Service Price Discount',
    es: 'Service Price Discount',
    ru: 'Service Price Discount',
    vi: 'Giá Dịch Vụ',
  },
  elecPriceDiscountInfo: {
    zh_cn: '输入0～1,例如0.85代表85折',
    zhhant: '输入0～1,例如0.85代表85折',
    en: 'enter 0~1, e.g. 0.85 means 15% off',
    he: 'הזן 0~1, לדוגמה 0.85 פירושו הנחה של 15%',
    de: '0~1 eingeben, z.B. 0,85 bedeutet 15% Rabatt',
    es: 'ingrese 0~1, por ejemplo, 0.85 significa 15% de descuento',
    ru: 'ведите 0~1, например, 0.85 означает скидку 15%',
    vi: 'hập 0~1, ví dụ 0.85 có nghĩa là giảm 15%',
  },
  servicePriceDiscountInfo: {
    zh_cn: '输入0～1,例如0.85代表85折',
    zhhant: '输入0～1,例如0.85代表85折',
    en: 'enter 0~1, e.g. 0.85 means 15% off',
    he: 'הזן 0~1, לדוגמה 0.85 פירושו הנחה של 15%',
    de: '0~1 eingeben, z.B. 0,85 bedeutet 15% Rabatt',
    es: 'ingrese 0~1, por ejemplo, 0.85 significa 15% de descuento',
    ru: 'введите 0~1, например, 0.85 означает скидку 15%',
    vi: 'nhập 0~1, ví dụ 0.85 có nghĩa là giảm 15%',
  },
  rechargeInquiryInfo: {
    zh_cn: '账号余额低于20元,无法启动充电',
    zhhant: '賬號餘額低於20元,無法啟動充電',
    en: 'Account balance is less than 20 yuan, cannot start charging',
    he: 'יתרת החשבון נמוכה מ-20 יואן, לא ניתן להתחיל טעינה',
    de: 'Kontostand ist weniger als 20 Yuan, Laden kann nicht gestartet werden',
    es: 'El saldo de la cuenta es inferior a 20 yuan, no se puede iniciar la carga',
    ru: 'Баланс счета менее 20 юаней, зарядка невозможна',
    vi: 'Số dư tài khoản dưới 20 tệ, không thể bắt đầu sạc',
  },
  GT_Enterprise: {
    zh_cn: '企业组',
    zhhant: '企業組',
    en: 'Enterprise Group',
    he: 'Enterprise Group',
    de: 'Enterprise Group',
    es: 'Enterprise Group',
    ru: 'Enterprise Group',
    vi: 'Nhóm Công Ty',
  },
  GT_Pricing: {
    zh_cn: '计费组',
    zhhant: '計費組',
    en: 'Pricing Group',
    he: 'Pricing Group',
    de: 'Pricing Group',
    es: 'Pricing Group',
    ru: 'Pricing Group',
    vi: 'Nhóm Đánh Giá',
  },
  stationName: {
    zh_cn: '站点名称',
    en: 'Station Name',
    zhhant: '站點名稱',
    he: 'שם תחנה',
    de: 'Stationsname',
    es: 'Nombre de la estación',
    ru: 'Название станции',
    vi: 'Tên trạm',
  },
  whetherDelGroupMember: {
    zh_cn: '是否要删除改群组成员',
    zhhant: '是否要刪除改群組成員',
    en: 'Whether to delete the group member',
    he: 'Whether to delete the group member',
    de: 'Whether to delete the group member',
    es: 'Whether to delete the group member',
    ru: 'Whether to delete the group member',
    vi: 'Có Không Xóa Thành Viên Nhóm',
  },
  groupAuthStation: {
    zh_cn: '群组授权站点',
    zhhant: '群組授權站點',
    en: 'Group Authorized Station',
    he: 'Group Authorized Station',
    de: 'Group Authorized Station',
    es: 'Group Authorized Station',
    ru: 'Group Authorized Station',
    vi: 'Nhóm Đã Tự Động Cấp Thẩm Quyền',
  },
  groupMember: {
    zh_cn: '群组成员',
    zhhant: '群組成員',
    en: 'Group Member',
    he: 'Group Member',
    de: 'Group Member',
    es: 'Group Member',
    ru: 'Group Member',
    vi: 'Thành Viên Nhóm',
  },
  adoFlag: {
    zh_cn: '信息',
    zhhant: '信息',
    en: 'Information',
    he: 'Information',
    de: 'Information',
    es: 'Information',
    ru: 'Information',
    vi: 'Thông Tin',
  },
  whetherDelGroupStation: {
    zh_cn: '是否要删除改群组站点',
    zhhant: '是否要刪除改群組站點',
    en: 'Whether to delete the group station',
    he: 'Whether to delete the group station',
    de: 'Whether to delete the group station',
    es: 'Whether to delete the group station',
    ru: 'Whether to delete the group station',
    vi: 'Có Không Xóa Trạm Nhóm',
  },
  managerName: {
    zh_cn: '管理员名称',
    zhhant: '管理員名稱',
    en: 'Manager Name',
    he: 'Manager Name',
    de: 'Manager Name',
    es: 'Manager Name',
    ru: 'Manager Name',
    vi: 'Tên Quản Lý',
  },
  amount: {
    zh_cn: '金额',
    zhhant: '金額',
    en: 'Amount',
    he: 'Amount',
    de: 'Amount',
    es: 'Amount',
    ru: 'Amount',
    vi: 'Số Tiền',
  },
  transactionType: {
    zh_cn: '交易类型',
    zhhant: '交易類型',
    en: 'Transaction Type',
    he: 'Transaction Type',
    de: 'Transaction Type',
    es: 'Transaction Type',
    ru: 'Transaction Type',
    vi: 'Loại Giao Dịch',
  },
  groupTransaction: {
    zh_cn: '交易流水',
    zhhant: '交易流水',
    en: 'Group Transaction',
    he: 'Group Transaction',
    de: 'Group Transaction',
    es: 'Group Transaction',
    ru: 'Group Transaction',
    vi: 'Giao Dịch Nhóm',
  },
  action: {
    zh_cn: '操作',
    zhhant: '操作',
    en: 'Action',
    he: 'פעולה',
    de: 'Aktion',
    es: 'Acción',
    ru: 'Действие',
    vi: 'Hành Động',
  },
  reharge: {
    zh_cn: '充值',
    zhhant: '充值',
    en: 'Recharge',
    he: 'טעינה',
    de: 'Aufladen',
    es: 'Recarga',
    ru: 'Пополнение',
    vi: 'Nạp Tiền',
  },
  deductions: {
    zh_cn: '扣款',
    zhhant: '扣款',
    en: 'Deductions',
    he: 'ניכויים',
    de: 'Abzüge',
    es: 'Deducciones',
    ru: 'Вычеты',
    vi: 'Khấu Trừ',
  },
  generating: {
    zh_cn: '生成中',
    zhhant: '生成中',
    en: 'Generating',
    he: 'מייצר',
    de: 'Wird generiert',
    es: 'Generando',
    ru: 'Генерация',
    vi: 'Đang tạo',
  },
  downloadQrCode: {
    zh_cn: '下载二维码',
    zhhant: '下載二維碼',
    en: 'Download QR Code',
    he: 'הורד קוד QR',
    de: 'QR-Code herunterladen',
    es: 'Descargar código QR',
    ru: 'Скачать QR-код',
    vi: 'Tải xuống mã QR',
  },
  previewQrCode: {
    zh_cn: '预览二维码',
    zhhant: '預覽二維碼',
    en: 'Preview QR Code',
    he: 'תצוגה מקדימה של קוד QR',
    de: 'QR-Code-Vorschau',
    es: 'Vista previa del código QR',
    ru: 'Предварительный просмотр QR-кода',
    vi: 'Xem trước mã QR',
  },
  connector: {
    zh_cn: '充电接口',
    zhhant: '充电接口',
    en: 'Connector',
    he: 'חיבור',
    de: 'Connector',
    es: 'Connector',
    ru: 'Connector',
    vi: 'Connector',
  },
  enterpriseGroupDesc: {
    zh_cn:
      '企业员工在授权站点启动充电时，使用企业组折扣*站点定价规则进行计费，使用企业余额进行结算。企业组订单不会进入清分账单。',
    zhhant:
      '企業員工在授權站點啟動充電時，使用企業組折扣*站點定價規則進行計費，使用企業餘額進行結算。企業組訂單不會進入清分賬單。',
    en: 'When enterprise employees start charging at authorized stations, the enterprise group discount * station pricing rules are used for billing, and the enterprise balance is used for settlement. Enterprise group orders will not enter the clearing bill.',
    he: 'When enterprise employees start charging at authorized stations, the enterprise group discount * station pricing rules are used for billing, and the enterprise balance is used for settlement. Enterprise group orders will not enter the clearing bill.',
    de: 'When enterprise employees start charging at authorized stations, the enterprise group discount * station pricing rules are used for billing, and the enterprise balance is used for settlement. Enterprise group orders will not enter the clearing bill.',
    es: 'When enterprise employees start charging at authorized stations, the enterprise group discount * station pricing rules are used for billing, and the enterprise balance is used for settlement. Enterprise group orders will not enter the clearing bill.',
    ru: 'When enterprise employees start charging at authorized stations, the enterprise group discount * station pricing rules are used for billing, and the enterprise balance is used for settlement. Enterprise group orders will not enter the clearing bill.',
    vi: 'Khi nhân viên doanh nghiệp bắt đầu sạc tại các trạm được ủy quyền, quy tắc định giá trạm * giảm giá nhóm doanh nghiệp được sử dụng để tính phí và số dư doanh nghiệp được sử dụng để thanh toán. Đơn đặt hàng nhóm doanh nghiệp sẽ không được đưa vào hóa đơn thanh toán.',
  },
  pricingGroupDesc: {
    zh_cn: '只使用组折扣*站点定价规则进行计费，结算账号还是用户自己的。',
    zhhant: '只使用組折扣*站點定價規則進行計費，結算賬號還是用戶自己的。',
    en: "Only the group discount * station pricing rules are used for billing, and the settlement account is still the user's own.",
    he: "Only the group discount * station pricing rules are used for billing, and the settlement account is still the user's own.",
    de: "Only the group discount * station pricing rules are used for billing, and the settlement account is still the user's own.",
    es: "Only the group discount * station pricing rules are used for billing, and the settlement account is still the user's own.",
    ru: "Only the group discount * station pricing rules are used for billing, and the settlement account is still the user's own.",
    vi: 'Chỉ quy tắc định giá trạm * giảm giá nhóm được sử dụng để tính phí và tài khoản thanh toán vẫn là của người dùng.',
  },
  discountDesc: {
    zh_cn:
      '0 表示不计费， 1表示全额计费， 0.85 表示计费打85折。 例如: 站点电量计费是 1.5元/度， 组电费折扣是0.9， 最终计费: 1.5 * 0.9 = 1.35元/度进行计费。',
    zhhant:
      '0 表示不計費， 1表示全額計費， 0.85 表示計費打85折。 例如: 站點電量計費是 1.5元/度， 組電費折扣是0.9， 最終計費: 1.5 * 0.9 = 1.35元/度進行計費。',
    en: '0 means no charge, 1 means full charge, 0.85 means 15% discount. For example: the station electricity charge is 1.5 yuan/kWh, the group electricity discount is 0.9, and the final charge: 1.5 * 0.9 = 1.35 yuan/kWh.',
    he: '0 means no charge, 1 means full charge, 0.85 means 15% discount. For example: the station electricity charge is 1.5 yuan/kWh, the group electricity discount is 0.9, and the final charge: 1.5 * 0.9 = 1.35 yuan/kWh.',
    de: '0 means no charge, 1 means full charge, 0.85 means 15% discount. For example: the station electricity charge is 1.5 yuan/kWh, the group electricity discount is 0.9, and the final charge: 1.5 * 0.9 = 1.35 yuan/kWh.',
    es: '0 means no charge, 1 means full charge, 0.85 means 15% discount. For example: the station electricity charge is 1.5 yuan/kWh, the group electricity discount is 0.9, and the final charge: 1.5 * 0.9 = 1.35 yuan/kWh.',
    ru: '0 means no charge, 1 means full charge, 0.85 means 15% discount. For example: the station electricity charge is 1.5 yuan/kWh, the group electricity discount is 0.9, and the final charge: 1.5 * 0.9 = 1.35 yuan/kWh.',
    vi: '0 có nghĩa là không tính phí, 1 có nghĩa là tính phí đầy đủ, 0.85 có nghĩa là giảm giá 15%. Ví dụ: phí điện của trạm là 1.5 đồng/kWh, giảm giá điện của nhóm là 0.9 và phí cuối cùng: 1.5 * 0.9 = 1.35 đồng/kWh.',
  },
  enterpriseGroupLabel: {
    zh_cn: '企业组',
    zhhant: '企業組',
    en: 'Enterprise Group',
    he: 'Enterprise Group',
    de: 'Enterprise Group',
    es: 'Enterprise Group',
    ru: 'Enterprise Group',
    vi: 'Nhóm Công Ty',
  },
  pricingGroupLabel: {
    zh_cn: '计费组',
    zhhant: '計費組',
    en: 'Pricing Group',
    he: 'Pricing Group',
    de: 'Pricing Group',
    es: 'Pricing Group',
    ru: 'Pricing Group',
    vi: 'Nhóm Đánh Giá',
  },
  discountLabel: {
    zh_cn: '折扣',
    zhhant: '折扣',
    en: 'Discount',
    he: 'Discount',
    de: 'Discount',
    es: 'Discount',
    ru: 'Discount',
    vi: 'Giảm Giá',
  },
  PDIT_RATIO: {
    zh_cn: '按比例计算',
    zhhant: '按比例計算',
    en: 'Calculate by Ratio',
    he: 'Calculate by Ratio',
    de: 'Calculate by Ratio',
    es: 'Calculate by Ratio',
    ru: 'Calculate by Ratio',
    vi: 'Tính theo tỷ lệ',
  },
  PDIT_FIXED: {
    zh_cn: '按固定金额计算',
    zhhant: '按固定金額計算',
    en: 'Calculate by Fixed Amount',
    he: 'Calculate by Fixed Amount',
    de: 'Calculate by Fixed Amount',
    es: 'Calculate by Fixed Amount',
    ru: 'Calculate by Fixed Amount',
    vi: 'Tính theo số tiền cố định',
  },
  addVin: {
    zh_cn: '新增Vin',
    zhhant: '新增Vin',
    en: 'Add Win',
    he: 'הוסף Win',
    de: 'Win hinzufügen',
    es: 'Agregar Win',
    ru: 'Добавить Win',
    vi: 'Thêm Win',
  },
  addCardNo: {
    zh_cn: '新增卡号',
    zhhant: '新增卡號',
    en: 'Add Card Number',
    he: 'הוסף מספר כרטיס',
    de: 'Kartennummer hinzufügen',
    es: 'Agregar número de tarjeta',
    ru: 'Добавить номер карты',
    vi: 'Thêm số thẻ',
  },
  sharpElecAmount: {
    zh_cn: '尖 电费',
    zhhant: '尖 電費',
    en: 'Peak Electricity Fee',
    he: 'Peak Electricity Fee',
    de: 'Peak Electricity Fee',
    es: 'Peak Electricity Fee',
    ru: 'Peak Electricity Fee',
    vi: 'Phí Dịch Vụ Cao Điểm',
  },
  sharpServiceAmount: {
    zh_cn: '尖 服务费',
    zhhant: '尖 服務費',
    en: 'Peak Service Fee',
    he: 'Peak Service Fee',
    de: 'Peak Service Fee',
    es: 'Peak Service Fee',
    ru: 'Peak Service Fee',
    vi: 'Phí Dịch Vụ Cao Điểm',
  },
  peakElecAmount: {
    zh_cn: '峰 电费',
    zhhant: '峰 電費',
    en: 'Peak Electricity Fee',
    he: 'Peak Electricity Fee',
    de: 'Peak Electricity Fee',
    es: 'Peak Electricity Fee',
    ru: 'Peak Electricity Fee',
    vi: 'Phí Điện Cao Điểm',
  },
  peakServiceAmount: {
    zh_cn: '峰 服务费',
    zhhant: '峰 服務費',
    en: 'Peak Service Fee',
    he: 'Peak Service Fee',
    de: 'Peak Service Fee',
    es: 'Peak Service Fee',
    ru: 'Peak Service Fee',
    vi: 'Phí Dịch Vụ Cao Điểm',
  },
  flatElecAmount: {
    zh_cn: '平 电费',
    zhhant: '平 電費',
    en: 'Flat Electricity Fee',
    he: 'Flat Electricity Fee',
    de: 'Flat Electricity Fee',
    es: 'Flat Electricity Fee',
    ru: 'Flat Electricity Fee',
    vi: 'Phí Điện Bình Thường',
  },
  flatServiceAmount: {
    zh_cn: '平 服务费',
    zhhant: '平 服務費',
    en: 'Flat Service Fee',
    he: 'Flat Service Fee',
    de: 'Flat Service Fee',
    es: 'Flat Service Fee',
    ru: 'Flat Service Fee',
    vi: 'Phí Dịch Vụ Bình Thường',
  },
  valleyElecAmount: {
    zh_cn: '谷 电费',
    zhhant: '谷 電費',
    en: 'Valley Electricity Fee',
    he: 'Valley Electricity Fee',
    de: 'Valley Electricity Fee',
    es: 'Valley Electricity Fee',
    ru: 'Valley Electricity Fee',
    vi: 'Phí Điện Thấp Điểm',
  },
  valleyServiceAmount: {
    zh_cn: '谷 服务费',
    zhhant: '谷 服務費',
    en: 'Valley Service Fee',
    he: 'Valley Service Fee',
    de: 'Valley Service Fee',
    es: 'Valley Service Fee',
    ru: 'Valley Service Fee',
    vi: 'Phí Dịch Vụ Thấp Điểm',
  },
  deepValleyElecAmount: {
    zh_cn: '深谷 电费',
    zhhant: '深谷 電費',
    en: 'Deep Valley Electricity Fee',
    he: 'Deep Valley Electricity Fee',
    de: 'Deep Valley Electricity Fee',
    es: 'Deep Valley Electricity Fee',
    ru: 'Deep Valley Electricity Fee',
    vi: 'Phí Điện Thấp Hơn',
  },
  deepValleyServiceAmount: {
    zh_cn: '深谷 服务费',
    zhhant: '深谷 服務費',
    en: 'Deep Valley Service Fee',
    he: 'Deep Valley Service Fee',
    de: 'Deep Valley Service Fee',
    es: 'Deep Valley Service Fee',
    ru: 'Deep Valley Service Fee',
    vi: 'Phí Dịch Vụ Thấp Hơn',
  },
  pleaseEnterKeyword: {
    zh_cn: '请输入关键字',
    zhhant: '請輸入關鍵字',
    en: 'Please enter keyword',
    he: 'Please enter keyword',
    de: 'Please enter keyword',
    es: 'Please enter keyword',
    ru: 'Please enter keyword',
    vi: 'Vui lòng nhập từ khóa',
  },
  chooseUser: {
    zh_cn: '请输入手机号/邮箱，筛选用户',
    zhhant: '請輸入手機號/郵箱，篩選用戶',
    en: 'Please enter phone number/email, filter user',
    he: 'Please enter phone number/email, filter user',
    de: 'Bitte eintragen Telefonnummer/E-Mail, Benutzer filtern',
    es: 'Por favor ingresar número de teléfono/correo electrónico, filtrar usuario',
    ru: 'Пожалуйста введите номер телефона/почту, фильтровать пользователя',
    vi: 'Vui lòng nhập số điện thoại/email, lọc người dùng',
  },
  chooseCard: {
    zh_cn: '请输入卡号进行筛选',
    zhhant: '請輸入卡號進行篩選',
    en: 'Please enter card number, filter',
    he: 'Please enter card number, filter',
    de: 'Bitte eintragen Kartennummer, filtern',
    es: 'Por favor ingresar número de tarjeta, filtrar',
    ru: 'Пожалуйста введите номер карты, фильтровать',
    vi: 'Vui lòng nhập số thẻ, lọc',
  },
  chooseVin: {
    zh_cn: '请输入VIN进行筛选',
    zhhant: '請輸入VIN進行篩選',
    en: 'Please enter VIN, filter',
    he: 'Please enter VIN, filter',
    de: 'Bitte eintragen VIN, filtern',
    es: 'Por favor ingresar VIN, filtrar',
    ru: 'Пожалуйста введите VIN, фильтровать',
    vi: 'Vui lòng nhập VIN, lọc',
  },
  chooseGroup: {
    zh_cn: '请输入集团名称进行筛选',
    zhhant: '請輸入集團名稱進行篩選',
    en: 'Please enter group name, filter',
    he: 'Please enter group name, filter',
    de: 'Bitte eintragen Gruppennamen, filtern',
    es: 'Por favor ingresar nombre de grupo, filtrar',
    ru: 'Пожалуйста введите имя группы, фильтровать',
    vi: 'Vui lòng nhập tên nhóm, lọc',
  },
  chooseAdo: {
    zh_cn: '请选择',
    zhhant: '請選擇',
    en: 'Please select',
    he: 'Please select',
    de: 'Bitte auswählen',
    es: 'Por favor seleccione',
    ru: 'Пожалуйста, выберите',
    vi: 'Vui lòng chọn',
  },
  sellerName: {
    zh_cn: '销方名称',
    zhhant: '銷方名稱',
    en: 'Seller Name',
    he: 'Seller Name',
    de: 'Seller Name',
    es: 'Seller Name',
    ru: 'Seller Name',
    vi: 'Seller Name',
  },
  sellerTaxId: {
    zh_cn: '销方税号',
    zhhant: '銷方税號',
    en: 'Seller Tax ID',
    he: 'Seller Tax ID',
    de: 'Seller Tax ID',
    es: 'Seller Tax ID',
    ru: 'Seller Tax ID',
    vi: 'Seller Tax ID',
  },
  buyerName: {
    zh_cn: '购方名称',
    zhhant: '購方名稱',
    en: 'Buyer Name',
    he: 'Buyer Name',
    de: 'Buyer Name',
    es: 'Buyer Name',
    ru: 'Buyer Name',
    vi: 'Buyer Name',
  },
  buyerTaxId: {
    zh_cn: '购方税号',
    zhhant: '購方税號',
    en: 'Buyer Tax ID',
    he: 'Buyer Tax ID',
    de: 'Buyer Tax ID',
    es: 'Buyer Tax ID',
    ru: 'Buyer Tax ID',
    vi: 'Buyer Tax ID',
  },
  invoiceAmount: {
    zh_cn: '发票金额',
    zhhant: '發票金額',
    en: 'Invoice Amount',
    he: 'Invoice Amount',
    de: 'Invoice Amount',
    es: 'Invoice Amount',
    ru: 'Invoice Amount',
    vi: 'Invoice Amount',
  },
  applyId: {
    zh_cn: '申请单号',
    zhhant: '申請單號',
    en: 'Apply ID',
    he: 'Apply ID',
    de: 'Apply ID',
    es: 'Apply ID',
    ru: 'Apply ID',
    vi: 'Apply ID',
  },
  auditInvoice: {
    zh_cn: '审核开票',
    zhhant: '審核開票',
    en: 'Audit Invoice',
    he: 'Audit Invoice',
    de: 'Audit Invoice',
    es: 'Audit Invoice',
    ru: 'Audit Invoice',
    vi: 'Audit Invoice',
  },
  invoiceInfo: {
    zh_cn: '发票信息',
    zhhant: '發票信息',
    en: 'Invoice Info',
    he: 'Invoice Info',
    de: 'Invoice Info',
    es: 'Invoice Info',
    ru: 'Invoice Info',
    vi: 'Invoice Info',
  },
  invoiceType: {
    zh_cn: '发票类型',
    zhhant: '發票類型',
    en: 'Invoice Type',
    he: 'Invoice Type',
    de: 'Invoice Type',
    es: 'Invoice Type',
    ru: 'Invoice Type',
    vi: 'Invoice Type',
  },
  invoiceName: {
    zh_cn: '名称',
    zhhant: '名稱',
    en: 'Name',
    he: 'Name',
    de: 'Name',
    es: 'Name',
    ru: 'Name',
    vi: 'Name',
  },
  invoiceTaxId: {
    zh_cn: '税号',
    zhhant: '税號',
    en: 'Tax ID',
    he: 'Tax ID',
    de: 'Tax ID',
    es: 'Tax ID',
    ru: 'Tax ID',
    vi: 'Tax ID',
  },
  invoiceAddress: {
    zh_cn: '单位地址',
    zhhant: '單位地址',
    en: 'Address',
    he: 'Address',
    de: 'Address',
    es: 'Address',
    ru: 'Address',
    vi: 'Address',
  },
  invoicePhone: {
    zh_cn: '电话号码',
    zhhant: '電話號碼',
    en: 'Phone',
    he: 'Phone',
    de: 'Phone',
    es: 'Phone',
    ru: 'Phone',
    vi: 'Phone',
  },
  invoiceBankName: {
    zh_cn: '开户银行名称',
    zhhant: '開戶銀行名稱',
    en: 'Bank Name',
    he: 'Bank Name',
    de: 'Bank Name',
    es: 'Bank Name',
    ru: 'Bank Name',
    vi: 'Bank Name',
  },
  invoiceBankAccount: {
    zh_cn: '开户银行账号',
    zhhant: '開戶銀行賬號',
    en: 'Bank Account',
    he: 'Bank Account',
    de: 'Bank Account',
    es: 'Bank Account',
    ru: 'Bank Account',
    vi: 'Bank Account',
  },
  invoiceEmail: {
    zh_cn: '接收邮箱',
    zhhant: '接收郵箱',
    en: 'Email',
    he: 'Email',
    de: 'Email',
    es: 'Email',
    ru: 'Email',
    vi: 'Email',
  },
  orderAmount: {
    zh_cn: '订单金额',
    zhhant: '訂單金額',
    en: 'Order Amount',
    he: 'Order Amount',
    de: 'Order Amount',
    es: 'Order Amount',
    ru: 'Order Amount',
    vi: 'Order Amount',
  },
  orderId: {
    zh_cn: '订单ID',
    zhhant: '訂單ID',
    en: 'Order ID',
    he: 'Order ID',
    de: 'Order ID',
    es: 'Order ID',
    ru: 'Order ID',
    vi: 'Order ID',
  },
  invoiceFile: {
    zh_cn: '发票文件',
    zhhant: '發票文件',
    en: 'Invoice File',
    he: 'Invoice File',
    de: 'Invoice File',
    es: 'Invoice File',
    ru: 'Invoice File',
    vi: 'Invoice File',
  },
  privateEvseSharing: {
    zh_cn: '私桩共享',
    zhhant: '私樁共享',
    en: 'Private EVSE Sharing',
    he: 'שיתוף עמדת טעינה פרטית',
    de: 'Private Ladestation-Sharing',
    es: 'Compartir EVSE privado',
    ru: 'Совместное использование частных EVSE',
    vi: 'Chia sẻ trạm sạc cá nhân',
  },
  showIncomeWallet: {
    zh_cn: '显示收入钱包',
    zhhant: '显示收入錢包',
    en: 'Show Income Wallet',
    he: 'הצג ארנק הכנסות',
    de: 'Einkommens-Wallet anzeigen',
    es: 'Mostrar billetera de ingresos',
    ru: 'Показать кошелек доходов',
    vi: 'Hiển thị ví tiền thu nhập',
  },
  businessStateInit: {
    zh_cn: '未上线运营',
    zhhant: '未上線運營',
    en: 'Not Operating',
    he: 'לא פעיל',
    de: 'Nicht in Betrieb',
    es: 'No operativo',
    ru: 'Не работает',
    vi: 'Chưa hoạt động',
  },

  businessStateOpenBusiness: {
    zh_cn: '商业运营',
    zhhant: '商業運營',
    en: 'Business Operating',
    he: 'הפעלה עסקית',
    de: 'Geschäftsbetrieb',
    es: 'Operación comercial',
    ru: 'Коммерческая работа',
    vi: 'Hoạt động thương mại',
  },

  businessStateSuspendBusiness: {
    zh_cn: '暂停运营',
    zhhant: '暫停運營',
    en: 'Suspend Operating',
    he: 'השהה פעילות',
    de: 'Betrieb aussetzen',
    es: 'Suspender operación',
    ru: 'Приостановить работу',
    vi: 'Tạm ngừng hoạt động',
  },

  businessStateClosedBusiness: {
    zh_cn: '停止运营',
    zhhant: '停止運營',
    en: 'Stop Operating',
    he: 'הפסק פעילות',
    de: 'Betrieb einstellen',
    es: 'Detener operación',
    ru: 'Прекратить работу',
    vi: 'Ngừng hoạt động',
  },
  businessStateInternalBusiness: {
    zh_cn: '内部运营/私桩站点',
    zhhant: '內部運營/私樁站點',
    en: 'Internal Operation/Private Pile Station',
    he: 'הפעלה פנימית/תחנת ערימה פרטית',
    de: 'Interne Operation/Private Pile Station',
    es: 'Operación interna/estación de pilas privadas',
    ru: 'Внутренняя операция/частная станция',
    vi: 'Hoạt động nội bộ/Trạm đống riêng tư',
  },
  businessState: {
    zh_cn: '运营状态',
    zhhant: '運營狀態',
    en: 'Operating Status',
    he: 'מצב הפעלה',
    de: 'Betriebsstatus',
    es: 'Estado de operación',
    ru: 'Статус работы',
    vi: 'Trạng thái hoạt động',
  },
  cards: {
    zh_cn: '卡列表',
    en: 'RFID Cards',
    zhhant: '卡列表',
    he: 'רשימת כרטיסים',
    de: 'RFID-Karten',
    es: 'Tarjetas RFID',
    ru: 'RFID-карты',
    vi: 'Danh sách thẻ',
  },
  bill: {
    zh_cn: '账单',
    zhhant: '賬單',
    en: 'Bill',
    he: 'חשבון',
    de: 'Rechnung',
    es: 'Factura',
    ru: 'Счет',
    vi: 'Hóa đơn',
  },
  bindMiniapp: {
    zh_cn: '绑定小程序',
    zhhant: '綁定小程序',
    en: 'Bind Miniapp',
    he: 'Bind Miniapp',
    de: 'Mini-App binden',
    es: 'Enlazar miniaplicación',
    ru: 'Привязать Miniapp',
    vi: 'Kết nối ứng dụng nhỏ',
  },
  miniAppid: {
    zh_cn: '小程序ID',
    zhhant: '小程序ID',
    en: 'Miniapp ID',
    he: 'מיני אפליקציה',
    de: 'Mini-App-ID',
    es: 'ID de miniaplicación',
    ru: 'Miniapp ID',
    vi: 'ID ứng dụng nhỏ',
  },
  bindUser: {
    zh_cn: '绑定用户',
    zhhant: '綁定用戶',
    en: 'Bind User',
    he: 'לחבר משתמש',
    de: 'Benutzer binden',
    es: 'Enlazar usuario',
    ru: 'Привязать пользователя',
    vi: 'Kết nối người dùng',
  },
  drtAdmin: {
    zh_cn: '超级管理员',
    zhhant: '超级管理员',
    en: 'Super Admin',
    he: 'מנהל מורכב',
    de: 'Super Admin',
    es: 'Administrador de agentes',
    ru: 'Супер Админ',
    vi: 'Quản trị viên cao cấp',
  },
  drtAgentOperator: {
    zh_cn: '代理商',
    zhhant: '代理商',
    en: 'Agent Operator',
    he: 'מפעיל סוכן',
    de: 'Agentenbetreiber',
    es: 'Operador agente',
    ru: 'Агент-оператор',
    vi: 'Nhà điều hành đại lý',
  },
  drtAgentOperatorView: {
    zh_cn: '代理商只读管理员',
    zhhant: '代理商只讀管理員',
    en: 'Agent Operator View Only',
    he: 'מפעיל סוכן לצפייה בלבד',
    de: 'Agentenbetreiber (nur Ansicht)',
    es: 'Vista de operador agente',
    ru: 'Агент-оператор (только просмотр)',
    vi: 'Quản trị viên đại lý chỉ xem',
  },
  drtBrandOperator: {
    zh_cn: '品牌商',
    zhhant: '品牌商',
    en: 'Brand Operator',
    he: 'מפעיל מותג',
    de: 'Markenbetreiber',
    es: 'Operador de marca',
    ru: 'Оператор бренда',
    vi: 'Nhà điều hành thương hiệu',
  },
  drtBrandOperatorView: {
    zh_cn: '品牌商只读管理员',
    zhhant: '品牌商只讀管理員',
    en: 'Brand Operator View Only',
    he: 'מפעיל מותג לצפייה בלבד',
    de: 'Markenbetreiber (nur Ansicht)',
    es: 'Vista de operador de marca',
    ru: 'Оператор бренда (только просмотр)',
    vi: 'Quản trị viên thương hiệu chỉ xem',
  },
  drtFinance: {
    zh_cn: '财务管理员',
    zhhant: '財務管理員',
    en: 'Finance Admin',
    he: 'מנהל כספים',
    de: 'Finanzadmin',
    es: 'Administrador financiero',
    ru: 'Финансовый администратор',
    vi: 'Quản trị viên tài chính',
  },
  drtOps: {
    zh_cn: '运维管理员',
    zhhant: '運維管理員',
    en: 'Operations Admin',
    he: 'מנהל תפעול',
    de: 'Betriebsadmin',
    es: 'Administrador de operaciones',
    ru: 'Администратор операций',
    vi: 'Quản trị viên vận hành',
  },
  drtProfitSharingPayee: {
    zh_cn: '分润管理员',
    zhhant: '分潤管理員',
    en: 'Profit Sharing Admin',
    he: 'מנהל שיתוף רווחים',
    de: 'Gewinnbeteiligungsadmin',
    es: 'Administrador de reparto de beneficios',
    ru: 'Администратор распределения прибыли',
    vi: 'Quản trị viên chia sẻ lợi nhuận',
  },
  drtStation: {
    zh_cn: '站点管理员',
    zhhant: '站點管理員',
    en: 'Station Admin',
    he: 'מנהל תחנה',
    de: 'Stationsadmin',
    es: 'Administrador de estación',
    ru: 'Администратор станции',
    vi: 'Quản trị viên trạm',
  },
  drtStationView: {
    zh_cn: '充电站只读管理员',
    zhhant: '充電站只讀管理員',
    en: 'Station View Only Admin',
    he: 'מנהל תחנה לצפייה בלבד',
    de: 'Stationsadmin (nur Ansicht)',
    es: 'Administrador de vista de estación',
    ru: 'Администратор станции (только просмотр)',
    vi: 'Quản trị viên trạm chỉ xem',
  },
  configPaymentChannel: {
    zh_cn: '配置支付渠道',
    zhhant: '配置支付渠道',
    en: 'Configure Payment Channel',
    he: 'קבע/הגדר אמצעי תשלום',
    de: 'Zahlungskanal konfigurieren',
    es: 'Configurar canal de pago',
    ru: 'Конфигурация платежного каналу',
    vi: 'Cấu hình kênh thanh toán',
  },
  paymentChannel: {
    zh_cn: '支付渠道',
    zhhant: '支付渠道',
    en: 'Payment Channel',
    he: 'אמצעי תשלום',
    de: 'Zahlungskanal',
    es: 'Canal de pago',
    ru: 'Платежный канал',
    vi: 'Kênh thanh toán',
  },
  defpc: {
    zh_cn: '默认渠道',
    zhhant: '默認渠道',
    en: 'Default Channel',
    he: 'אמצעי ברירת מחדל',
    de: 'Standardkanal',
    es: 'Canal predeterminado',
    ru: 'Канал по умолчанию',
    vi: 'Kênh mặc định',
  },
  pspc: {
    zh_cn: '清分渠道',
    zhhant: '清分渠道',
    en: 'ps Channel',
    he: 'ps אמצעי',
    de: 'ps Kanal',
    es: 'Canal ps',
    ru: 'Пс-канал',
    vi: 'Kênh ps',
  },
  bindpc: {
    zh_cn: '绑定渠道',
    zhhant: '綁定渠道',
    en: 'bind Channel',
    he: 'bind אמצעי',
    de: 'bind Kanal',
    es: 'Canal bind',
    ru: 'Канал привязки',
    vi: 'Kênh bind',
  },
  selectpc: {
    zh_cn: '选择渠道',
    zhhant: '選擇渠道',
    en: 'select Channel',
    he: 'select אמצעי',
    de: 'select Kanal',
    es: 'Canal select',
    ru: 'Канал выбора',
    vi: 'Kênh chọn',
  },
  tradeFeePercentageConf: {
    zh_cn: '交易费比例(第三方)',
    zhhant: '交易费比例(第三方)',
    en: 'trade fee percentage(third party)',
    he: 'תשלום על פי אחוז(שלישי)',
    de: 'Trade fee percentage(third party)',
    es: 'trade fee percentage(third party)',
    ru: 'Транзакция fee percentage(третий)',
    vi: 'trade fee percentage(third party)',
  },
  tradeFeePercentageCDef: {
    zh_cn: '交易费比例(自定义)',
    zhhant: '交易费比例(自定义)',
    en: 'trade fee percentage(custom)',
    he: 'תשלום על פי אחוז(מותאם)',
    de: 'Trade fee percentage(custom)',
    es: 'trade fee percentage(custom)',
    ru: 'Транзакция fee percentage(custom)',
    vi: 'trade fee percentage(custom)',
  },
  withdrawFeeCDef: {
    zh_cn: '提现费(自定义)',
    zhhant: '提現費(自定義)',
    en: 'withdraw fee(custom)',
    he: 'תשלום על פי אחוז(מותאם)',
    de: 'Withdraw fee percentage(custom)',
    es: 'Withdraw fee percentage(custom)',
    ru: 'Вывод fee percentage(custom)',
    vi: 'Withdraw fee percentage(custom)',
  },
  wxAppId: {
    zh_cn: '微信AppId',
    zhhant: '微信AppId',
    en: 'wxAppId',
    he: 'wxAppId',
    de: 'wxAppId',
    es: 'wxAppId',
    ru: 'wxAppId',
    vi: 'wxAppId',
  },
  aliAppId: {
    zh_cn: '支付宝AppId',
    zhhant: '支付宝AppId',
    en: 'aliAppId',
    he: 'aliAppId',
    de: 'aliAppId',
    es: 'aliAppId',
    ru: 'aliAppId',
    vi: 'aliAppId',
  },
  isVisibleToAdminOnly: {
    zh_cn: '仅管理员可见',
    zhhant: '僅管理員可見',
    en: 'Visible to admin only',
    he: 'רק למנהל',
    de: 'Nur für Admin sichtbar',
    es: 'Visible solo para administradores',
    ru: 'Видимо только для администратора',
    vi: 'Chỉ hiển thị cho quản trị viên',
  },
  defOperatorName: {
    zh_cn: '所属商户',
    zhhant: '所屬商戶',
    en: 'Belong to merchant',
    he: 'שייך למוכר',
    de: 'Zugehörig zu Händler',
    es: 'Pertenece a un comerciante',
    ru: 'Принадлежит к продавцу',
    vi: 'Thuộc thương gia',
  },
  bindPayeeName: {
    zh_cn: '绑定收款人',
    zhhant: '綁定收款人',
    en: 'Bind payee',
    he: 'תשלום bind',
    de: 'Bind Zahlungsempfänger',
    es: 'Pagador bind',
    ru: 'Получатель привязки',
    vi: 'Người được thanh toán bind',
  },
  defPayeeName: {
    zh_cn: '默认收款人',
    zhhant: '默認收款人',
    en: 'Default payee',
    he: 'תשלום ברירת מחדל',
    de: 'Standardzahlungsempfänger',
    es: 'Pagador predeterminado',
    ru: 'Получатель по умолчанию',
    vi: 'Người được thanh toán mặc định',
  },
  insufficientMoney: {
    //  钱包余额不足
    zh_cn: '钱包余额不足',
    zhhant: '錢包餘額不足',
    en: 'Wallet balance is insufficient',
    he: 'אזור כספי לא מספיק',
    de: 'Guthaben nicht ausreichend',
    es: 'Saldo de billetera insuficiente',
    ru: 'Баланс кошелька недостаточен',
    vi: 'Số dư ví không đủ',
  },
  barrierGateType: {
    zh_cn: '道闸厂商',
    zhhant: '道闸廠商',
    en: 'Barrier Gate Type',
    he: 'Barrier Gate Type',
    de: 'Barrier Gate Type',
    es: 'Barrier Gate Type',
    ru: 'Barrier Gate Type',
    vi: 'Barrier Gate Type',
  },
  bgtJs: {
    zh_cn: '捷顺道闸',
    zhhant: '捷順道査',
    en: 'Jieshun Dao Zha',
    he: 'Jieshun Dao Zha',
    de: 'Jieshun Dao Zha',
    es: 'Jieshun Dao Zha',
    ru: 'Jieshun Dao Zha',
    vi: 'Jieshun Dao Zha',
  },
  bgtLty: {
    zh_cn: '路通云停',
    zhhant: '路通云停',
    en: 'Lutong Yunting',
    he: 'Lutong Yunting',
    de: 'Lutong Yunting',
    es: 'Lutong Yunting',
    ru: 'Lutong Yunting',
    vi: 'Lutong Yunting',
  },
  merchantId: {
    zh_cn: '商户ID',
    zhhant: '商戶ID',
    en: 'Merchant ID',
    he: 'Merchant ID',
    de: 'Merchant ID',
    es: 'Merchant ID',
    ru: 'Merchant ID',
    vi: 'Merchant ID',
  },
  couponId: {
    zh_cn: '优惠券ID',
    zhhant: '優惠券ID',
    en: 'Coupon ID',
    he: 'Coupon ID',
    de: 'Coupon ID',
    es: 'Coupon ID',
    ru: 'Coupon ID',
    vi: 'Coupon ID',
  },
  parkInfo: {
    zh_cn: '停车场信息',
    zhhant: '停车场信息',
    en: 'Parking Info',
    he: 'Parking Info',
    de: 'Parking Info',
    es: 'Parking Info',
    ru: 'Parking Info',
    vi: 'Parking Info',
  },
  selectStationNature: {
    zh_cn: '请选择站点性质',
    zhhant: '請選擇站点性质',
    en: 'Please select station type',
    he: 'בחר סוג תחנה',
    de: 'Bitte wählen Sie den Stationstyp',
    es: 'Seleccione el tipo de estación',
    ru: 'Пожалуйста, выберите тип станции',
    vi: 'Vui lòng chọn loại trạm',
  },
  totalCapacity: {
    zh_cn: '总装机容量',
    zhhant: '總裝機容量',
    en: 'Total Installed Capacity',
    he: 'קיבולת מותקנת כוללת',
    de: 'Gesamtkapazität installiert',
    es: 'Capacidad total instalada',
    ru: 'Общая установленная мощность',
    vi: 'Tổng công suất lắp đặt',
  },
  gridConnected: {
    zh_cn: '是否已并网',
    zhhant: '是否已併網',
    en: 'Grid Connected',
    he: 'האם מחובר לרשת',
    de: 'Mit Netz verbunden',
    es: '¿Conectado a la red?',
    ru: 'Подключено к сети',
    vi: 'Đã nối lưới chưa',
  },
  gridTime: {
    zh_cn: '并网时间',
    zhhant: '併網時間',
    en: 'Grid Connection Time',
    he: 'זמן חיבור לרשת',
    de: 'Netzanschlusszeit',
    es: 'Hora de conexión a la red',
    ru: 'Время подключения к сети',
    vi: 'Thời gian nối lưới',
  },
  gridType: {
    zh_cn: '并网类型',
    zhhant: '併網類型',
    en: 'Grid Connection Type',
    he: 'סוג חיבור לרשת',
    de: 'Netzanschlusstyp',
    es: 'Tipo de conexión a la red',
    ru: 'Тип подключения к сети',
    vi: 'Loại nối lưới',
  },
  chargingPlans: {
    zh_cn: '充电计划',
    zhhant: '充電計劃',
    en: 'Charging Plans',
    he: 'תוכנית טעינה',
    de: 'Ladungsplan',
    es: 'Plan de carga',
    ru: 'План зарядки',
    vi: 'Kế hoạch sạc',
  },
  noSense: {
    zh_cn: '无感',
    zhhant: '無感',
    en: 'No Sense',
    he: 'אין תחושה',
    de: 'Kein Sinn',
    es: 'Sin sentido',
    ru: 'Без смысла',
    vi: 'Không cảm giác',
  },
  occupyTips: {
    zh_cn:
      '例如 免费占桩时间30分钟，封顶金额25元 占桩费单价2元/分钟表示:充电结束30分钟内不收取费用，超过30分钟的时间按每分钟2元收费,封顶25元。',
    zh_hant:
      '例如 免費占樁時間30分鐘，封頂金額25元 占樁費單價2元/分鐘表示:充电结束30分鐘內不收取費用，超過30分鐘的時間按每分鐘2元收費,封頂25元。',
    en: 'For example, free occupying time is 30 minutes and the maximum amount is 25 yuan. The unit price of occupying fee per minute is 2 yuan/minute means that no fees will be charged within 30 minutes after charging ends, and the fee will be charged at 2 yuan/minute for every minute after 30 minutes. The maximum amount is 25 yuan.',
    he: 'For example, free occupying time is 30 minutes and the maximum amount is 25 yuan. The unit price of occupying fee per minute is 2 yuan/minute means that no fees will be charged within 30 minutes after charging ends, and the fee will be charged at 2 yuan/minute for every minute after 30 minutes. The maximum amount is 25 yuan.',
    de: 'For example, free occupying time is 30 minutes and the maximum amount is 25 yuan. The unit price of occupying fee per minute is 2 yuan/minute means that no fees will be charged within 30 minutes after charging ends, and the fee will be charged at 2 yuan/minute for every minute after 30 minutes. The maximum amount is 25 yuan.',
    es: 'For example, free occupying time is 30 minutes and the maximum amount is 25 yuan. The unit price of occupying fee per minute is 2 yuan/minute means that no fees will be charged within 30 minutes after charging ends, and the fee will be charged at 2 yuan/minute for every minute after 30 minutes. The maximum amount is 25 yuan.',
    ru: 'For example, free occupying time is 30 minutes and the maximum amount is 25 yuan. The unit price of occupying fee per minute is 2 yuan/minute means that no fees will be charged within 30 minutes after charging ends, and the fee will be charged at 2 yuan/minute for every minute after 30 minutes. The maximum amount is 25 yuan.',
  },
  /** 免费时间 */
  freeOccupyTime: {
    zh_cn: '免费占桩时间（分钟）',
    zhhant: '免費占桩時間（分鐘）',
    en: 'Free Occupy Time (Minutes)',
    he: 'Free Occupy Time (Minutes)',
    de: 'Free Occupy Time (Minutes)',
    es: 'Free Occupy Time (Minutes)',
    ru: 'Free Occupy Time (Minutes)',
    vi: 'Free Occupy Time (Minutes)',
  },
  /** 最高/封顶费用，分辨率RMB 0.1分 */
  maxOccupyFee: {
    zh_cn: '最高封顶费用（元）',
    zhhant: '最高封頂費用（元）',
    en: 'Max Occupy Fee ($)',
    he: 'Max Occupy Fee ($)',
    de: 'Max Occupy Fee ($)',
    es: 'Max Occupy Fee ($)',
    ru: 'Max Occupy Fee ($)',
    vi: 'Max Occupy Fee ($)',
  },
  /** 每分钟的费用，分辨率RMB 0.1分 */
  occupyPrice: {
    zh_cn: '占桩计费（元/分钟）',
    zhhant: '占樁計費（元/分鐘）',
    en: 'Occupy Price ($/Minute)',
    he: 'Occupy Price ($/Minute)',
    de: 'Occupy Price ($/Minute)',
    es: 'Occupy Price ($/Minute)',
    ru: 'Occupy Price ($/Minute)',
    vi: 'Occupy Price ($/Minute)',
  },
  occupyOrder: {
    zh_cn: '占桩订单',
    zhhant: '占樁訂單',
    en: 'Occupy Order',
    he: 'Occupy Order',
    de: 'Occupy Order',
    es: 'Occupy Order',
    ru: 'Occupy Order',
    vi: 'Occupy Order',
  },
  mchId: {
    zh_cn: '商户号',
    zhhant: '商戶號',
    en: 'Mch ID',
    he: 'Mch ID',
    de: 'Mch ID',
    es: 'Mch ID',
    ru: 'Mch ID',
    vi: 'Mch ID',
  },
  subMchId: {
    zh_cn: '子商户号',
    zhhant: '子商戶號',
    en: 'Sub Mch ID',
    he: 'Sub Mch ID',
    de: 'Sub Mch ID',
    es: 'Sub Mch ID',
    ru: 'Sub Mch ID',
    vi: 'Sub Mch ID',
  },
  mchPrivateKey: {
    zh_cn: '商户私钥',
    zhhant: '商戶私鑰',
    en: 'Mch Private Key',
    he: 'Mch Private Key',
    de: 'Mch Private Key',
    es: 'Mch Private Key',
    ru: 'Mch Private Key',
    vi: 'Mch Private Key',
  },
  mchApiV3Key: {
    zh_cn: '商户APIv3密钥',
    zhhant: '商戶APIv3密鑰',
    en: 'Mch APIv3 Key',
    he: 'Mch APIv3 Key',
    de: 'Mch APIv3 Key',
    es: 'Mch APIv3 Key',
    ru: 'Mch APIv3 Key',
    vi: 'Mch APIv3 Key',
  },
  mchCerSerNum: {
    zh_cn: '证书序列号',
    zhhant: '憑證序號',
    en: 'Cer Ser Num',
    he: 'Cer Ser Num',
    de: 'Cer Ser Num',
    es: 'Cer Ser Num',
    ru: 'Cer Ser Num',
    vi: 'Cer Ser Num',
  },
  chargingSpeedType: {
    zh_cn: '充电速度',
    zhhant: '充电速度',
    en: 'Charging Speed Type',
    he: 'Charging Speed Type',
    de: 'Charging Speed Type',
    es: 'Charging Speed Type',
    ru: 'Charging Speed Type',
    vi: 'Charging Speed Type',
  },
  tfn: {
    zh_cn: '统一社会信用代码',
  },
  selectPricingOnBicycleTips: {
    zh_cn: '单车请选择按功率计费',
  },
  rescueType: {
    zh_cn: '救援类型',
    zhhant: '救援類型',
    en: 'Rescue Type',
    he: 'Rescue Type',
    de: 'Rescue Type',
    es: 'Rescue Type',
    ru: 'Rescue Type',
    vi: 'Rescue Type',
  },
  needPay: {
    zh_cn: '需要支付',
    zhhant: '需要支付',
    en: 'Need Pay',
    he: 'Need Pay',
    de: 'Need Pay',
    es: 'Need Pay',
    ru: 'Need Pay',
    vi: 'Need Pay',
  },
  payMode: {
    zh_cn: '支付方式',
    zhhant: '支付方式',
    en: 'Pay Mode',
    he: 'Pay Mode',
    de: 'Pay Mode',
    es: 'Pay Mode',
    ru: 'Pay Mode',
    vi: 'Pay Mode',
  },
  payAmount: {
    zh_cn: '支付金额',
    zhhant: '支付金額',
    en: 'Pay Amount',
    he: 'Pay Amount',
    de: 'Pay Amount',
    es: 'Pay Amount',
    ru: 'Pay Amount',
    vi: 'Pay Amount',
  },
  refundAmount: {
    zh_ch: '退款金额',
    zhhant: '退款金額',
    en: 'Refund Amount',
    he: 'Refund Amount',
    de: 'Refund Amount',
    es: 'Refund Amount',
    ru: 'Refund Amount',
    vi: 'Refund Amount',
  },
  rescueOrderStateWaitPay: {
    zh_cn: '待支付',
    zhhant: '待支付',
    en: 'Wait Pay',
    he: 'Wait Pay',
    de: 'Wait Pay',
    es: 'Wait Pay',
    ru: 'Wait Pay',
    vi: 'Wait Pay',
  },
  payTid: {
    zh_cn: '交易ID',
    zhhant: '交易ID',
    en: 'Pay Tid',
    he: 'Pay Tid',
    de: 'Pay Tid',
    es: 'Pay Tid',
    ru: 'Pay Tid',
    vi: 'Pay Tid',
  },
  rescueOrderStatePending: {
    zh_cn: '待派单',
    zhhant: '待派单',
    en: 'Pending',
    he: 'Pending',
    de: 'Pending',
    es: 'Pending',
    ru: 'Pending',
    vi: 'Pending',
  },
  rescueOrderStateProcessing: {
    zh_cn: '进行中',
    zhhant: '進行中',
    en: 'Processing',
    he: 'Processing',
    de: 'Processing',
    es: 'Processing',
    ru: 'Processing',
    vi: 'Processing',
  },
  rescueOrderStateDone: {
    zh_cn: '已完成',
    zhhant: '已完成',
    en: 'Done',
    he: 'Done',
    de: 'Done',
    es: 'Done',
    ru: 'Done',
    vi: 'Done',
  },
  rescueOrderStateFail: {
    zh_cn: '支付失败',
    zhhant: '支付失敗',
    en: 'Pay failed',
    he: 'Pay failed',
    de: 'Pay failed',
    es: 'Pay failed',
    ru: 'Pay failed',
    vi: 'Pay failed',
  },
  rescueOrderStateRefund: {
    zh_cn: '已退款',
    zhhant: '已退款',
    en: 'Refunded',
    he: 'Refunded',
    de: 'Refunded',
    es: 'Refunded',
    ru: 'Refunded',
    vi: 'Refunded',
  },
  rescueTypeJumpStart: {
    zh_cn: '搭电',
    zhhant: '搭電',
    en: 'Jump Start',
    he: 'Jump Start',
    de: 'Jump Start',
    es: 'Jump Start',
    ru: 'Jump Start',
    vi: 'Jump Start',
  },
  rescueTypeTireChange: {
    zh_cn: '换胎',
    zhhant: '換胎',
    en: 'Tire Change',
    he: 'Tire Change',
    de: 'Tire Change',
    es: 'Tire Change',
    ru: 'Tire Change',
    vi: 'Tire Change',
  },
  rescueTypeTowing: {
    zh_cn: '拖车',
    zhhant: '拖车',
    en: 'Towing',
    he: 'Towing',
    de: 'Towing',
    es: 'Towing',
    ru: 'Towing',
    vi: 'Towing',
  },
  rescueTypeEmergencyExtraction: {
    zh_cn: '紧急脱困',
    zhhant: '緊急脱困',
    en: 'Emergency Extraction',
    he: 'Emergency Extraction',
    de: 'Emergency Extraction',
    es: 'Emergency Extraction',
    ru: 'Emergency Extraction',
    vi: 'Emergency Extraction',
  },
  rescueTypeDeliveryElectricity: {
    zh_cn: '送电上门',
    zhhant: '送电上门',
    en: 'Delivery Electricity',
    he: 'Delivery Electricity',
    de: 'Delivery Electricity',
    es: 'Delivery Electricity',
    ru: 'Delivery Electricity',
    vi: 'Delivery Electricity',
  },
  handlerName: {
    zh_cn: '处理人',
    zhhant: '处理人',
    en: 'Handler Name',
    he: 'Handler Name',
    de: 'Handler Name',
    es: 'Handler Name',
    ru: 'Handler Name',
    vi: 'Handler Name',
  },
  handlerPhone: {
    zh_cn: '处理人电话',
    zhhant: '處理人電話',
    en: 'Handler Phone',
    he: 'Handler Phone',
    de: 'Handler Phone',
    es: 'Handler Phone',
    ru: 'Handler Phone',
    vi: 'Handler Phone',
  },
  completeTime: {
    zh_cn: '完成时间',
    zhhant: '完成時間',
    en: 'Complete Time',
    he: 'Complete Time',
    de: 'Complete Time',
    es: 'Complete Time',
    ru: 'Complete Time',
    vi: 'Complete Time',
  },
  completeRemark: {
    zh_cn: '完成备注',
    zhhant: '完成備註',
    en: 'Complete Remark',
    he: 'Complete Remark',
    de: 'Complete Remark',
    es: 'Complete Remark',
    ru: 'Complete Remark',
    vi: 'Complete Remark',
  },
  homeQrcodeFix: {
    zh_cn: '家用二维码前缀',
    zhhant: '家用二維碼前綴',
    en: 'Home QR Code Prefix',
    he: 'קידומת קוד QR לבית',
    de: 'Was ist mit den heutigen einnahmen',
    es: 'Pagador predeterminado',
    ru: 'Получатель по умолчанию',
    vi: 'Người được thanh toán mặc định',
  },
  opQrcodeFix: {
    zh_cn: '运营二维码前缀',
    zhhant: '運營二维码前綴',
    en: 'Operator QR Code Prefix',
    he: 'קידומת קוד QR למפעיל',
    de: 'Was ist mit den heutigen einnahmen',
    es: 'Pagador predeterminado',
    ru: 'Получатель по умолчанию',
    vi: 'Người được thanh toán mặc định',
  },
  investment: {
    zh_cn: '投资',
    zhhant: '投資',
    en: 'Investment',
    he: 'Investment',
    de: 'Investment',
    es: 'Investment',
    ru: 'Investment',
    vi: 'Investment',
  },
  cooperation: {
    zh_cn: '场地合作',
    zhhant: '场地合作',
    en: 'Cooperation',
    he: 'Cooperation',
    de: 'Cooperation',
    es: 'Cooperation',
    ru: 'Cooperation',
    vi: 'Cooperation',
  },
  toJoin: {
    zh_cn: '加盟',
    zhhant: '加盟',
    en: 'To Join',
    he: 'To Join',
    de: 'To Join',
    es: 'To Join',
    ru: 'To Join',
    vi: 'To Join',
  },
  webHook: {
    zh_cn: 'WebHook',
    zhhant: 'WebHook',
    en: 'WebHook',
    he: 'WebHook',
    de: 'WebHook',
    es: 'WebHook',
    ru: 'WebHook',
    vi: 'WebHook',
  },
  investAmount: {
    zh_cn: '投资金额',
    zhhant: '投資金額',
    en: 'Investment Amount',
    he: 'Investment Amount',
    de: 'Investment Amount',
    es: 'Investment Amount',
    ru: 'Investment Amount',
    vi: 'Investment Amount',
  },
  spaceAddress: {
    zh_cn: '场地地址',
    zhhant: '场地地址',
    en: 'Space Address',
    he: 'Space Address',
    de: 'Space Address',
    es: 'Space Address',
    ru: 'Space Address',
    vi: 'Space Address',
  },
  havePower: {
    zh_cn: '是否有电力',
    zhhant: '是否有電力',
    en: 'Have Power',
    he: 'Have Power',
    de: 'Have Power',
    es: 'Have Power',
    ru: 'Have Power',
    vi: 'Have Power',
  },
  spaceArea: {
    zh_cn: '场地面积',
    zhhant: '场地面積',
    en: 'Space Area',
    he: 'Space Area',
    de: 'Space Area',
    es: 'Space Area',
    ru: 'Space Area',
    vi: 'Space Area',
  },
  cityArea: {
    zh_cn: '城市区域',
    zhhant: '城市區域',
    en: 'City Area',
    he: 'City Area',
    de: 'City Area',
    es: 'City Area',
    ru: 'City Area',
    vi: 'City Area',
  },
  resourceDesc: {
    zh_cn: '资源情况描述',
    zhhant: '資源情況描述',
    en: 'Resource Desc',
    he: 'Resource Desc',
    de: 'Resource Desc',
    es: 'Resource Desc',
    ru: 'Resource Desc',
    vi: 'Resource Desc',
  },
  haveExperience: {
    zh_cn: '是否有相关经验',
    zhhant: '是否有相關經驗',
    en: 'Have Experience',
    he: 'Have Experience',
    de: 'Have Experience',
    es: 'Have Experience',
    ru: 'Have Experience',
    vi: 'Have Experience',
  },
  homeStation: {
    zh_cn: '家用站',
    zhhant: '家用站',
    en: 'Home Station',
    he: 'בית',
    de: 'Zuhause',
    es: 'Hogar',
    ru: 'Дом',
    vi: 'Nhà',
  },
  bizStation: {
    zh_cn: '运营站',
    zhhant: '營業站',
    en: 'Business Station',
    he: 'עסקים',
    de: 'Betrieb',
    es: 'Comercial',
    ru: 'Бизнес',
    vi: 'Kinh doanh',
  },
  supportDeepValley: {
    zh_cn: '支持深谷',
    zhhant: '支持深谷',
    en: 'Support Deep Valley',
    he: 'תמיכה ב-Deep Valley',
    de: 'Unterstützung für Deep Valley',
    es: 'Soporte para Deep Valley',
    ru: 'Поддержка Deep Valley',
    vi: 'Hỗ trợ Deep Valley',
  },
  clockingPriceing: {
    zh_cn: '定时策略',
    zhhant: '定時策略',
    en: 'Clocking Priceing',
    he: 'מחיקת תחנות',
    de: 'Zeitgesteuerte Preisgestaltung',
    es: 'Precios programados',
    ru: 'Планирование цен',
    vi: 'Chuẩn bị xóa',
  },
  confirmDeleteStation: {
    zh_cn: '删除站点后, 站点所有设备编号将同步删除下架。 列表中无法搜索显示，请确认是否删除站点?',
    zhhant: '刪除站點後, 站點所有設備編號將同步刪除下架。 列表中無法搜索顯示，請確認是否刪除站點?',
    en: 'After deleting the station, all device numbers under the station will be synchronized to be taken off the shelf. The list cannot be searched and displayed. Please confirm whether to delete the station?',
    he: 'לאחר מחיקת אתר, כל מספרי המכשירים תחת האתר יוסרו באופן סינכרוני. לא ניתן לחפש ולהציג ברשימה. אנא אשר אם למחיק אתר?',
    de: 'Nachdem der Ladepunkt gelöscht wurde, werden alle Gerätenummern unter dem Ladepunkt synchronisiert entfernt. Die Liste kann nicht gesucht und angezeigt werden. Bitte bestätigen Sie, ob der Ladepunkt gelöscht werden soll?',
    es: 'Después de eliminar la estación de carga, todos los números de dispositivos bajo la estación se sincronizarán para ser retirados del mostrador. La lista no puede buscarse ni visualizarse después de la eliminación. ¿Desea eliminar la estación de carga?',
    ru: 'После удаления станции, все номера устройств под станцией будут синхронизироваться для снятия со продажи. Список не может быть поиском и показом. Пожалуйста, удалите станцию.',
    vi: 'Sau khi xóa trạm, tất cả các số thiết bị dưới trạm sẽ được đồng bộ để hạ kệ. Danh sách không thể tìm kiếm và hiển thị. Vui lòng xác nhận xóa trạm.',
  },

  totalElectricity: {
    zh_cn: '总电量',
    zhhant: '總電量',
    en: 'Total Electricity',
    he: 'Total Electricity',
    de: 'Total Electricity',
    es: 'Total Electricity',
    ru: 'Total Electricity',
    vi: 'Total Electricity',
  },
  totalServiceAmount: {
    zh_cn: '总服务费',
    zhhant: '總服務費',
    en: 'Total Service Amount',
    he: 'Total Service Amount',
    de: 'Total Service Amount',
    es: 'Total Service Amount',
    ru: 'Total Service Amount',
    vi: 'Total Service Amount',
  },
  totalElecAmount: {
    zh_cn: '总电费',
    zhhant: '總電費',
    en: 'Total Electric Amount',
    he: 'Total Electric Amount',
    de: 'Total Electric Amount',
    es: 'Total Electric Amount',
    ru: 'Total Electric Amount',
    vi: 'Total Electric Amount',
  },
  totalDiscountAmount: {
    zh_cn: '总优惠金额',
    zhhant: '總优惠金額',
    en: 'Total Discount Amount',
    he: 'Total Discount Amount',
    de: 'Total Discount Amount',
    es: 'Total Discount Amount',
    ru: 'Total Discount Amount',
    vi: 'Total Discount Amount',
  },
  totalFinalAmount: {
    zh_cn: '最终费用',
    zhhant: '最終费用',
    en: 'Total Final Amount',
    he: 'Total Final Amount',
    de: 'Total Final Amount',
    es: 'Total Final Amount',
    ru: 'Total Final Amount',
    vi: 'Total Final Amount',
  },
  totalChargeTime: {
    zh_cn: '总充电时间',
    zhhant: '總充电時間',
    en: 'Total Charge Time',
    he: 'Total Charge Time',
    de: 'Total Charge Time',
    es: 'Total Charge Time',
    ru: 'Total Charge Time',
    vi: 'Total Charge Time',
  },
  totalOrderNum: {
    zh_cn: '总订单数',
    zhhant: '總訂單數',
    en: 'Total Order Num',
    he: 'Total Order Num',
    de: 'Total Order Num',
    es: 'Total Order Num',
    ru: 'Total Order Num',
    vi: 'Total Order Num',
  },
}
